/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable */
import $ from 'jquery'
import moment from 'moment'
import Swal from 'sweetalert2'
import TimeAgo from 'react-timeago'
import { toast } from 'react-toastify'
import React, { Component } from 'react'
import axios from 'axios'
import { Col, Row, Button, Modal, Form } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor'
import ToolkitProvider from 'react-bootstrap-table2-toolkit' // ,{ Search }
import {
  Input,
  // DatePicker,
  // Steps,
  Divider,
  Select,
  Icon,
  // Switch,
  InputNumber,
  // Upload,
} from 'antd'
// import PlacesAutocomplete, {
//   geocodeByAddress,
//   getLatLng,
// } from "react-places-autocomplete";

import DueDiligenceForm from './DueDiligenceForm'
import ViewSchemeModal from '../11-schemes/ViewSchemeModal'
import { AddCapitalModal } from './AddCapitalModal.js'
import { LoanSchedule } from './LoanSchedule.js'
import { getLatestLoanForBeekeeper } from '../../../services/loanService'

// import { allBanks } from '../../../commonConfig';
const readCookie = require('../cookie.js').readCookie

var google_maps_url_regex = new RegExp(
  '^https:\/\/www.google.com\/maps\/place\/.*@(.*),(.*),'
)

const altMobileRegex = /^[0-9]*$/
const fullNameRegex = /^[a-zA-Z0-9()\/\s\.]+$/
// const MIN_DATE = "2000-01-01";
const { Option, OptGroup } = Select,
  months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  startYear = 2019

var dtToday = new Date()
var month = dtToday.getMonth() + 1
var day = dtToday.getDate()
var year = dtToday.getFullYear()
if (month < 10) month = '0' + month.toString()
if (day < 10) day = '0' + day.toString()
const maxDate = year + '-' + month + '-' + day

const INITIAL_DD_STATUS = {
  basic: {},
  businessInfo: {},
  eligibility: {},
  existingenterpriserelated: {},
  loanandfinancialinfo: {},
  stabilityAndBackground: {},
}

export default class SingleLeadMaturityStages extends Component {
  BPLAN_VERSION_REVISION_DATE = moment()
    .date(22)
    .month(5)
    .year(2022)
    .hours(20)
    .toDate()

  constructor(props) {
    super(props)
    // this.state={

    // }

    let scaleupLoanReqdOptions = [
      { value: '', label: 'Select' },
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' },
    ],
      modeOfAssessmentOptions = [
        { value: '', label: 'Select' },
        { value: 'Call', label: 'Call' },
        { value: 'Visit', label: 'Visit' },
      ],
      operationalOptions = [
        { value: '', label: 'Select' },
        { value: 'Operational', label: 'Operational' },
        { value: 'Not Operational', label: 'Not Operational' },
        { value: 'Halted', label: 'Halted' },
        { value: 'Pivoted', label: 'Pivoted' },
      ],
      businessHealthOptions = [
        { value: '', label: 'Select' },
        { value: 'Growing Revenue', label: 'Growing Revenue' },
        { value: 'Constant Revenue', label: 'Constant Revenue' },
        { value: 'Unstable Revenue', label: 'Unstable Revenue' },
        { value: 'Declining Revenue', label: 'Declining Revenue' },
        { value: 'Zero Revenue', label: 'Zero Revenue' },
      ]
    this.state = {
      latestLoanData: null,
      showFieldViewInvestment: false,
      selectedApplicationType: "loan", // "loan" | "self"
      showNewInvestmentModal: false,
      selectedStage: 'applied',
      newRecordType: '', // 'loan' or 'self'
      recordType: '',
      projectDetails: {},
      similarEnterpriseNumbers: [],
      currentIndex: null,
      creditScore: '',
      creditScoreDoc: null,
      profileCompletionError: null,
      profileCompletionErrorObj: null,
      interimDate: props.leadData?.leadMaturity?.enterpriseSetup?.createdOn,
      errorObj: {},
      aadharError: false,
      locError: '',
      verifyingIFSC: null,
      refreshingDueDiligenceForm: false,
      currentActiveStage: 'capitalFulfilled',
      lastCompletedStage: 'capitalFulfilled',
      mfis: [],
      stages: {
        dueDiligence: {
          dueDiligenceStatus: '',
          // questions: {
          //   guarantorDetails: [
          //     { index: 0, name: "", phone: "", relationship: "" },
          //     { index: 1, name: "", phone: "", relationship: "" },
          //   ],
          // },
          questions: INITIAL_DD_STATUS,
        },
        skillTrained: { skillTrainedStatus: '' },
        enterpriseTrained: { enterpriseTrainedStatus: '' },
        businessPlanReady: { businessPlanReadyStatus: '' },
        capitalFulfilled: {
          capitalFulfilledStatus: '',
          loanAmount: 0,
          selfInvestmentAmount: 0,
          grantAmount: 0,
        },
        enterpriseSetup: { enterpriseSetupStatus: '' },
        enterpriseSustainability: { enterpriseSustainabilityStatus: '' },
      },
      ddOnHoldReasons: [
        'Unresponsive (Not picking up)',
        'Unresponsive (Unable to connect/Switched off)',
        'Interested to start business after some time',
        'Applicant different from entrepreneur: Has no idea of the business',
        'Business Idea not finalized',
        'Less idea about why to start the business',
        'Business Idea requires license, but candidate does not have those',
        'Need more time to know the exact location to start the business',
        'Need more time to identify target customers',
        'Need more time to estimate monthly sales and costs',
        'Need more time to find nearby competitive businesses',
        'Need more time to find the place to buy goods/machines/raw materials',
        'Previous loan taken and ongoing',
        'Need more time to supply quotations corresponding to items purchased',
        'Candidate has no PAN',
        'Other Reason',
      ],
      bpOnHoldReasons: [
        'Unresponsive (Not picking up)',
        'Unresponsive (Unable to connect/Switched off)',
        'Submission of quotations shall take time',
        'Not keen to visit bank(s) at the moment',
        'Business location not finalized',
        'Business metrics (assumptions) not finalized',
        'Collateral/Security related documents pending',
        'Required license/rent deed/other key document pending',
        'Skill/EDP training pending',
        'Other Reason',
      ],

      quotationsColumns: [
        {
          text: 'Quotation / Documentation of',
          sort: true,
          hidden: false,
          export: true,
          dataField: 'quotationOf',
          searchable: true,
          formatter: this.formatEditInputs.bind(this, 'quotationOf'),
        },
        {
          text: 'File Type',
          sort: true,
          hidden: false,
          export: true,
          dataField: 'fileType',
          searchable: true,
          headerStyle: () => {
            return { width: '130px' }
          },
          formatter: this.formatEditInputs.bind(this, 'fileType'),
        },
        {
          text: 'File(s) Uploaded',
          sort: true,
          hidden: false,
          export: true,
          dataField: 'files',
          searchable: false,
          headerStyle: () => {
            return { width: '150px' }
          },
          formatter: this.formatEditInputs.bind(this, 'files'),
        },
        {
          text: 'EDIT/DELETE',
          sort: false,
          hidden: false,
          export: false,
          searchable: false,
          align: 'center',
          headerStyle: () => {
            return { width: '100px', textAlign: 'center' }
          },
          dataField: 'edit',
          formatter: this.formatEditDelete,
        },
      ],
      selfOrGrantColumns: [
        {
          text: 'Sl. No.',
          sort: true,
          hidden: false,
          export: true,
          searchable: false,
          headerStyle: () => {
            return { width: '55px' }
          },
          formatter: (value, row, index) => {
            // Return the row index (index + 1 for 1-based index)
            return index + 1
          }, //just return the index for now
        },
        {
          text: 'Record',
          sort: true,
          hidden: false,
          export: true,
          searchable: true,
          headerStyle: () => {
            return { width: '100px' }
          },
          formatter: (cell, row, rowIndex, formatExtraData) => {
            return (
              <span>
                {row.recordType === 'grant' ? 'Grant' : 'Self Investment'}
              </span>
            )
          },
        },
        {
          text: 'Amount',
          sort: true,
          hidden: false,
          export: true,
          searchable: true,
          headerStyle: () => {
            return { width: '100px' }
          },
          formatter: (cell, row, rowIndex, formatExtraData) => {
            return (
              //if .recordType is grant, then show grantAmount, else show selfInvestmentAmount
              <span>
                {this.state.recordType === 'grant'
                  ? row.grantAmount
                  : row.selfInvestmentAmount}
              </span>
            )
          },
        },
        {
          text: 'Status',
          sort: true,
          hidden: false,
          export: true,
          dataField: 'status',
          searchable: true,
          headerStyle: () => {
            return { width: '75px' }
          },
          formatter: this.formatEditInputs.bind(this, 'status'),
        },
        {
          text: 'Date Added On',
          sort: true,
          hidden: false,
          export: true,
          dataField: 'dateOfApplication',
          searchable: true,
          headerStyle: () => {
            return { width: '140px' }
          },
          formatter: this.formatEditInputs.bind(this, 'dateOfApplication'),
        },
        {
          text: 'Edit',
          sort: false,
          hidden: ['sidbi'].includes(JSON.parse(readCookie('userData')).type),
          export: false,
          searchable: false,
          align: 'center',
          headerStyle: () => {
            return { width: '70px', textAlign: 'center' }
          },
          dataField: 'edit',
          formatter: this.formatEdit,
        },
        {
          text: 'Delete',
          sort: false,
          hidden: !(
            JSON.parse(readCookie('userData')).userType.name ===
            'Project Management Unit'
          ),
          export: false,
          searchable: false,
          align: 'center',
          headerStyle: () => {
            return { width: '100px', textAlign: 'center' }
          },
          dataField: 'delete',
          formatter: this.formatDelete,
        },
      ],

      loanApplicationColumns: [
        {
          text: 'Sl. No.',
          sort: true,
          hidden: false,
          export: true,
          searchable: false,
          headerStyle: () => {
            return { width: '55px' }
          },
          formatter: (value, row, index) => {
            // Return the row index (index + 1 for 1-based index)
            return index + 1
          }, //just return the index for now
        },
        // {
        //   text: "Scheme",
        //   sort: true,
        //   hidden: false,
        //   export: true,
        //   dataField: "scheme",
        //   searchable: true,
        //   headerStyle: () => {
        //     return { width: "240px" };
        //   },
        //   formatter: this.formatEditInputs.bind(this, "scheme"),
        // },
        {
          text: 'Branch IFSC',
          sort: true,
          hidden: false,
          export: true,
          dataField: 'branchIFSC',
          searchable: true,
          headerStyle: () => {
            return { width: '100px' }
          },
          formatter: this.formatEditInputs.bind(this, 'branchIFSC'),
        },
        {
          text: 'Status',
          sort: true,
          hidden: false,
          export: true,
          dataField: 'status',
          searchable: true,
          headerStyle: () => {
            return { width: '75px' }
          },
          formatter: this.formatEditInputs.bind(this, 'status'),
        },
        {
          text: 'MFI Name',
          sort: true,
          hidden: false,
          export: true,
          dataField: 'mfiName',
          searchable: true,
          headerStyle: () => {
            return { width: '75px' }
          },
          // formatter: this.formatEditInputs.bind(this, "status"),
        },
        {
          text: 'Date of Application',
          sort: true,
          hidden: false,
          export: true,
          dataField: 'dateOfApplication',
          searchable: true,
          headerStyle: () => {
            return { width: '140px' }
          },
          formatter: this.formatEditInputs.bind(this, 'dateOfApplication'),
        },
        {
          text: 'Application Details',
          sort: true,
          hidden: false,
          export: true,
          dataField: 'importantInfo',
          searchable: true,
          headerStyle: () => {
            return { width: '200px' }
          },
          formatter: this.formatEditInputs.bind(this, 'importantInfo'),
        },
        {
          text: 'Proof Of Application',
          sort: true,
          hidden: false,
          export: true,
          dataField: 'files',
          searchable: false,
          headerStyle: () => {
            return { width: '160px' }
          },
          formatter: this.formatEditInputs.bind(this, 'files'),
        },
        {
          text: 'Date of Sanction',
          sort: true,
          hidden: false,
          export: true,
          dataField: 'dateOfSanction',
          searchable: true,
          headerStyle: () => {
            return { width: '120px' }
          },
          formatter: this.formatEditInputs.bind(this, 'dateOfSanction'),
        },
        {
          text: 'Proof Of Sanction',
          sort: true,
          hidden: false,
          export: true,
          dataField: 'proofOfSanction',
          searchable: false,
          headerStyle: () => {
            return { width: '150px' }
          },
          formatter: this.formatEditInputs.bind(this, 'proofOfSanction'),
        },
        {
          text: 'Date of Disbursement',
          sort: true,
          hidden: false,
          export: true,
          dataField: 'dateOfDisbursement',
          searchable: true,
          headerStyle: () => {
            return { width: '150px' }
          },
          formatter: this.formatEditInputs.bind(this, 'dateOfDisbursement'),
        },
        {
          text: 'Disbursement Sum',
          sort: true,
          hidden: false,
          export: true,
          dataField: 'disbursedAmount',
          searchable: false,
          align: 'center',
          headerStyle: () => {
            return { width: '120px' }
          },
          formatter: this.formatEditInputs.bind(this, 'disbursedAmount'),
        },
        {
          text: 'Disbursement Interest Percentage',
          sort: true,
          hidden: false,
          export: true,
          align: 'center',
          dataField: 'disbursedInterestPercentage',
          searchable: false,
          headerStyle: () => {
            return { width: '120px' }
          },
          formatter: this.formatEditInputs.bind(
            this,
            'disbursedInterestPercentage'
          ),
        },
        {
          text: 'Proof Of Disbursement',
          sort: true,
          hidden: false,
          export: true,
          dataField: 'proofOfDisbursement',
          searchable: false,
          headerStyle: () => {
            return { width: '170px' }
          },
          formatter: this.formatEditInputs.bind(this, 'proofOfDisbursement'),
        },
        {
          text: 'Date of Rejection',
          sort: true,
          hidden: false,
          export: true,
          dataField: 'dateOfRejection',
          searchable: true,
          headerStyle: () => {
            return { width: '130px' }
          },
          formatter: this.formatEditInputs.bind(this, 'dateOfRejection'),
        },
        {
          text: 'Edit',
          sort: false,
          hidden: ['sidbi'].includes(JSON.parse(readCookie('userData')).type),
          export: false,
          searchable: false,
          align: 'center',
          headerStyle: () => {
            return { width: '70px', textAlign: 'center' }
          },
          dataField: 'edit',
          formatter: this.formatEdit,
        },
        {
          text: 'Delete',
          sort: false,
          hidden: !(
            JSON.parse(readCookie('userData')).userType.name ===
            'Project Management Unit'
          ),
          export: false,
          searchable: false,
          align: 'center',
          headerStyle: () => {
            return { width: '100px', textAlign: 'center' }
          },
          dataField: 'delete',
          formatter: this.formatDelete,
        },
      ],
      enterpriseSustainabilityCheckInColumns: [
        {
          headerFormatter: () => (
            <div className="position-relative is-imp">Date of check-in</div>
          ),
          dataField: 'checkInDate',
          headerStyle: () => {
            return { width: '140px' }
          },
          formatter: d => (d ? moment(d).format('DD/MM/YYYY') : d),
          editorRenderer: (props, val, row, col, rowI, colI) => (
            <input
              type="date"
              onKeyDown={e => e.preventDefault()}
              className="form-control"
              {...props}
              onBlur={e => props.onUpdate(e.target.value)}
              max={moment().format('YYYY-MM-DD')}
              defaultValue={val}
            />
          ),
        },
        {
          text: 'Assessed By',
          dataField: 'assessedBy',
          headerStyle: () => {
            return { width: '130px' }
          },
          editable: false,
          formatter: this.formatCheckInAssessee,
        },
        {
          headerFormatter: () => (
            <div className="position-relative is-imp">Mode of Assessment</div>
          ),
          dataField: 'modeOfAssessment',
          headerStyle: () => {
            return { width: '130px' }
          },
          editor: { type: Type.SELECT, options: modeOfAssessmentOptions },
        },
        {
          headerFormatter: () => (
            <div className="position-relative is-imp">Still Operational</div>
          ),
          dataField: 'operational',
          headerStyle: () => {
            return { width: '130px' }
          },
          editor: { type: Type.SELECT, options: operationalOptions },
        },
        {
          headerFormatter: () => (
            <div className="position-relative is-imp">
              Daily Income (Profit) INR
            </div>
          ),
          dataField: 'dailyProfit',
          headerStyle: () => {
            return { width: '120px' }
          },
          editorRenderer: (props, val, row, col, rowI, colI) => (
            <InputNumber
              {...props}
              onBlur={e => props.onUpdate(e.target.value)}
              min={0}
              defaultValue={val}
            />
          ),
        },
        {
          text: 'Monthly Income (Profit) INR',
          dataField: 'dailyProfit',
          headerStyle: () => {
            return { width: '120px' }
          },
          editable: false,
          formatter: (cell, row) =>
            row.dailyProfit && parseInt(row.dailyProfit)
              ? 30 * parseInt(row.dailyProfit)
              : '',
        },
        {
          text: 'Credit Score',
          dataField: 'creditScore',
          headerStyle: () => {
            return { width: '120px' }
          },
          editorRenderer: (props, val, row, col, rowI, colI) => (
            <InputNumber
              {...props}
              onBlur={e => props.onUpdate(e.target.value)}
              min={0}
              defaultValue={val}
            />
          ),
        },
        {
          text: 'Credit Score Document',
          dataField: 'creditScoreDoc',
          headerStyle: () => {
            return { width: '140px' }
          },
          formatter: cell =>
            cell ? (
              <Button onClick={() => window.open(cell, '_blank')}>
                {' '}
                See Document
              </Button>
            ) : null,
          editorRenderer: (props, val, row, col, rowI, colI) => (
            <>
              {!val ? (
                <Form.Group
                  controlId="formFile"
                  className="mb-3"
                  disabled={!this.props.isEditable}
                  onChange={e =>
                    this.setState({
                      creditScoreDoc: e.target.files[0],
                      currentIndex: rowI,
                    })
                  }
                  onBlur={
                    this.state.creditScoreDoc && this.checkAndUpdateCheckIns
                  }
                >
                  <Form.Control type="file" />
                </Form.Group>
              ) : (
                <Button onClick={() => window.open(val, '_blank')}>
                  See Document
                </Button>
              )}
            </>
          ),
        },
        {
          headerFormatter: () => (
            <div className="position-relative is-imp">Business Health</div>
          ),
          dataField: 'businessHealth',
          headerStyle: () => {
            return { width: '150px' }
          },
          editor: { type: Type.SELECT, options: businessHealthOptions },
        },
        {
          headerFormatter: () => (
            <div className="position-relative is-imp">
              Jobs Created (Including Self)
            </div>
          ),
          dataField: 'jobsCreated',
          headerStyle: () => {
            return { width: '120px' }
          },
          editorRenderer: (props, val, row, col, rowI, colI) => (
            <InputNumber
              {...props}
              onBlur={e => props.onUpdate(e.target.value)}
              min={1}
              defaultValue={val}
            />
          ),
        },
        {
          text: 'Any new developments',
          dataField: 'developments',
          headerStyle: () => {
            return { width: '160px' }
          },
          editor: { type: Type.TEXTAREA },
        },
        {
          headerFormatter: () => (
            <div className="position-relative is-imp">Wants scale-up loan</div>
          ),
          dataField: 'scaleupLoanReqd',
          headerStyle: () => {
            return { width: '125px' }
          },
          editor: { type: Type.SELECT, options: scaleupLoanReqdOptions },
        },
        {
          text: 'Required Loan Value (INR)',
          dataField: 'reqdLoanValue',
          headerStyle: () => {
            return { width: '130px' }
          },
          editable: (cell, row, rowIndex, colIndex) =>
            row.scaleupLoanReqd === 'Yes' ? true : false,
          editorRenderer: (props, val, row, col, rowI, colI) => (
            <InputNumber
              {...props}
              onBlur={e => props.onUpdate(e.target.value)}
              min={0}
              defaultValue={val}
            />
          ),
        },
        {
          text: 'Insights / Comments',
          dataField: 'comments',
          searchable: true,
          headerStyle: () => {
            return { width: '200px' }
          },
          editor: { type: Type.TEXTAREA },
        },
        {
          text: 'Delete',
          dataField: 'index',
          headerStyle: () => {
            return { width: '50px' }
          },
          editable: false,
          formatter: this.formatDeleteCheckIn,
        },
      ],

      loanApplicationSchemes: [
        'General MSME Loan (FD backed)',
        'Collateralized MSME Loan',
        'General MSME Loan (Guarantor backed)',
        'SBI e-Mudra',
        'Prime Minister Mudra Yojana (PMMY)',
        'NABARD Scheme',
        'NULM',
        'NRLM',
        'PMEGP (DIC/KVIC)',
        'CMEGP',
        'Gram Udyog Vikas Yojna',
        'Divyangjan Swavalamban Yojana',
        'State SC/ST/OBC Subsidy Scheme',
        'Minority Welfare Scheme',
        'Other',
      ],
      allBanks: [],
      // [
      //   "//Allahabad Bank",
      //   "Andhra Bank",
      //   "Andhra Pradesh Grameena Vikas Bank",
      //   "Aryavart Bank",
      //   "Axis Bank",
      //   "Bandhan Bank",
      //   "Bank of Bahrain and Kuwait",
      //   "Bank of Baroda",
      //   "Bank of India",
      //   "Bank of Maharashtra",
      //   "Baroda Uttar Pradesh Gramin Bank",
      //   "Bhadradri Bank",
      //   "Canara Bank",
      //   "Central Bank of India",
      //   "City Union Bank",
      //   "Corporation Bank",
      //   "Dakshin Bihar Gramin Bank",
      //   "Dena Bank",
      //   "Deutsche Bank",
      //   "Development Credit Bank",
      //   "Dhanlaxmi Bank",
      //   "Federal Bank",
      //   "Fino Payments Bank",
      //   "Gramin Bank",
      //   "HDFC Bank",
      //   "ICICI Bank",
      //   "IDBI Bank",
      //   "Indian Bank",
      //   "Indian Post Payments Bank",
      //   "Indian Overseas Bank",
      //   "IndusInd Bank",
      //   "ING Vysya Bank",
      //   "Jammu and Kashmir Bank",
      //   "Karnataka Bank Ltd",
      //   "Karur Vysya Bank",
      //   "Kashi Gomti Samyut Gramin Bank",
      //   "Kotak Bank",
      //   "Laxmi Vilas Bank",
      //   "Oriental Bank of Commerce",
      //   "Prathama Bank",
      //   "Punjab National Bank - Corporate Banking",
      //   "Punjab National Bank - Retail Banking",
      //   "Punjab &amp; Sind Bank",
      //   "RBL Bank",
      //   "Shamrao Vitthal Co-operative Bank",
      //   "South Indian Bank",
      //   "State Bank of Bikaner &amp; Jaipur",
      //   "State Bank of Hyderabad",
      //   "State Bank of India",
      //   "State Bank of Mysore",
      //   "State Bank of Patiala",
      //   "State Bank of Travancore",
      //   "Syndicate Bank",
      //   "Tamilnad Mercantile Bank Ltd.",
      //   "UCO Bank",
      //   "Union Bank of India",
      //   "United Bank of India",
      //   "Uttar Bihar Gramin Bank",
      //   "Vijaya Bank",
      //   "Yes Bank Ltd",
      // ],
      certificateOfShopAndEstablishmentActFile: null,
      uploadingLoanApplicationFiles: false,
      udyogAadharCertificateFile: null,
      pastingLinkToBusinessPlan: false,
      uploadingBusinessPlanFile: null,
      showQuotationUploadFiles: false,
      uploadingQuotationFiles: false,
      editingLoanApplication: null,
      uploadingBusinessPlan: false,
      newFilesLoanApplication: {},
      editingQuotationIndex: null,
      showBusinessPlanEdit: false,
      showLoanUploadFiles: false,
      nonRecommendedSchemes: [],
      recommendedSchemeIds: null,
      gstCertificateFile: null,
      newFilesQuotation: null,
      otherLicensesFile: null,
      editingQuotation: null,
      linkToBusinessPlan: '',
      recommendedSchemes: [],
      otherImageFiles: [],
      viewScheme: null,
      loaded: false,
      financialProductList: [],
      editFinancialProduct: []
    }
  }

  getSimilarEnterpriseNumbers = () => {
    fetch(
      process.env.REACT_APP_API_URL +
      `/api/v1/lead-maturity/similar-lead-numbers/${this.props.leadId}`,
      {
        method: 'GET',
        headers: {
          'x-auth-token': JSON.parse(readCookie('access_token')),
        },
      }
    )
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          let { similarEnterpriseNumbers = [] } = data
          this.setState({ similarEnterpriseNumbers })
        }
      })
  }
  fetchFinancialProject = () => {
    fetch(`${process.env.REACT_APP_API_URL}/api/v1/humblebee/financial-product`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${JSON.parse(readCookie('access_token'))}`,
      },
    })
      .then(response => response.json())
      .then(data => {

        // API returns an array — normalize to products array
        const products = Array.isArray(data) ? data : data?.data || [];

        // Filter products where product._id === this.props.leadId
        const matchedProducts = products.filter(
          p => String(p._id) === String(this.props.leadId)
        );

        console.log('matched product objects:', JSON.stringify(matchedProducts));

        console.log("All products count:", products.length, "Matched:", matchedProducts.length);



        console.log("Financial-product Data: ", data);

        this.setState({ financialProductList: data })
      })
      .catch(error => {
        console.error(error, 'Error fetching projects');
      });
  };

  getAllMFIs = () => {
    fetch(process.env.REACT_APP_API_URL + '/api/v1/mfi', {
      method: 'GET',
      headers: {
        'x-auth-token': JSON.parse(readCookie('access_token')),
      },
    })
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          let mfis = data.mfis
          this.setState({ mfis })
        }
      })
  }

  fetchProjectDetails = () => {
    fetch(process.env.REACT_APP_API_URL + '/api/v1/project/project-details', {
      method: 'GET',
      headers: {
        'x-auth-token': JSON.parse(readCookie('access_token')),
      },
    })
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          const { projectDetails = {} } = data
          this.setState({ projectDetails })
        }
      })
  }
  fetchBeekeeperIdByMobile = async (mobileNumber) => {
    try {
      const token = JSON.parse(readCookie('access_token'));
      const config = {
        headers: {
          source: 'humblebee_admin',
          authorization: 'Bearer ' + token,
        },
      };
      const res = await axios.get(
        `${process.env.REACT_APP_API_APP_USER_URL}/user/getAllSurveyedUsers?limit=2000&role=trainee_beekeeper`,
        config
      );

      console.log("Response from fetchBeekeeperIdByMobile:", res.data?.userInfo);

      if (res.data && res.data.userInfo) {
        const user = res.data.userInfo.find((item) => {
          // Check all possible locations for mobile number
          const m1 = item.userInfo?.mobileNumber?.toString();
          const m2 = item.mobileNumber?.toString();
          const m3 = item.surveyData?.mobile_number?.toString();
          const target = mobileNumber?.toString();
          return m1 === target || m2 === target || m3 === target;
        });

        if (user) {
          // Check all possible locations for the ID
          const id = user.fieldViewData?.[0]?.le_app_user_id ||
            user.userInfo?._id ||
            user._id;
          console.log("Found Beekeeper ID:", id, "for mobile:", mobileNumber);
          return id;
        }
      }
      return null;
    } catch (error) {
      console.error("Error fetching beekeeper ID by mobile:", error);
      return null;
    }
  };

  componentDidMount = async () => {
    // this.fetchLeadMaturityData(true);
    // this.fetchProjectDetails();
    this.getAllBanks()
    this.getAllMFIs()
    this.getSimilarEnterpriseNumbers()
    this.fetchFinancialProject()

    console.log("Lead ID:", this.props.leadId);
    console.log("fieldViewId prop:", this.props.fieldViewId);

    // For advance profiles: Use fieldViewId prop (which is fieldViewData[0]._id from Leads.js)
    const beekeeperId = this.props.fieldViewId;

    console.log("Beekeeper ID (from fieldViewId prop):", beekeeperId);

    if (beekeeperId) {
      console.log("Advance profile detected - calling loan API with beekeeperId:", beekeeperId);
      getLatestLoanForBeekeeper(beekeeperId)
        .then(data => {
          console.log('Latest Loan Data in SingleLeadMaturityStages:', data)
          console.log('Latest Loan Data in JSON stringfy:', data ? JSON.stringify(data) : 'null')
          // store latest loan data in state so the UI can render it
          if (data) {
            // Set selectedStage based on current loan status
            const currentStatus = data.loanStatus || data.status;
            this.setState({
              latestLoanData: data,
              selectedStage: currentStatus || 'applied'
            });
          }
        })
        .catch(err => console.error('Latest Loan Error in SingleLeadMaturityStages:', err));
    } else {
      console.log("Not an advance profile (no fieldViewId) - skipping loan API call");
    }
    // this.checkProfileCompletionErrors();
  }
  removeSupportingDocument = type => {
    // let editingImages = this.state.stages.enterpriseSetup.otherImageUrls;

    Swal.fire({
      title: 'Are you sure?',
      html: 'This file will be deleted permanently',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Yes, Delete',
      confirmButtonAriaLabel: 'Yes, Delete',
      cancelButtonText: 'No, Cancel',
      cancelButtonAriaLabel: 'No, Cancel',
    }).then(result => {
      if (result.value) {
        fetch(
          process.env.REACT_APP_API_URL +
          '/api/v1/lead-maturity/remove-doc/' +
          this.props.leadId +
          `/${type}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'x-auth-token': JSON.parse(readCookie('access_token')),
            },
          }
        )
          .then(data => data.json())
          .then(data => {
            if (data.status) {
              this.setState({
                stages: {
                  ...this.state.stages,
                  enterpriseSetup: {
                    ...this.state.stages.enterpriseSetup,
                    [type]: '',
                  },
                },
              })
            } else {
              this.notifyError(data.errorMsg)
            }
          })
      }
    })
  }
  getAllBanks = () => {
    fetch(process.env.REACT_APP_API_URL + '/api/v1/bank-branches/banks', {
      method: 'GET',
      headers: {
        'x-auth-token': JSON.parse(readCookie('access_token')),
      },
    })
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          this.setState({ allBanks: data.allBanks })
        }
      })
  }
  fetchLeadMaturityData = firstTime => {
    fetch(
      process.env.REACT_APP_API_URL +
      '/api/v1/lead-maturity/' +
      this.props.leadId +
      '?selectedProjectId=' +
      this.props.projectId || '',
      {
        method: 'GET',
        headers: {
          'x-auth-token': JSON.parse(readCookie('access_token')),
        },
      }
    )
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          let // loanApplicationSpecialColumns = [],
            //   loanApplicationColumns = this.state.loanApplicationColumns,
            currentActiveStage = 'dueDiligence',
            lastCompletedStage = 'dueDiligence'
          // if(data.stages.capitalFulfilled.capitalFulfilledStatus === 'Sanctioned') {
          // 	loanApplicationSpecialColumns.push({ text: 'Date of Sanction', sort: true, hidden: false, export: true, dataField: 'dateOfSanction', searchable: true, headerStyle: () => {return {width: '120px'}}, formatter: this.formatEditInputs.bind(this, 'dateOfSanction') });
          // }
          // if(data.stages.capitalFulfilled.capitalFulfilledStatus === 'Disbursed') {
          // 	loanApplicationSpecialColumns.push({ text: 'Date of Disbursement', sort: true, hidden: false, export: true, dataField: 'dateOfDisbursement', searchable: true, headerStyle: () => {return {width: '120px'}}, formatter: this.formatEditInputs.bind(this, 'dateOfDisbursement') });
          // }
          // if(data.stages.capitalFulfilled.capitalFulfilledStatus === 'Rejected') {
          // 	loanApplicationSpecialColumns.push({ text: 'Date of Rejection', sort: true, hidden: false, export: true, dataField: 'dateOfRejection', searchable: true, headerStyle: () => {return {width: '120px'}}, formatter: this.formatEditInputs.bind(this, 'dateOfRejection') });
          // }
          // loanApplicationColumns.splice(3, 0, ...loanApplicationSpecialColumns);
          data.stages.dueDiligence.questions = {
            ...this.state.stages.dueDiligence.questions,
            ...data.stages.dueDiligence.questions,
          }
          if (firstTime) {
            if (
              (data.stages.enterpriseSetup.enterpriseSetupStatus ===
                'Started up' ||
                data.stages.enterpriseSetup.enterpriseSetupStatus ===
                'Scaled up') &&
              (data.stages.capitalFulfilled.capitalFulfilledStatus ===
                'Disbursed' ||
                data.stages.capitalFulfilled.capitalFulfilledStatus ===
                'Not required') &&
              data.stages.businessPlanReady.businessPlanReadyStatus ===
              'Completed' &&
              data.stages.dueDiligence.dueDiligenceStatus === 'Completed'
            )
              lastCompletedStage = 'enterpriseSustainability'
            else if (
              (data.stages.capitalFulfilled.capitalFulfilledStatus ===
                'Disbursed' ||
                data.stages.capitalFulfilled.capitalFulfilledStatus ===
                'Not required' ||
                (this.props.leadData.enterpriseStatus.financeType ===
                  '100% self-financed' &&
                  !this.props.leadData.enterpriseStatus.loanAmountRequired)) &&
              data.stages.businessPlanReady.businessPlanReadyStatus ===
              'Completed' &&
              data.stages.dueDiligence.dueDiligenceStatus === 'Completed'
            )
              lastCompletedStage = 'enterpriseSetup'
            else if (
              data.stages.businessPlanReady.businessPlanReadyStatus ===
              'Completed' &&
              data.stages.dueDiligence.dueDiligenceStatus === 'Completed'
            )
              lastCompletedStage = 'capitalFulfilled'
            else if (
              data.stages.dueDiligence.dueDiligenceStatus === 'Completed'
            )
              lastCompletedStage = 'businessPlanReady'
            currentActiveStage = lastCompletedStage
            if (['sidbi'].includes(JSON.parse(readCookie('userData')).type)) {
              if (
                [
                  'enterpriseSustainability',
                  'enterpriseSetup',
                  'capitalFulfilled',
                ].includes(lastCompletedStage)
              )
                currentActiveStage = 'capitalFulfilled'
              lastCompletedStage = 'capitalFulfilled'
            } else if (
              JSON.parse(readCookie('userData')).accountType === 'saarthi'
            ) {
              if (
                ['enterpriseSustainability', 'enterpriseSetup'].includes(
                  lastCompletedStage
                ) &&
                ['', 'enterpriseSetup'].includes(
                  JSON.parse(readCookie('userData')).saarthiAccess
                )
              )
                currentActiveStage = 'enterpriseSetup'
              else if (
                [
                  'enterpriseSustainability',
                  'enterpriseSetup',
                  'capitalFulfilled',
                ].includes(lastCompletedStage) &&
                ['', 'capitalFulfilled'].includes(
                  JSON.parse(readCookie('userData')).saarthiAccess
                )
              )
                currentActiveStage = 'capitalFulfilled'
              else if (
                [
                  'enterpriseSustainability',
                  'enterpriseSetup',
                  'capitalFulfilled',
                  'businessPlanReady',
                ].includes(lastCompletedStage) &&
                ['', 'businessPlanReady'].includes(
                  JSON.parse(readCookie('userData')).saarthiAccess
                )
              )
                currentActiveStage = 'businessPlanReady'
              lastCompletedStage = currentActiveStage
            }
            this.setState({ currentActiveStage, lastCompletedStage })
          }
          this.setState({ stages: data.stages, loaded: true })
        } else if (firstTime) {
          console.error(data.errorMsg)
          this.notifyError(data.errorMsg)
        }
      })
  }

  changeCurrentActiveStage = stage => {
    if (stage === 'capitalFulfilled') {
      if (
        JSON.parse(readCookie('userData')).accountType !== 'saarthi' ||
        (JSON.parse(readCookie('userData')).accountType === 'saarthi' &&
          ['', 'capitalFulfilled'].includes(
            JSON.parse(readCookie('userData')).saarthiAccess
          ))
      ) {
        this.setState({ currentActiveStage: stage })
      } else this.notifyError('You do not have the access to edit this stage!')
    } else if (stage === 'enterpriseSetup') {
      if (JSON.parse(readCookie('userData')).accountType !== 'saarthi') {
        this.setState({ currentActiveStage: stage })
      } else this.notifyError('You do not have the access to edit this stage!')
    } else this.notifyError('Please complete the previous steps!')
  }

  getCurrentUpdatedByObj = () => {
    let userData = JSON.parse(readCookie('userData'))
    return {
      _id: userData._id,
      fullName: userData.fullName,
      userType: {
        _id: userData.userType._id,
        customUrl: userData.userType.name.toLowerCase().replace(/ /g, '-'),
      },
    }
  }

  formatEdit = (cell, row, index) => {
    if (this.state.editingLoanApplication === null) {
      return (
        <button
          disabled={!this.props.isEditable}
          className="btn edit-loan-application-btn"
          onClick={this.editLoanApplication.bind(this, row)}
        >
          Edit
        </button>
      )
    } else return null
  }

  formatDelete = (cell, row, index) => {
    if (this.state.editingLoanApplication === null) {
      return (
        <button
          disabled={!this.props.isEditable}
          className="btn btn-danger edit-loan-application-btn"
          onClick={this.deleteLoanApplication.bind(this, row)}
        >
          Delete
        </button>
      )
    } else return null
  }

  formatEditDelete = (cell, row, index) => {
    if (this.state.editingQuotation === null) {
      return (
        <div className="edit-delete-buttons">
          <button
            className="btn edit-quotation-btn"
            title="Edit Quotation"
            disabled={!this.props.isEditable}
            onClick={this.editQuotation.bind(this, row, index)}
          >
            <i className="fa fa-pencil" />
          </button>
          <button
            disabled={!this.props.isEditable}
            className="btn delete-quotation-btn"
            title="Delete Quotation"
            onClick={this.deleteQuotation.bind(this, row, index)}
          >
            <i className="fa fa-times" />
          </button>
        </div>
      )
    } else return null
  }

  formatEditInputs = (type, cell, row, index) => {
    if (
      type === 'dateOfApplication' ||
      type === 'dateOfSanction' ||
      type === 'dateOfDisbursement' ||
      type === 'dateOfRejection'
    ) {
      if (cell) return moment(cell).format('DD/MM/YYYY')
      else return 'N/A'
    } else if (type === 'branchIFSC') {
      if (cell)
        return (
          <a
            href={'/bank-branches/' + cell}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'var(--themeColor)' }}
          >
            {cell}
          </a>
        )
    } else if (
      type === 'files' ||
      type === 'proofOfSanction' ||
      type === 'proofOfDisbursement'
    ) {
      if (cell) {
        return cell.map((file, index) => {
          if (index)
            return (
              <span key={index}>
                ,{' '}
                <a href={file} target="_blank" rel="noopener noreferrer">
                  {'File ' + (index + 1)}
                </a>
              </span>
            )
          else
            return (
              <span key={index}>
                <a href={file} rel="noopener noreferrer" target="_blank">
                  {'File ' + (index + 1)}
                </a>
              </span>
            )
        })
      } else return 'N/A'
    } else if (type === 'scheme') {
      if (
        row.schemeId &&
        this.state.recommendedSchemeIds &&
        this.state.recommendedSchemeIds.indexOf(row.schemeId) > -1
      )
        return cell
      else {
        return (
          <span className="scheme-title">
            {cell}
            <span className="non-recommended-tag" title="Not Recommended">
              NR
            </span>
          </span>
        )
      }
    } else if (type === 'disbursedAmount') {
      if (cell) return cell.toLocaleString()
      else return null
    } else if (type === 'disbursedInterestPercentage') {
      if (cell) return `${cell} %`
      else return null
    } else {
      if (cell) return cell
      else return null
    }
  }

  disabledDate = current => {
    return (
      current && moment().startOf('day') < moment(current).subtract(1, 'day')
    )
  }

  editQuotation = (row, index) => {
    this.setState({
      editingQuotation: { ...row },
      editingQuotationIndex: index,
    })
  }

  deleteQuotation = (row, index) => {
    let quotations =
      this.state.stages.businessPlanReady.quotationsObj.quotations,
      stages = this.state.stages
    Swal.fire({
      title: 'Are you sure?',
      html: 'This quotation will be deleted permanently',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Yes, Delete',
      confirmButtonAriaLabel: 'Yes, Delete',
      cancelButtonText: 'No, Cancel',
      cancelButtonAriaLabel: 'No, Cancel',
    }).then(result => {
      if (result.value) {
        quotations.splice(index, 1)
        fetch(
          process.env.REACT_APP_API_URL +
          '/api/v1/lead-maturity/' +
          this.props.leadId +
          '/businessPlanReady',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-auth-token': JSON.parse(readCookie('access_token')),
            },
            body: JSON.stringify({ quotations }),
          }
        )
          .then(data => data.json())
          .then(data => {
            if (data.status) {
              this.notifySuccess('Successfully deleted quotation')
              stages['businessPlanReady'] = data.businessPlanReady
              stages['businessPlanReady']['updatedBy'] =
                this.getCurrentUpdatedByObj()
              this.setState({ stages })
            } else {
              this.notifyError(data.errorMsg)
            }
          })
      }
    })
  }

  hideEditingQuotation = () => {
    this.setState({
      editingQuotation: null,
      uploadingQuotationFiles: false,
      newFilesQuotation: null,
      showQuotationUploadFiles: false,
      editingQuotationIndex: null,
    })
  }

  // Add this helper method to your component class
  getMatchedFinancialProduct = () => {
    const { financialProductList } = this.state;

    if (!financialProductList || financialProductList.length === 0) {
      return null;
    }

    // Filter products where product._id === this.props.leadId
    const matchedProducts = financialProductList.filter(
      p => String(p._id) === String(this.props.leadId)
    );

    return matchedProducts.length > 0 ? matchedProducts[0] : null;
  };

  // Helper to format tenure
  formatTenure = (months) => {
    if (!months) return 'N/A';
    if (months === 12) return '1 year';
    if (months % 12 === 0) return `${months / 12} years`;
    return `${months} months`;
  };

  // Helper to format repayment frequency
  formatRepaymentFrequency = (months) => {
    if (!months) return 'N/A';
    if (months === 1) return 'Monthly';
    if (months === 3) return 'Quarterly';
    if (months === 6) return 'Half-yearly';
    if (months === 12) return 'Yearly';
    return `Every ${months} months`;
  };

  renderNoInvestmentUI = () => {
    return (
      <div style={{ padding: "20px" }}>
        <div
          style={{
            fontSize: "22px",
            fontWeight: 600,
            marginBottom: "20px",
            color: "#555",
          }}
        >
          No Investment made yet
        </div>

        {/* <Button
          style={{
            backgroundColor: "#DF6F4F",
            color: "#fff",
            borderRadius: "6px",
            border: "none",
          }}
          // onClick={() => this.setState({ showNewInvestmentModal: true })}
          onClick={this.addNewLoanApplication}
        >
          Add New Record
        </Button> */}
      </div>
    );
  };


  // Replace the hardcoded Loan Scheme Info section with this:
  renderFinancialProductInfo = () => {
    const { latestLoanData } = this.state;

    // If we have latest loan data (from fieldView advanced profile), render that first
    if (latestLoanData) {
      const ld = latestLoanData;
      const disb = ld.disbursement || {};
      const transfer = ld.transferDetails || {};

      return (
        <div style={{ marginBottom: 25 }}>
          <div style={{ fontWeight: 600, color: "#DF6F4F" }}>
            Latest Loan: {ld.loanId || ld._id || 'Loan Details'}
          </div>

          <div style={{ marginTop: 8 }}>
            <div>
              Application Date: <b>{ld.dateOfApplication ? new Date(ld.dateOfApplication).toLocaleString() : '—'}</b>
            </div>
            <div>
              Mode of Application: <b>{ld.modeOfApplication || '—'}</b>
            </div>
            {ld.applicationDetails && (
              <div>
                Application Notes: <b>{ld.applicationDetails}</b>
              </div>
            )}

            <div style={{ marginTop: 8 }}>
              Amount Sanctioned: <b>₹ {ld.amountSanctioned ? Number(ld.amountSanctioned).toLocaleString() : (ld.amount ? Number(ld.amount).toLocaleString() : '—')}</b>
            </div>
            {ld.dateOfSanction && (
              <div>
                Date of Sanction: <b>{new Date(ld.dateOfSanction).toLocaleString()}</b>
              </div>
            )}

            {disb.date && (
              <div style={{ marginTop: 8 }}>
                <div>Date of Disbursement: <b>{new Date(disb.date).toLocaleString()}</b></div>
                <div>Amount Disbursed: <b>₹ {disb.amount ? Number(disb.amount).toLocaleString() : '—'}</b></div>
                <div>Mode of Transfer: <b>{disb.modeOfTransfer || disb.offlineMethod || disb.onlineMethod || '—'}</b></div>
                {disb.notes && <div>Notes: <b>{disb.notes}</b></div>}
                {disb.proofs && disb.proofs.length > 0 && (
                  <div style={{ marginTop: 6 }}>
                    Proofs:
                    <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
                      {disb.proofs.map((p, i) => (
                        <img key={i} src={p} alt={`proof-${i}`} width={80} />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {transfer.dateOfTransfer && (
              <div style={{ marginTop: 8 }}>
                <div>Transfer Date: <b>{new Date(transfer.dateOfTransfer).toLocaleString()}</b></div>
                <div>Amount Transferred: <b>₹ {transfer.amountTransferred ? Number(transfer.amountTransferred).toLocaleString() : (transfer.loanDisbursed ? Number(transfer.loanDisbursed).toLocaleString() : '—')}</b></div>
                <div>Self Investment: <b>₹ {transfer.selfInvestment ? Number(transfer.selfInvestment).toLocaleString() : '0'}</b></div>
                <div>Transfer Method: <b>{transfer.transferMethod || transfer.modeOfTransfer || '—'}</b></div>
                {transfer.transactionId && <div>Transaction ID: <b>{transfer.transactionId}</b></div>}
                {transfer.proofs && transfer.proofs.length > 0 && (
                  <div style={{ marginTop: 6 }}>
                    Transfer Proofs:
                    <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
                      {transfer.proofs.map((p, i) => (
                        <img key={i} src={p} alt={`transfer-proof-${i}`} width={80} />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* If the component has a fieldViewId (advanced profile), show investment-field option */}
            {this.props.fieldViewId && (
              <div style={{ marginTop: 12 }}>
                <button className="btn brand-color-background" onClick={() => this.setState({ showFieldViewInvestment: !this.state.showFieldViewInvestment })}>
                  {this.state.showFieldViewInvestment ? 'Hide Investment FieldView' : 'Show Investment FieldView'}
                </button>

                {this.state.showFieldViewInvestment && (
                  <div style={{ marginTop: 10, padding: 10, background: '#fafafa', borderRadius: 6 }}>
                    <div><b>FieldView Investment Details</b></div>
                    <div>Loan Status: <b>{ld.loanStatus || ld.status || '—'}</b></div>
                    <div>Loan ID: <b>{ld.loanId || ld._id}</b></div>
                    <div>Files Attached: <b>{Array.isArray(ld.files) ? ld.files.length : (ld.files ? 1 : 0)}</b></div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      );
    }

    // fallback to existing financial product display if no latest loan data
    const matchedProduct = this.getMatchedFinancialProduct();

    if (!matchedProduct) return null;

    const {
      uniqueID,
      breakdown,
      loanTerms,
      investmentRequired
    } = matchedProduct;

    return (
      <div style={{ marginBottom: 25 }}>
        <div style={{ fontWeight: 600, color: "#DF6F4F" }}>
          Loan Scheme: {uniqueID || 'Financial Product'}
        </div>

        <div style={{ marginTop: 4 }}>
          {breakdown?.loan && (
            <>
              Principal Amount: <b>₹ {breakdown.loan.toLocaleString()}</b>
              &nbsp;&nbsp;&nbsp;
            </>
          )}

          {loanTerms?.annualInterestRate && (
            <>
              Interest Rate: <b>@{loanTerms.annualInterestRate}% pa</b>
              &nbsp;&nbsp;&nbsp;
            </>
          )}

          {loanTerms?.tenureMonths && (
            <>
              Repayment plan: <b>{this.formatTenure(loanTerms.tenureMonths)}</b>
              &nbsp;&nbsp;&nbsp;
            </>
          )}

          {loanTerms?.repaymentFrequencyMonths && (
            <>
              Repayment frequency: <b>{this.formatRepaymentFrequency(loanTerms.repaymentFrequencyMonths)}</b>
              &nbsp;&nbsp;&nbsp;
            </>
          )}

          {loanTerms?.moratoriumMonths !== null && loanTerms?.moratoriumMonths !== undefined && (
            <>
              Moratorium: <b>{loanTerms.moratoriumMonths} months</b>
            </>
          )}

          {breakdown?.farmerSelfInvestment && (
            <div style={{ marginTop: 8 }}>
              Self Investment: <b>₹ {breakdown.farmerSelfInvestment.toLocaleString()}</b>
            </div>
          )}

          {investmentRequired && (
            <div style={{ marginTop: 8 }}>
              Total Investment Required: <b>₹ {investmentRequired.toLocaleString()}</b>
            </div>
          )}

          {loanTerms?.processingFeeValue && (
            <div style={{ marginTop: 8 }}>
              Processing Fee: <b>₹ {loanTerms.processingFeeValue.toLocaleString()}</b>
            </div>
          )}
        </div>
      </div>
    );
  };



  changeQuotationsStatus = status => {
    let stages = this.state.stages
    fetch(
      process.env.REACT_APP_API_URL +
      '/api/v1/lead-maturity/' +
      this.props.leadId +
      '/businessPlanReady',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': JSON.parse(readCookie('access_token')),
        },
        body: JSON.stringify({ quotationStatus: status }),
      }
    )
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          stages['businessPlanReady'] = data.businessPlanReady
          stages['businessPlanReady']['updatedBy'] =
            this.getCurrentUpdatedByObj()
          this.setState({ stages })
        } else {
          this.notifyError(data.errorMsg)
        }
      })
  }

  verifyIFSC = e => {
    let ifsc = e.target.value,
      errorObj = this.state.errorObj
    let banks = [this.state.editingLoanApplication.appliedToBank]
    if (ifsc) {
      this.setState({ verifyingIFSC: 'Verifying' })
      fetch(
        process.env.REACT_APP_API_URL +
        '/api/v1/bank-branches/verify-ifsc/' +
        ifsc,
        {
          method: 'GET',
          headers: {
            'x-auth-token': JSON.parse(readCookie('access_token')),
          },
        }
      )
        .then(data => data.json())
        .then(data => {
          if (data.status) {
            if (!data.bank || banks.indexOf(data.bank) === -1) {
              errorObj['bankIFSC'] = 'Please select the Bank with this IFSC'
              this.setState({ verifyingIFSC: 'Failed', errorObj })
            } else {
              delete errorObj['bankIFSC']
              this.setState({ verifyingIFSC: data.result, errorObj })
            }
          } else {
            errorObj['bankIFSC'] = data.errorMsg
            this.setState({ verifyingIFSC: data.result, errorObj })
          }
        })
        .catch(err => {
          errorObj['bankIFSC'] = 'Invalid Bank IFSC'
          this.setState({ verifyingIFSC: 'Failed', errorObj })
        })
    } else {
      delete errorObj['bankIFSC']
      this.setState({ verifyingIFSC: null, errorObj })
    }
  }

  saveEditingQuotation = () => {
    let editingQuotation = this.state.editingQuotation,
      stages = this.state.stages

    let error = ''
    if (!editingQuotation.quotationOf) {
      error = 'Please enter a valid value'
    } else if (
      editingQuotation.fileType !== 'Quotation' &&
      editingQuotation.fileType !== 'Other document'
    ) {
      error = 'Please select a correct file type'
    } else if (!editingQuotation.files || !editingQuotation.files.length) {
      error = 'Please select at least one file to upload'
    }
    if (!error) {
      let quotations = stages.businessPlanReady.quotationsObj.quotations
      if (this.state.editingQuotationIndex !== null)
        quotations[this.state.editingQuotationIndex] = editingQuotation
      else quotations[quotations.length] = editingQuotation
      fetch(
        process.env.REACT_APP_API_URL +
        '/api/v1/lead-maturity/' +
        this.props.leadId +
        '/businessPlanReady',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-auth-token': JSON.parse(readCookie('access_token')),
          },
          body: JSON.stringify({ quotations }),
        }
      )
        .then(data => data.json())
        .then(data => {
          if (data.status) {
            this.notifySuccess('Successfully updated quotations')
            stages['businessPlanReady'] = data.businessPlanReady
            stages['businessPlanReady']['updatedBy'] =
              this.getCurrentUpdatedByObj()
            this.setState({
              stages,
              editingQuotation: null,
              uploadingQuotationFiles: false,
              newFilesQuotation: null,
              showQuotationUploadFiles: false,
              editingQuotationIndex: null,
            })
          } else {
            this.notifyError(data.errorMsg)
          }
        })
    } else {
      this.notifyError(error)
    }
  }

  addNewQuotation = () => {
    let editingQuotation = { quotationOf: '', fileType: '', files: [] }
    this.setState({
      editingQuotation,
      showQuotationUploadFiles: false,
      newFilesQuotation: null,
    })
  }

  updateEditingQuotation = (type, value) => {
    let editingQuotation = this.state.editingQuotation

    if (value.target) value = value.target.value
    editingQuotation[type] = value
    this.setState({
      editingQuotation,
      showQuotationUploadFiles: false,
      newFilesQuotation: null,
    })
  }

  showQuotationUploadFiles = () => {
    this.setState({ showQuotationUploadFiles: true })
  }

  hideQuotationUploadFiles = () => {
    this.setState({ showQuotationUploadFiles: false, newFilesQuotation: null })
  }

  updateFilesQuotation = e => {
    let files = e.target.files
    this.setState({ newFilesQuotation: files })
  }

  verifyStory = () => {
    fetch(
      process.env.REACT_APP_API_URL +
      '/api/v1/lead-maturity/verify-story/' +
      this.props.leadId,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': JSON.parse(readCookie('access_token')),
        },
        //body: JSON.stringify({ quotations })
      }
    )
      .then(data => data.json())
      .then(data => {
        if (!data.error) {
          // this.state.stages.enterpriseSetup?.entrepreneurStoryVerification?.status
          this.notifySuccess('Entrepreneur story verified successfully!')
          this.setState({
            stages: {
              ...this.state.stages,
              enterpriseSetup: {
                ...this.state.stages.enterpriseSetup,
                entrepreneurStoryVerification: data.responseObj,
              },
            },
          })
        } else {
          this.notifyError(`Couldn't verify story!`)
        }
      })
  }

  deleteFileFromQuotation = index => {
    let editingQuotation = this.state.editingQuotation

    Swal.fire({
      title: 'Are you sure?',
      html: 'This file will be deleted permanently',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Yes, Delete',
      confirmButtonAriaLabel: 'Yes, Delete',
      cancelButtonText: 'No, Cancel',
      cancelButtonAriaLabel: 'No, Cancel',
    }).then(result => {
      if (result.value) {
        editingQuotation.files.splice(index, 1)
        this.setState({ editingQuotation })
      }
    })
  }
  deleteFileFromEnterpriseSetup = index => {
    let editingImages = this.state.stages.enterpriseSetup.otherImageUrls

    if (
      ['Started up', 'Scaled up'].indexOf(
        this.state.stages.enterpriseSetup.enterpriseSetupStatus
      ) &&
      editingImages.length === 1
    ) {
      Swal.fire({
        title: 'Are you sure?',
        html: 'Are you sure to continue? This action moves back the candidate to the previous stage as some fields are mandatory.',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Yes, Proceed',
        confirmButtonAriaLabel: 'Yes, Proceed',
        cancelButtonText: 'No, Cancel',
        cancelButtonAriaLabel: 'No, Cancel',
      }).then(result => {
        if (result.value) {
          this.onStatusChange('Not Started', true)
          Swal.fire({
            title: 'Are you sure?',
            html: 'This file will be deleted permanently',
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: 'Yes, Delete',
            confirmButtonAriaLabel: 'Yes, Delete',
            cancelButtonText: 'No, Cancel',
            cancelButtonAriaLabel: 'No, Cancel',
          }).then(result => {
            if (result.value) {
              editingImages.splice(index, 1)
              fetch(
                process.env.REACT_APP_API_URL +
                '/api/v1/lead-maturity/' +
                this.props.leadId +
                `?index=${index}`,
                {
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'x-auth-token': JSON.parse(readCookie('access_token')),
                  },
                  //body: JSON.stringify({ quotations })
                }
              )
                .then(data => data.json())
                .then(data => {
                  if (data.status) {
                    this.setState({
                      stages: {
                        ...this.state.stages,
                        enterpriseSetup: {
                          ...this.state.stages.enterpriseSetup,
                          otherImages: editingImages,
                        },
                      },
                    })
                  } else {
                    this.notifyError(data.errorMsg)
                  }
                })
            }
          })
        } else {
          this.notifySuccess('Changes were not saved!')
          return
        }
      })
    } else {
      Swal.fire({
        title: 'Are you sure?',
        html: 'This file will be deleted permanently',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Yes, Delete',
        confirmButtonAriaLabel: 'Yes, Delete',
        cancelButtonText: 'No, Cancel',
        cancelButtonAriaLabel: 'No, Cancel',
      }).then(result => {
        if (result.value) {
          editingImages.splice(index, 1)
          fetch(
            process.env.REACT_APP_API_URL +
            '/api/v1/lead-maturity/' +
            this.props.leadId +
            `?index=${index}`,
            {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': JSON.parse(readCookie('access_token')),
              },
              //body: JSON.stringify({ quotations })
            }
          )
            .then(data => data.json())
            .then(data => {
              if (data.status) {
                this.setState({
                  stages: {
                    ...this.state.stages,
                    enterpriseSetup: {
                      ...this.state.stages.enterpriseSetup,
                      otherImages: editingImages,
                    },
                  },
                })
              } else {
                this.notifyError(data.errorMsg)
              }
            })
        }
      })
    }
  }

  quotationUploadFiles = () => {
    let newFilesQuotation = this.state.newFilesQuotation,
      editingQuotation = this.state.editingQuotation

    let formData = new FormData()
    for (let x = 0; x < newFilesQuotation.length; x++) {
      formData.append('files', newFilesQuotation[x])
    }
    if (newFilesQuotation.length) {
      this.setState({ uploadingQuotationFiles: true })
      fetch(
        process.env.REACT_APP_API_URL +
        '/api/v1/lead-maturity/' +
        this.props.leadId +
        '/upload-files/quotations',
        {
          method: 'POST',
          headers: {
            'x-auth-token': JSON.parse(readCookie('access_token')),
          },
          body: formData,
        }
      )
        .then(data => data.json())
        .then(data => {
          if (data.status) {
            editingQuotation.files = [...editingQuotation.files, ...data.urls]
            this.notifySuccess('Successfully uploaded files')
            this.setState({
              editingQuotation,
              newFilesQuotation: null,
              showLoanUploadFiles: false,
              uploadingQuotationFiles: false,
            })
          } else {
            this.notifyError(data.errorMsg)
          }
        })
    }
  }

  editLoanApplication = row => {
    if (row.status === 'Disbursed' && row.disbursedAmount === undefined) {
      row.disbursedAmount = this.props.loanAmountRequired
    }
    this.setState({ editingLoanApplication: { ...row } })
  }
  deleteLoanApplication = row => {
    Swal.fire({
      title: 'Are you sure?',
      html: 'This row will be deleted permanently',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Yes, Delete',
      confirmButtonAriaLabel: 'Yes, Delete',
      cancelButtonText: 'No, Cancel',
      cancelButtonAriaLabel: 'No, Cancel',
    }).then(result => {
      if (result.value) {
        fetch(
          process.env.REACT_APP_API_URL +
          '/api/v1/lead-maturity/' +
          this.props.leadId +
          '/' +
          row._id,
          {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              'x-auth-token': JSON.parse(readCookie('access_token')),
            },
          }
        )
          .then(data => data.json())
          .then(data => {
            if (data.status) {
              console.log(data)
              let stages = this.state.stages
              stages.capitalFulfilled.loanApplicationDetails =
                data.loanApplicationDetails
              this.setState({ stages })
              this.notifySuccess(data.message)
            } else {
              this.notifyError(data.errorMsg)
            }
          })
      }
    })
  }
  hideEditingLoanApplication = () => {
    this.setState({
      editingLoanApplication: null,
      uploadingLoanApplicationFiles: false,
      newFilesLoanApplication: {},
      showLoanUploadFiles: false,
      errorObj: {},
    })
  }

  saveEditingLoanApplication = () => {
    let editingLoanApplication = this.state.editingLoanApplication,
      stages = this.state.stages
    let error = ''
    if (!this.state.editingLoanApplication.status) {
      error = 'Please select a correct Loan Application Status'
    } else if (!this.state.editingLoanApplication.dateOfApplication) {
      error = 'Please select a correct Date of Application'
    } else if (
      !this.state.editingLoanApplication.modeOfApplication &&
      this.state.editingLoanApplication.recordType === 'loan'
    ) {
      error = 'Please select a correct Mode of Application'
    } else if (!this.state.editingLoanApplication.importantInfo) {
      error = 'Please fill in the Application details'
    } else if (
      !this.state.editingLoanApplication.branchIFSC &&
      // this.state.editingLoanApplication.modeOfApplication === "Offline" &&
      this.state.editingLoanApplication.appliedToBank
    ) {
      error = 'Please enter a correct Branch IFSC'
    } else if (this.state.errorObj.bankIFSC) {
      error = this.state.errorObj.bankIFSC
    } else if (
      this.state.editingLoanApplication.status === 'Rejected' &&
      !this.state.editingLoanApplication.dateOfRejection
    ) {
      error = 'Please select a correct Date of Rejection'
    } else if (this.state.editingLoanApplication.status === 'Sanctioned') {
      if (!this.state.editingLoanApplication.dateOfSanction)
        error = 'Please select a correct Date of Sanction'
      else if (!this.state.editingLoanApplication.proofOfSanction.length)
        error = 'Please upload the Proof of Sanction'
    } else if (this.state.editingLoanApplication.status === 'Disbursed') {
      if (!this.state.editingLoanApplication.dateOfSanction)
        error = 'Please select a correct Date of Sanction'
      else if (!this.state.editingLoanApplication.proofOfSanction.length)
        error = 'Please upload the Proof of Sanction'
      else if (!this.state.editingLoanApplication.dateOfDisbursement)
        error = 'Please select a correct Date of Disbursement'
      else if (!this.state.editingLoanApplication.proofOfDisbursement.length)
        error = 'Please upload the Proof of Disbursement'
      else if (!this.state.editingLoanApplication.disbursedAmount)
        error = 'Please enter the disbursed amount'
      else if (
        this.state.editingLoanApplication.disbursedAmount < 5000
        // || this.state.editingLoanApplication.disbursedAmount > 10000000
      )
        error = 'Disbursed Amount must be greater than Rs.5000'
      // error = "Disbursed Amount must be between Rs.5000 & Rs.1 Cr.";
      else if (!this.state.editingLoanApplication.disbursedInterestPercentage)
        error = 'Please enter the Disbursed Loan Interest Percentage'
      else if (
        !(
          this.state.editingLoanApplication.disbursedInterestPercentage >= 0 &&
          this.state.editingLoanApplication.disbursedInterestPercentage <= 30
        )
      )
        error = 'Interest rate must be between 0% and 30%'
    }
    else if (this.state.editingLoanApplication.financialProduct?.length == 0) {
      error = 'Select atleast one Financial Product'
    }
    console.log(this.state.editingLoanApplication.financialProduct?.length, 'error --.', error);
    let overrideAmount =
      this.state.editingLoanApplication.disbursedAmount &&
      this.props.loanAmountRequired !==
      this.state.editingLoanApplication.disbursedAmount

    // if (this.state.editingLoanApplication.disbursedAmount!==)
    if (!error) {
      if (overrideAmount) {
        Swal.fire({
          title: 'Are you sure?',
          html: 'Loan Amount Required and Disbursed Amount are different. Accepting will change the value in the lead profile as well.',
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: 'Yes, Change',
          confirmButtonAriaLabel: 'Yes, Change',
          cancelButtonText: 'No, Cancel',
          cancelButtonAriaLabel: 'No, Cancel',
        }).then(result => {
          if (result.value) {
            loanApplicationDetails.selfInvestmentAmount =
              this.state.stages.capitalFulfilled.selfInvestmentAmount
            fetch(
              process.env.REACT_APP_API_APP_FIELD_URL +
              '/trainee/add-capital/' +
              this.props.leadId,
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  source: 'humblebee_admin',
                  Authorization:
                    'Bearer ' + JSON.parse(readCookie('access_token')),
                },
                body: JSON.stringify({
                  loanApplicationDetails: editingLoanApplication,
                }),
              }
            )
              .then(data => data.json())
              .then(data => {
                if (data.status) {
                  this.notifySuccess('Successfully updated loan application')
                  window.location.reload()
                } else {
                  this.notifyError(data.errorMsg)
                }
              })
          }
        })
      } else {
        fetch(
          process.env.REACT_APP_API_APP_FIELD_URL +
          '/trainee/add-capital/' +
          this.props.leadId,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              source: 'humblebee_admin',
              Authorization: 'Bearer ' + JSON.parse(readCookie('access_token')),
            },
            body: JSON.stringify({
              loanApplicationDetails: editingLoanApplication,
            }),
          }
        )
          .then(data => data.json())
          .then(data => {
            if (data.status) {
              this.notifySuccess('Successfully updated loan application')
              stages.capitalFulfilled.loanApplicationDetails = false
              this.setState({ stages }, () => {
                stages.capitalFulfilled = data.capitalFulfilled
                // stages.capitalFulfilled.updatedBy = this.getCurrentUpdatedByObj();
                this.setState({
                  stages,
                  editingLoanApplication: null,
                  uploadingLoanApplicationFiles: false,
                  newFilesLoanApplication: {},
                  showLoanUploadFiles: false,
                })
              })
            } else {
              this.notifyError(data.errorMsg)
            }
          })
      }
    } else {
      this.notifyError(error)
    }
  }

  badgeColor = () => {
    const appType = this.state.selectedApplicationType;
    const st = this.state.selectedStage;
    // Use fixed, high-contrast colors so the status badge is always readable
    if (appType === "self") {
      // Gray badge for self-investment flow
      return "#6c757d"; // bootstrap secondary
    }

    if (st === "rejected") return "#e74c3c";     // red
    if (st === "sanctioned") return "#27ae60";   // green
    if (st === "disbursed") return "#27ae60";    // green
    if (st === "transferred") return "#27ae60";  // green
    // default (applied)
    return "#DF6F4F";                             // orange
  };

  addNewLoanApplication = () => {
    fetch(
      process.env.REACT_APP_API_URL +
      '/api/v1/schemes/' +
      this.props.leadId +
      '/non-recommended-schemes?ids=' +
      this.state?.recommendedSchemeIds?.join(','),
      {
        method: 'GET',
        headers: {
          'x-auth-token': JSON.parse(readCookie('access_token')),
        },
      }
    )
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          this.setState({ nonRecommendedSchemes: data.schemes })
        }
      })

    let editingLoanApplication = {
      slNo: '',
      id: '',
      scheme: '',
      selfInvestmentAmount: 0,
      loanAmount: 0,
      grantAmount: 0,
      modeOfApplication: '',
      appliedToBank: '',
      branchIFSC: '',
      dateOfApplication: '',
      dateOfSanction: '',
      dateOfDisbursement: '',
      dateOfRejection: '',
      status: '',
      importantInfo: '',
      disbursedTo: '',
      files: [],
      proofOfSanction: [],
      recordType: '',
      proofOfDisbursement: [],
      history: [],
      mfiName: '',
      mfiId: '',
      createdAt: new Date(),
      updatedAt: new Date(),
      financialProduct: '',
    }
    this.setState({
      editingLoanApplication,
      showLoanUploadFiles: false,
      newFilesLoanApplication: {},
    })
  }

  updateEditingLoanApplication = (type, value, elem) => {
    let editingLoanApplication = this.state.editingLoanApplication

    if (value.target) value = value.target.value
    if (
      type === 'dateOfApplication' ||
      type === 'dateOfSanction' ||
      type === 'dateOfDisbursement' ||
      type === 'dateOfRejection'
    ) {
      if (
        !value ||
        !moment(value).isValid() ||
        (moment(value).year() < 1900 &&
          moment(value).year().toString().length === 4)
      ) {
        // console.log(value, !moment(value).isValid(), moment(value).year(), moment(value).year().toString().length);
        this.notifyError('Please select a valid date!')
        return
      }
      value = moment(value).toDate()

      if (type === 'dateOfApplication') {
        let dateToConsider = moment(this.props?.leadData?.addedAt).toDate()
        if (value < dateToConsider) {
          Swal.fire(
            '',
            'Please note that the system has recorded that the loan application date is before the date of profile creation. This shall be flagged during audit process and the candidate shall be disqualified. Kindly correct the loan application date and upload legitimate evidence to avoid this.',
            'info'
          )
        }
      }
    }

    if (elem && type === 'scheme') {
      if (elem.props.type === 'id') {
        editingLoanApplication[type] = elem.props.title
        editingLoanApplication['schemeId'] = value
        if (!elem.props.title.toLowerCase().includes('mfi')) {
          editingLoanApplication['mfiId'] = ''
          editingLoanApplication['mfiName'] = ''
        }
      } else {
        editingLoanApplication[type] = value
        if (!value.toLowerCase().includes('mfi')) {
          editingLoanApplication['mfiId'] = ''
          editingLoanApplication['mfiName'] = ''
        }
      }
    } else if (type === 'mfi') {
      editingLoanApplication['mfiId'] = value
      let mfiObj = this.state.mfis.filter(x => x._id === value)
      editingLoanApplication['mfiName'] = mfiObj.length
        ? mfiObj[0]['label'] || ''
        : ''
    } else editingLoanApplication[type] = value
    this.setState({ editingLoanApplication })
  }

  showLoanUploadFiles = type => {
    this.setState({ showLoanUploadFiles: type })
  }

  updateDisbursement = (type, event) => {
    let editingLoanApplication = this.state.editingLoanApplication
    editingLoanApplication[type] = event.target.value
      ? Number(event.target.value)
      : null
    this.setState({ editingLoanApplication })
  }
  hideLoanUploadFiles = type => {
    let newFilesLoanApplication = this.state.newFilesLoanApplication
    delete newFilesLoanApplication[type]
    this.setState({ showLoanUploadFiles: false, newFilesLoanApplication })
  }

  updateFilesLoanApplication = (type, e) => {
    let files = e.target.files,
      newFilesLoanApplication = this.state.newFilesLoanApplication
    newFilesLoanApplication[type] = files
    this.setState({ newFilesLoanApplication })
  }

  deleteFileFromLoan = (index, type) => {
    let editingLoanApplication = this.state.editingLoanApplication

    Swal.fire({
      title: 'Are you sure?',
      html: 'This file will be deleted permanently',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Yes, Delete',
      confirmButtonAriaLabel: 'Yes, Delete',
      cancelButtonText: 'No, Cancel',
      cancelButtonAriaLabel: 'No, Cancel',
    }).then(result => {
      if (result.value) {
        editingLoanApplication[type].splice(index, 1)
        this.setState({ editingLoanApplication })
      }
    })
  }

  loanUploadFiles = type => {
    let newFilesLoanApplication = this.state.newFilesLoanApplication,
      editingLoanApplication = this.state.editingLoanApplication
    if (type === 'proofOfDisbursement') {
      Swal.fire({
        title: 'Are you sure?',
        html: '<note>Please note that the disbursement proof is ideally a photo of the passbook/transaction summary which shows the loan sum credited into the account. The cover page of the passbook confirming the name of the candidate should also be uploaded.<br/>Kindly <strong>DO NOT</strong> upload handwritten notes, business plan, shop photo or blurred photos of the proof of the disbursement in any case.This shall lead to disqunotelification.</p>',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'I understand, please proceed!',
        confirmButtonAriaLabel: 'I understand, please proceed!',
        cancelButtonText: 'Cancel',
        cancelButtonAriaLabel: 'Cancel',
      }).then(result => {
        if (result.value) {
          if (
            newFilesLoanApplication[type] &&
            newFilesLoanApplication[type].length
          ) {
            let formData = new FormData()
            for (let x = 0; x < newFilesLoanApplication[type].length; x++) {
              formData.append('files', newFilesLoanApplication[type][x])
            }
            this.setState({ uploadingLoanApplicationFiles: type })
            fetch(
              process.env.REACT_APP_API_APP_FIELD_URL +
              '/trainee/add-doc/' +
              this.props.leadId,
              {
                method: 'POST',
                headers: {
                  source: 'humblebee_admin',
                  Authorization:
                    'Bearer ' + JSON.parse(readCookie('access_token')),
                },
                body: formData,
              }
            )
              .then(data => data.json())
              .then(data => {
                if (data.status) {
                  editingLoanApplication[type] = [
                    ...editingLoanApplication[type],
                    ...data.urls,
                  ]
                  delete newFilesLoanApplication[type]
                  this.notifySuccess('Successfully uploaded files')
                  this.setState({
                    editingLoanApplication,
                    newFilesLoanApplication,
                    showLoanUploadFiles: false,
                    uploadingLoanApplicationFiles: false,
                  })
                } else {
                  this.notifyError(data.errorMsg)
                  this.setState({ uploadingLoanApplicationFiles: false })
                }
              })
          }
        }
      })
    } else if (
      newFilesLoanApplication[type] &&
      newFilesLoanApplication[type].length
    ) {
      let formData = new FormData()
      for (let x = 0; x < newFilesLoanApplication[type].length; x++) {
        formData.append('files', newFilesLoanApplication[type][x])
      }
      this.setState({ uploadingLoanApplicationFiles: type })
      fetch(
        process.env.REACT_APP_API_APP_FIELD_URL +
        '/trainee/add-doc/' +
        this.props.leadId,
        {
          method: 'POST',
          headers: {
            source: 'humblebee_admin',
            Authorization: 'Bearer ' + JSON.parse(readCookie('access_token')),
          },
          body: formData,
        }
      )
        .then(data => data.json())
        .then(data => {
          if (data.status) {
            editingLoanApplication[type] = [
              ...editingLoanApplication[type],
              ...data.urls,
            ]
            delete newFilesLoanApplication[type]
            this.notifySuccess('Successfully uploaded files')
            this.setState({
              editingLoanApplication,
              newFilesLoanApplication,
              showLoanUploadFiles: false,
              uploadingLoanApplicationFiles: false,
            })
          } else {
            this.notifyError(data.errorMsg)
            this.setState({ uploadingLoanApplicationFiles: false })
          }
        })
    }
  }

  onStatusChange = (status, moveBack = false) => {
    let stages = this.state.stages,
      currentActiveStage = this.state.currentActiveStage,
      isValid = false

    if (
      ['Started up', 'Scaled up'].includes(status) &&
      this.state.similarEnterpriseNumbers.length &&
      JSON.parse(readCookie('userData')).userType.name !==
      'Project Management Unit'
    ) {
      Swal.fire(
        '',
        `There is an enterprise with similar mobile number (${this.state.similarEnterpriseNumbers[0].basic.name || ''} - ${this.state.similarEnterpriseNumbers[0].basic.mobileNumber || ''}) in the system. Only PMU can mark this as set-up. Please reach out to the PMU.`,
        'error'
      )
      return
    }

    let milestone = stages.enterpriseSetup.sidbiMilestone
    // return;
    // console.log( milestone , moveBack)
    if (milestone && moveBack === true) {
      Swal.fire({
        title: 'Warning!',
        // text: "This candidate data has already been reported. We do not advise you to take this action.",
        html: `<span>You must not alter the status of this candidate, since they have already been shared with the funder. Any change is not advisable. Kindly reach out to your supervisor for guidance. <br/> आपको इस उम्मीदवार की स्थिति में बदलाव नहीं करना चाहिए, क्योंकि उन्हें पहले ही फंडर के साथ साझा किया जा चुका है। कोई भी बदलाव उचित नहीं है। कृपया मार्गदर्शन के लिए अपने वरिष्ठ से संपर्क करें।</span>`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'No, Cancel',
        confirmButtonText: 'Yes, Continue',
      }).then(res => {
        if (res.value) {
          if (status) {
            if (currentActiveStage === 'enterpriseSetup') {
              if (
                stages.enterpriseSetup.entityName &&
                ((this.state.stages.enterpriseSetup.creationMonth &&
                  this.state.stages.enterpriseSetup.creationYear) ||
                  this.state.stages.enterpriseSetup.createdOn) &&
                stages.enterpriseSetup.enterpriseRegistered &&
                stages.enterpriseSetup.udyogAadharCertificateReceived &&
                stages.enterpriseSetup.gstCertificate &&
                stages.enterpriseSetup.otherLicenses &&
                google_maps_url_regex.test(
                  stages.enterpriseSetup.googleBusinessLocationUrl
                ) &&
                stages.enterpriseSetup.certificateOfShopAndEstablishmentAct &&
                stages.enterpriseSetup.digitalPayment &&
                stages.enterpriseSetup.hasInsurance &&
                stages.enterpriseSetup.gemsPortalRegistered &&
                stages.enterpriseSetup.officeShopFactoryAddress &&
                stages.enterpriseSetup.officeShopFactoryAddressUrl &&
                stages.enterpriseSetup.officeShopFactoryAddressUrl.latitude &&
                stages.enterpriseSetup.officeShopFactoryAddressUrl.longitude &&
                stages.enterpriseSetup.supportReceived &&
                stages.enterpriseSetup.entrepreneurStory &&
                stages.enterpriseSetup.googleBusinessLocationUrl &&
                (this.state.otherImageFiles ||
                  stages.enterpriseSetup.otherImageUrls.length)
              ) {
                if (
                  stages.enterpriseSetup.enterpriseRegistered === 'Yes' &&
                  stages.enterpriseSetup.entityType
                )
                  isValid = true
                else if (stages.enterpriseSetup.enterpriseRegistered === 'No')
                  isValid = true
              }
            } else if (currentActiveStage === 'businessPlanReady') {
              if (
                (stages.businessPlanReady.businessPlanId ||
                  stages.businessPlanReady.businessPlanUrl) &&
                stages.businessPlanReady.businessPlanStatus === 'Completed' &&
                ['Received', 'Not required'].includes(
                  stages.businessPlanReady.quotationsObj.quotationStatus
                ) &&
                status === 'Completed'
              )
                isValid = true
              else if (status !== 'Completed') isValid = true
              // } else if(currentActiveStage === 'dueDiligence' && status === 'Completed') {
              // 	if(stages.dueDiligence.questions.currentMonthlySales && stages.dueDiligence.questions.currentMonthlyCosts && stages.dueDiligence.questions.correctName && stages.dueDiligence.questions.interestedInBusiness && stages.dueDiligence.questions.sourceOfKnowledge && stages.dueDiligence.questions.reasonForBusiness && stages.dueDiligence.questions.experienceDetails && stages.dueDiligence.questions.familyAwareness && stages.dueDiligence.questions.isJointVenture && stages.dueDiligence.questions.licenseReqd && stages.dueDiligence.questions.earningFamilyMembers && stages.dueDiligence.questions.monthlyHouseholdIncome && stages.dueDiligence.questions.filedIncomeTax && stages.dueDiligence.questions.monthlyIndividualIncome && stages.dueDiligence.questions.incomeSource && stages.dueDiligence.questions.isOwnHouse && stages.dueDiligence.questions.houseOwnerName && stages.dueDiligence.questions.livingInHouse && stages.dueDiligence.questions.businessLocationUnchanged && stages.dueDiligence.questions.isExactBusinessLocationKnown && stages.dueDiligence.questions.areTargetCustomersIdentified && stages.dueDiligence.questions.estimateMonthlySalesAndCosts && stages.dueDiligence.questions.nearbyCompetitiveBusinesses && stages.dueDiligence.questions.goodsPurchaseLocation && stages.dueDiligence.questions.hasTakenCreditCard && stages.dueDiligence.questions.isCibilKnown && stages.dueDiligence.questions.isCandidateInvolvedInBusiness && stages.dueDiligence.questions.willSupplyQuotations && stages.dueDiligence.questions.ownLand && stages.dueDiligence.questions.worthOfAsset && stages.dueDiligence.questions.candidateHasPAN && stages.dueDiligence.questions.candidateHasGuarantor && stages.dueDiligence.questions.nameRelationWithGuarantor && stages.dueDiligence.questions.bankAccountIsActive && stages.dueDiligence.questions.hasGSTRegistration && stages.dueDiligence.questions.hasGSTReturns && stages.dueDiligence.questions.hasITReturns && stages.dueDiligence.questions.hasTINNumber && stages.dueDiligence.questions.registeredUnderMSMEUdyogAadhar && stages.dueDiligence.questions.hasRelevantLicenses && stages.dueDiligence.questions.otherBusinessAssets && stages.dueDiligence.questions.hasActiveBankAccount && stages.dueDiligence.questions.maintainAccounts) isValid = true;
              // 	else this.notifyError('Please fill all the fields below!');
            } else isValid = true

            if (currentActiveStage === 'enterpriseSetup' && status === 'No') {
              Swal.fire({
                title: 'Are you sure?',
                html: 'Do you want to mark the enterprise as not setup?',
                showCloseButton: true,
                showCancelButton: true,
                focusConfirm: false,
                confirmButtonText: 'Yes, I wish to',
                confirmButtonAriaLabel: 'Yes, I wish to',
                cancelButtonText: 'No, I do not',
                cancelButtonAriaLabel: 'No, I do not',
              }).then(result => {
                if (result.value) {
                  stages[currentActiveStage][currentActiveStage + 'Status'] =
                    status
                  fetch(
                    process.env.REACT_APP_API_URL +
                    '/api/v1/lead-maturity/' +
                    this.props.leadId,
                    {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                        'x-auth-token': JSON.parse(readCookie('access_token')),
                      },
                      body: JSON.stringify({
                        [currentActiveStage]: stages[currentActiveStage],
                      }),
                    }
                  )
                    .then(data => data.json())
                    .then(data => {
                      if (data.status) {
                        this.setState({ stages })
                        this.notifySuccess('Successfully Updated the status!')
                      } else {
                        this.notifyError(data.errorMsg)
                      }
                    })
                }
              })
            } else {
              if (isValid) {
                stages[currentActiveStage][currentActiveStage + 'Status'] =
                  status
                if (currentActiveStage === 'businessPlanReady') {
                  stages.capitalFulfilled.capitalFulfilledStatus = 'Not Started'
                  stages.enterpriseSetup.enterpriseSetupStatus = 'Not Started'
                } else if (currentActiveStage === 'dueDiligence') {
                  stages.capitalFulfilled.capitalFulfilledStatus = 'Not Started'
                  stages.enterpriseSetup.enterpriseSetupStatus = 'Not Started'
                  stages.businessPlanReady.businessPlanReadyStatus =
                    'Not Started'
                }
                fetch(
                  process.env.REACT_APP_API_URL +
                  '/api/v1/lead-maturity/' +
                  this.props.leadId,
                  {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'x-auth-token': JSON.parse(readCookie('access_token')),
                    },
                    body: JSON.stringify({
                      [currentActiveStage]: stages[currentActiveStage],
                    }),
                  }
                )
                  .then(data => data.json())
                  .then(data => {
                    if (data.status) {
                      if (
                        currentActiveStage === 'dueDiligence' &&
                        status === 'Completed'
                      )
                        currentActiveStage = 'businessPlanReady'
                      this.setState({ stages, currentActiveStage })
                      this.notifySuccess('Successfully Updated the status!')
                    } else {
                      this.notifyError(data.errorMsg)
                    }
                  })
              } else {
                this.notifyError('Please fill the mandatory fields below!')
              }
            }
          }
        }
      })
    } else if (status) {
      if (currentActiveStage === 'enterpriseSetup') {
        if (
          stages.enterpriseSetup.entityName &&
          ((this.state.stages.enterpriseSetup.creationMonth &&
            this.state.stages.enterpriseSetup.creationYear) ||
            this.state.stages.enterpriseSetup.createdOn) &&
          stages.enterpriseSetup.enterpriseRegistered &&
          stages.enterpriseSetup.udyogAadharCertificateReceived &&
          stages.enterpriseSetup.gstCertificate &&
          stages.enterpriseSetup.otherLicenses &&
          google_maps_url_regex.test(
            stages.enterpriseSetup.googleBusinessLocationUrl
          ) &&
          stages.enterpriseSetup.certificateOfShopAndEstablishmentAct &&
          stages.enterpriseSetup.digitalPayment &&
          stages.enterpriseSetup.hasInsurance &&
          stages.enterpriseSetup.gemsPortalRegistered &&
          stages.enterpriseSetup.officeShopFactoryAddress &&
          stages.enterpriseSetup.officeShopFactoryAddressUrl &&
          stages.enterpriseSetup.officeShopFactoryAddressUrl.latitude &&
          stages.enterpriseSetup.officeShopFactoryAddressUrl.longitude &&
          stages.enterpriseSetup.supportReceived &&
          stages.enterpriseSetup.entrepreneurStory &&
          stages.enterpriseSetup.googleBusinessLocationUrl &&
          (this.state.otherImageFiles ||
            stages.enterpriseSetup.otherImageUrls.length)
        ) {
          if (
            stages.enterpriseSetup.enterpriseRegistered === 'Yes' &&
            stages.enterpriseSetup.entityType
          )
            isValid = true
          else if (stages.enterpriseSetup.enterpriseRegistered === 'No')
            isValid = true
        }
      } else if (currentActiveStage === 'businessPlanReady') {
        if (
          (stages.businessPlanReady.businessPlanId ||
            stages.businessPlanReady.businessPlanUrl) &&
          stages.businessPlanReady.businessPlanStatus === 'Completed' &&
          ['Received', 'Not required'].includes(
            stages.businessPlanReady.quotationsObj.quotationStatus
          ) &&
          status === 'Completed'
        )
          isValid = true
        else if (status !== 'Completed') isValid = true
        // } else if(currentActiveStage === 'dueDiligence' && status === 'Completed') {
        // 	if(stages.dueDiligence.questions.currentMonthlySales && stages.dueDiligence.questions.currentMonthlyCosts && stages.dueDiligence.questions.correctName && stages.dueDiligence.questions.interestedInBusiness && stages.dueDiligence.questions.sourceOfKnowledge && stages.dueDiligence.questions.reasonForBusiness && stages.dueDiligence.questions.experienceDetails && stages.dueDiligence.questions.familyAwareness && stages.dueDiligence.questions.isJointVenture && stages.dueDiligence.questions.licenseReqd && stages.dueDiligence.questions.earningFamilyMembers && stages.dueDiligence.questions.monthlyHouseholdIncome && stages.dueDiligence.questions.filedIncomeTax && stages.dueDiligence.questions.monthlyIndividualIncome && stages.dueDiligence.questions.incomeSource && stages.dueDiligence.questions.isOwnHouse && stages.dueDiligence.questions.houseOwnerName && stages.dueDiligence.questions.livingInHouse && stages.dueDiligence.questions.businessLocationUnchanged && stages.dueDiligence.questions.isExactBusinessLocationKnown && stages.dueDiligence.questions.areTargetCustomersIdentified && stages.dueDiligence.questions.estimateMonthlySalesAndCosts && stages.dueDiligence.questions.nearbyCompetitiveBusinesses && stages.dueDiligence.questions.goodsPurchaseLocation && stages.dueDiligence.questions.hasTakenCreditCard && stages.dueDiligence.questions.isCibilKnown && stages.dueDiligence.questions.isCandidateInvolvedInBusiness && stages.dueDiligence.questions.willSupplyQuotations && stages.dueDiligence.questions.ownLand && stages.dueDiligence.questions.worthOfAsset && stages.dueDiligence.questions.candidateHasPAN && stages.dueDiligence.questions.candidateHasGuarantor && stages.dueDiligence.questions.nameRelationWithGuarantor && stages.dueDiligence.questions.bankAccountIsActive && stages.dueDiligence.questions.hasGSTRegistration && stages.dueDiligence.questions.hasGSTReturns && stages.dueDiligence.questions.hasITReturns && stages.dueDiligence.questions.hasTINNumber && stages.dueDiligence.questions.registeredUnderMSMEUdyogAadhar && stages.dueDiligence.questions.hasRelevantLicenses && stages.dueDiligence.questions.otherBusinessAssets && stages.dueDiligence.questions.hasActiveBankAccount && stages.dueDiligence.questions.maintainAccounts) isValid = true;
        // 	else this.notifyError('Please fill all the fields below!');
      } else isValid = true

      if (currentActiveStage === 'enterpriseSetup' && status === 'No') {
        Swal.fire({
          title: 'Are you sure?',
          html: 'Do you want to mark the enterprise as not setup?',
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: 'Yes, I wish to',
          confirmButtonAriaLabel: 'Yes, I wish to',
          cancelButtonText: 'No, I do not',
          cancelButtonAriaLabel: 'No, I do not',
        }).then(result => {
          if (result.value) {
            stages[currentActiveStage][currentActiveStage + 'Status'] = status
            fetch(
              process.env.REACT_APP_API_URL +
              '/api/v1/lead-maturity/' +
              this.props.leadId,
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'x-auth-token': JSON.parse(readCookie('access_token')),
                },
                body: JSON.stringify({
                  [currentActiveStage]: stages[currentActiveStage],
                }),
              }
            )
              .then(data => data.json())
              .then(data => {
                if (data.status) {
                  this.setState({ stages })
                  this.notifySuccess('Successfully Updated the status!')
                } else {
                  this.notifyError(data.errorMsg)
                }
              })
          }
        })
      } else {
        if (isValid) {
          stages[currentActiveStage][currentActiveStage + 'Status'] = status
          if (currentActiveStage === 'businessPlanReady') {
            stages.capitalFulfilled.capitalFulfilledStatus = 'Not Started'
            stages.enterpriseSetup.enterpriseSetupStatus = 'Not Started'
          } else if (currentActiveStage === 'dueDiligence') {
            stages.capitalFulfilled.capitalFulfilledStatus = 'Not Started'
            stages.enterpriseSetup.enterpriseSetupStatus = 'Not Started'
            stages.businessPlanReady.businessPlanReadyStatus = 'Not Started'
          }
          fetch(
            process.env.REACT_APP_API_URL +
            '/api/v1/lead-maturity/' +
            this.props.leadId,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': JSON.parse(readCookie('access_token')),
              },
              body: JSON.stringify({
                [currentActiveStage]: stages[currentActiveStage],
              }),
            }
          )
            .then(data => data.json())
            .then(data => {
              if (data.status) {
                if (
                  currentActiveStage === 'dueDiligence' &&
                  status === 'Completed'
                )
                  currentActiveStage = 'businessPlanReady'
                this.setState({ stages, currentActiveStage })
                this.notifySuccess('Successfully Updated the status!')
              } else {
                this.notifyError(data.errorMsg)
              }
            })
        } else {
          this.notifyError('Please fill the mandatory fields below!')
        }
      }
    }
  }

  dueDiligenceChange = (e, section, key) => {
    let value = e,
      stages = this.state.stages
    //  return;
    if (section === 'eligibility' && key === 'cibilReportDocument') {
      // Upload logic
      /**
       * API
       */
      if (e.target.files.length) {
        let fileToSend = e.target.files[0]
        const formData = new FormData()
        formData.append('cibilDoc', fileToSend)
        fetch(
          process.env.REACT_APP_API_URL +
          '/api/v1/swati-leads/upload-cibil-doc/' +
          this.props.leadId,
          {
            method: 'POST',
            headers: {
              'x-auth-token': JSON.parse(readCookie('access_token')),
            },
            body: formData,
          }
        )
          .then(data => data.json())
          .then(data => {
            if (data.status) {
              let stages = this.state.stages
              stages.dueDiligence.questions[section][key] = data.s3Url
              this.notifySuccess(data.message)
              this.setState({ stages })
            } else {
              this.notifyError(data.errorMsg)
            }
          })
        // fetch();
        // update stages - this.state.stages
      }
      return
    }
    if (e.hasOwnProperty('target')) value = e.target.value

    if (key === 'correctName' && value === 'Relative explaining the business') {
      Swal.fire(
        '',
        'Please insist on speaking to the candidate (loan applicant)',
        'info'
      )
    } else if (
      key === 'nearbyCompetitiveBusinesses' &&
      value === 'Many similar businesses around'
    ) {
      Swal.fire('', 'Counsel the candidate for a different idea', 'info')
    } else if (key === 'visitBankForLoan' && value) {
      Swal.fire(
        '',
        'The candidate should know that banking procedures take time and they would need to be patient while visiting the bank. Multiple visits to the bank shall be required and the candidate should be ready for the same.',
        'info'
      )
    } else if (key === 'businessLocationUnchanged' && value === 'No') {
      Swal.fire({
        title: 'Please enter the pincode of the business location',
        input: 'text',
        inputAttributes: { placeholder: 'Pincode' },
        showCancelButton: true,
        showLoaderOnConfirm: true,
        confirmButtonText: 'Search Location',
        preConfirm: pincode => {
          if (pincode.match(/^\d{6}$/) !== null) {
            return fetch(
              process.env.REACT_APP_API_URL +
              '/api/v1/ivrs/get-details-for-pincode/' +
              pincode,
              {
                method: 'GET',
                headers: {
                  'x-auth-token': JSON.parse(readCookie('access_token')),
                },
              }
            )
              .then(data => data.json())
              .then(data => {
                if (data.status) {
                  data.details.pincode = pincode
                  return data.details
                } else if (data.errorMessage) {
                  this.notifyError(data.errorMessage)
                  return false
                } else {
                  this.notifyError('Unable to fetch the location!')
                  return false
                }
              })
              .catch(error => {
                console.log(`Request failed: ${error}`)
                return false
              })
          } else return false
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(result => {
        if (result.value) {
          if (result.value.assignedTo) {
            Swal.fire({
              icon: 'warning',
              title: 'Are you sure?',
              text: 'This candidates location will be automatically updated and assigned to the respective SCK!',
              focusConfirm: false,
              showCloseButton: true,
              showCancelButton: true,
              cancelButtonText: 'No, Cancel',
              confirmButtonText: 'Yes, Update location',
            }).then(res => {
              if (res.value) {
                fetch(
                  process.env.REACT_APP_API_URL +
                  '/api/v1/swati-leads/' +
                  this.props.leadId,
                  {
                    method: 'PATCH',
                    headers: {
                      'Content-Type': 'application/JSON',
                      'x-auth-token': JSON.parse(readCookie('access_token')),
                    },
                    body: JSON.stringify({
                      updateLocation: {
                        inModel: 'Ngo',
                        state: result.value.state,
                        pincode: result.value.pincode,
                        district: result.value.district,
                        userType: result.value.userType,
                        assignTo: result.value.assignedTo,
                      },
                    }),
                  }
                )
                  .then(data => data.json())
                  .then(data => {
                    if (data.status) {
                      this.notifySuccess('Lead is successfully disqualified!')
                      window.location.reload()
                    } else {
                      this.notifyError('Could not update lead')
                    }
                  })
              }
            })
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'Are you sure?',
              text: `This candidate will be automatically marked as disqualified as the new location (${result.value.district}, ${result.value.state}) is outside focus region!`,
              focusConfirm: false,
              showCloseButton: true,
              showCancelButton: true,
              cancelButtonText: 'No, Cancel',
              confirmButtonText: 'Yes, Disqualify',
            }).then(res => {
              if (res.value) {
                fetch(
                  process.env.REACT_APP_API_URL +
                  '/api/v1/swati-leads/' +
                  this.props.leadId +
                  '?disqualified=true&from=dueDiligence',
                  {
                    method: 'PATCH',
                    headers: {
                      'Content-Type': 'application/JSON',
                      'x-auth-token': JSON.parse(readCookie('access_token')),
                    },
                    body: JSON.stringify({
                      disqualificationReason: 'Migrated',
                      updateLocation: {
                        userType: '',
                        inModel: null,
                        assignTo: null,
                        state: result.value.state,
                        pincode: result.value.pincode,
                        district: result.value.district,
                      },
                    }),
                  }
                )
                  .then(data => data.json())
                  .then(data => {
                    if (data.status) {
                      this.notifySuccess('Lead is successfully disqualified!')
                      window.location.reload()
                    } else {
                      this.notifyError('Could not update lead')
                    }
                  })
              }
            })
          }
        }
      })
    } else if (key === 'isCibilKnown' && value === 'Poor (Below 500)') {
      Swal.fire({
        icon: 'warning',
        title: 'Are you sure?',
        text: 'This candidate will be automatically marked as disqualified because of the poor CIBIL score!',
        focusConfirm: false,
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: 'No, Cancel',
        confirmButtonText: 'Yes, Disqualify',
      }).then(result => {
        if (result.value) {
          stages.dueDiligence['questions'][section][key] = value

          fetch(
            process.env.REACT_APP_API_URL +
            '/api/v1/lead-maturity/' +
            this.props.leadId +
            '/dueDiligence',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': JSON.parse(readCookie('access_token')),
              },
              body: JSON.stringify({
                questions: {
                  [section]: {
                    ...this.state.stages.dueDiligence.questions[section],
                    [key]: value,
                  },
                },
              }),
            }
          )
            .then(data => data.json())
            .then(data => {
              if (data.status) {
                stages.dueDiligence = data.dueDiligence
                stages.dueDiligence.updatedBy = this.getCurrentUpdatedByObj()
                this.setState({ stages })
              } else {
                this.notifyError(data.errorMsg)
              }
            })

          fetch(
            process.env.REACT_APP_API_URL +
            '/api/v1/swati-leads/' +
            this.props.leadId +
            '?disqualified=true&from=dueDiligence',
            {
              method: 'PATCH',
              headers: {
                'Content-Type': 'application/JSON',
                'x-auth-token': JSON.parse(readCookie('access_token')),
              },
              body: JSON.stringify({
                disqualificationReason: 'Poor CIBIL score',
              }),
            }
          )
            .then(data => data.json())
            .then(data => {
              if (data.status) {
                this.notifySuccess('Lead is successfully disqualified!')
                window.location.reload()
              } else {
                this.notifyError('Could not update lead')
              }
            })
        }
      })
    }

    if (
      (key !== 'businessLocationUnchanged' || value !== 'No') &&
      (key !== 'isCibilKnown' || value !== 'Poor (Below 500)')
    ) {
      if (
        key === 'monthlyHouseholdIncome' ||
        key === 'incomeInITR' ||
        key === 'monthlyIndividualIncome' ||
        key === 'worthOfAsset' ||
        key === 'investmentInBusiness' ||
        key === 'worthOfBusinessAsset' ||
        key === 'currentMonthlySales' ||
        key === 'currentMonthlyCosts'
      ) {
        value = parseFloat(String(value).replace(/,/g, '')) || ''
      }

      fetch(
        process.env.REACT_APP_API_URL +
        '/api/v1/lead-maturity/' +
        this.props.leadId +
        '/dueDiligence',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-auth-token': JSON.parse(readCookie('access_token')),
          },
          // body: JSON.stringify({ [type]: { [key]: value } }),
          body:
            // JSON.stringify({ 'questions': { [section]: { [key]: value } } }),
            JSON.stringify({
              questions: {
                [section]: {
                  ...this.state.stages.dueDiligence.questions[section],
                  [key]: value,
                },
              },
            }),
        }
      )
        .then(data => data.json())
        .then(data => {
          if (data.status) {
            const INITIAL_DD_STATUS = {
              basic: {},
              businessInfo: {},
              eligibility: {},
              existingenterpriserelated: {},
              loanandfinancialinfo: {},
              stabilityAndBackground: {},
            }
            stages.dueDiligence = data.dueDiligence
            stages.dueDiligence.questions = {
              ...INITIAL_DD_STATUS,
              ...data.dueDiligence.questions,
            }
            stages.dueDiligence.updatedBy = this.getCurrentUpdatedByObj()
            this.setState({ stages })
          } else {
            this.notifyError(data.errorMsg)
          }
        })
    }
  }

  saveToProfile = (type, e) => {
    console.log(
      '🚀 ~ file: SingleLeadMaturityStages.js:8213 ~ SingleLeadMaturityStages ~ type, e:',
      type,
      e
    )
    if (
      type === 'experienceInSector' ||
      type === 'employmentStatus' ||
      type === 'employer' ||
      type === 'willingToGiveCollateral'
    ) {
      let value = e
      if (e.target) value = e.target.value
      Swal.fire({
        icon: 'warning',
        title: 'Are you sure you want to go ahead?',
        text: "Updating this value will update the candidate's profile as well!",
        focusConfirm: false,
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: 'No, Cancel',
        confirmButtonText: 'Yes, Update',
      }).then(res => {
        if (res.value) {
          fetch(
            process.env.REACT_APP_API_URL +
            '/api/v1/swati-leads/' +
            this.props.leadId +
            `?${type}=${value}`,
            {
              method: 'PATCH',
              headers: {
                'Content-Type': 'application/JSON',
                'x-auth-token': JSON.parse(readCookie('access_token')),
              },
            }
          )
            .then(data => data.json())
            .then(data => {
              if (data.status) {
                this.setState({ refreshingDueDiligenceForm: true }, () => {
                  this.props.refreshLeadData(() =>
                    this.setState({ refreshingDueDiligenceForm: false })
                  )
                })
                this.notifySuccess('Lead profile updated!')
              } else {
                this.notifyError('Could not update lead')
              }
            })
        } else {
          this.setState({ refreshingDueDiligenceForm: true }, () => {
            this.props.refreshLeadData(() =>
              this.setState({ refreshingDueDiligenceForm: false })
            )
          })
        }
      })
    }
  }

  showHoldPrompt = (type = 'dueDiligence') => {
    let html =
      '<div className="mb15">You are about to put this lead on hold!</div>' +
      '<div className="form-group"><label className="control-label text-left">Put on hold until:</label>' +
      `<input className="form-control mb10" type="date" min="${maxDate}" id="next-followup-date" className="swal2-input" /></div>` +
      '<div className="form-group"><label className="control-label text-left">Select the reason to put this candidate on hold:</label>' +
      '<select className="form-control" id="on-hold-reason" className="swal2-input">' +
      '<option value="" disabled selected>Select a reason</option>'

    if (type === 'dueDiligence') {
      for (let i = 0; i < this.state.ddOnHoldReasons.length; i++) {
        html += `<option value="${this.state.ddOnHoldReasons[i]}">${this.state.ddOnHoldReasons[i]}</option>`
      }
    } else if (type === 'businessPlanReady') {
      for (let i = 0; i < this.state.bpOnHoldReasons.length; i++) {
        html += `<option value="${this.state.bpOnHoldReasons[i]}">${this.state.bpOnHoldReasons[i]}</option>`
      }
    }
    html += '</select></div>'

    Swal.fire({
      html,
      icon: 'warning',
      focusConfirm: false,
      showCloseButton: true,
      showCancelButton: true,
      title: 'Are you sure?',
      cancelButtonText: 'No, Cancel',
      confirmButtonText: 'Yes, Put On Hold',
      preConfirm: () => {
        let nextFollowUpDate =
          document.getElementById('next-followup-date').value,
          onHoldReason = document.getElementById('on-hold-reason').value
        if (nextFollowUpDate && onHoldReason) {
          return { nextFollowUpDate, onHoldReason }
        } else return false
      },
    }).then(result => {
      if (result.value) {
        fetch(
          process.env.REACT_APP_API_URL +
          '/api/v1/swati-leads/' +
          this.props.leadId +
          '?putOnHold=true&from=' +
          type,
          {
            method: 'PATCH',
            headers: {
              'Content-Type': 'application/JSON',
              'x-auth-token': JSON.parse(readCookie('access_token')),
            },
            body: JSON.stringify({
              onHoldReason: result.value.onHoldReason,
              nextFollowUpDate: result.value.nextFollowUpDate,
            }),
          }
        )
          .then(data => data.json())
          .then(data => {
            if (data.status) {
              this.notifySuccess('Lead is successfully put on hold!')
              window.location.reload()
            } else {
              this.notifyError('Could not update lead')
            }
          })
      }
    })
  }

  showDisqualificationPrompt = () => {
    if (this.props.leadData.leadMaturity.enterpriseSetup.sidbiMilestone) {
      Swal.fire({
        title: 'Warning!',
        // text: "This candidate data has already been reported. We do not advise you to take this action.",
        html: `<span>You must not alter the status of this candidate, since they have already been shared with the funder. Any change is not advisable. Kindly reach out to your supervisor for guidance. <br/> आपको इस उम्मीदवार की स्थिति में बदलाव नहीं करना चाहिए, क्योंकि उन्हें पहले ही फंडर के साथ साझा किया जा चुका है। कोई भी बदलाव उचित नहीं है। कृपया मार्गदर्शन के लिए अपने वरिष्ठ से संपर्क करें।</span>`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'No, Cancel',
        confirmButtonText: 'Yes, Disqualify',
      }).then(result => {
        if (result.value) {
          console.log(result, 'result')
          this.promptFunction()
        }
      })
    } else {
      this.promptFunction()
    }
  }

  promptFunction = () => {
    Swal.fire({
      title: 'Why do you want to disqualify this lead?',
      text: 'Kindly select the reason for disqualifying',
      input: 'select',
      inputOptions: {
        'No longer interested': 'No longer interested',
        'Has no idea/intention of starting up':
          'Has no idea/intention of starting up',
        'Spam caller': 'Spam caller',
        'Not able to get in touch at all': 'Not able to get in touch at all',
        Migrated: 'Migrated',
        'Passed away': 'Passed away',
        'Poor CIBIL score': 'Poor CIBIL score',
        'Only looking for bank loan (not very genuine)':
          'Only looking for bank loan (not very genuine)',
        'Scale-up: Has availed credit linkage before':
          'Scale-up: Has availed credit linkage before',
        'Duplicate lead': 'Duplicate lead',
        'Candidate started without Mission support':
          'Candidate started without Mission support',
        "Candidate doesn't acknowledge support of Mission Swavalamban":
          "Candidate doesn't acknowledge support of Mission Swavalamban",
        'Other Reason': 'Other Reason',
      },
      type: 'warning',
      showCancelButton: true,
      inputPlaceholder: 'Select the reason',
      cancelButtonText: 'No, Cancel',
      confirmButtonText: 'Yes, Disqualify',
      inputValidator: value => {
        if (value) {
          fetch(
            process.env.REACT_APP_API_URL +
            '/api/v1/swati-leads/' +
            this.props.leadId +
            '?disqualified=true&from=dueDiligence',
            {
              method: 'PATCH',
              headers: {
                'Content-Type': 'application/JSON',
                'x-auth-token': JSON.parse(readCookie('access_token')),
              },
              body: JSON.stringify({ disqualificationReason: value }),
            }
          )
            .then(data => data.json())
            .then(data => {
              if (data.status) {
                this.notifySuccess('Lead is successfully disqualified!')
                window.location.reload()
              } else {
                this.notifyError('Could not update lead')
              }
            })
        }
      },
    })
  }

  addGuarantor = () => {
    let stages = this.state.stages,
      isValid = true

    for (
      let i = 0;
      i <
      stages.dueDiligence.questions.loanandfinancialinfo.guarantorDetails
        .length;
      i++
    ) {
      if (
        !stages.dueDiligence.questions.loanandfinancialinfo.guarantorDetails[i]
          .name
      )
        isValid = false
    }
    if (isValid) {
      stages.dueDiligence.questions.loanandfinancialinfo.guarantorDetails.push({
        index:
          stages.dueDiligence.questions.loanandfinancialinfo.guarantorDetails
            .length,
        name: '',
        phone: '',
        relationship: '',
      })
      this.setState({ stages })
    } else {
      this.notifyError(
        'Please fill all the guarantor details correctly to add more.'
      )
    }
  }

  skillAndEDPTrainingChange = (currentActiveStage, type, e) => {
    let value = e,
      stages = this.state.stages
    if (e.hasOwnProperty('target')) value = e.target.value
    stages[currentActiveStage][type] = value

    // if(type === 'instituteLocation') {
    // 	stages[currentActiveStage]['instituteLocation'] = { label: value };
    // 	geocodeByAddress(value)
    // 	.then(results => getLatLng(results[0]))
    // 	.then((latLng) => {
    // 		stages[currentActiveStage]['instituteLocation']['latitude'] = latLng.lat;
    // 		stages[currentActiveStage]['instituteLocation']['longitude'] = latLng.lng;
    // 		fetch(process.env.REACT_APP_API_URL + '/api/v1/lead-maturity/' + this.props.leadId + '/' + currentActiveStage, {
    // 			method: 'POST',
    // 			headers: {
    // 				'Content-Type': 'application/json',
    // 				'x-auth-token': JSON.parse(readCookie('access_token'))
    // 			},
    // 			body: JSON.stringify({ instituteLocation: stages[currentActiveStage]['instituteLocation'] })
    // 		}).then(data => data.json())
    // 		.then(data => {
    // 			if(data.status) {
    // 				this.setState({ stages });
    // 			} else {
    // 				this.notifyError(data.errorMsg);
    // 			}
    // 		});
    // 	}).catch(error => console.error('Error', error));
    // } else {
    fetch(
      process.env.REACT_APP_API_URL +
      '/api/v1/lead-maturity/' +
      this.props.leadId +
      '/' +
      currentActiveStage,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': JSON.parse(readCookie('access_token')),
        },
        body: JSON.stringify({ [type]: value }),
      }
    )
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          this.setState({ stages })
        } else {
          this.notifyError(data.errorMsg)
        }
      })
    // }
  }

  editDate = async () => {
    // eslint-disable-next-line no-unused-vars
    const { value: date } = await Swal.fire({
      title: 'Selected Enterprise setup date',
      html: `<input type="date" id="swal-date" className="form-control" max=${moment().format('YYYY-MM-DD')}>`,
      focusConfirm: false,
      preConfirm: () => {
        return document.getElementById('swal-date').value
      },
    })

    if (document.getElementById('swal-date').value) {
      // this.updateDate(document.getElementById('swal-date').value);
      fetch(
        process.env.REACT_APP_API_URL +
        '/api/v1/swati-leads/updateEnterpriseSetUpDate/' +
        this.props.leadId,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'x-auth-token': JSON.parse(readCookie('access_token')),
          },
          body: JSON.stringify({
            date: document.getElementById('swal-date').value,
          }),
        }
      )
        .then(data => data.json())
        .then(data => {
          if (!data.error) {
            this.notifySuccess(data.message)
            window.location.reload()
          } else {
            this.notifyError("Date couldn't be updated!")
          }
        })
    } else {
      this.notifyError('Select valid date')
    }
  }
  changeDate = e => {
    if (
      this.state.projectDetails.toDate &&
      e.target.value >
      moment(this.state.projectDetails.toDate).format('YYYY-MM-DD')
    ) {
      this.notifyError(
        `This project got over on ${moment(this.state.projectDetails.toDate).format('DD MMM YYYY')} and only enterprises enabled on/before this date can be added.`
      )
      return
    }
    this.setState({
      stages: {
        ...this.state.stages,
        enterpriseSetup: {
          ...this.state.stages.enterpriseSetup,
          createdOn: e.target.value || '',
        },
      },
    })
  }
  updateDate = e => {
    let {
      leadData: {
        leadInfo: { createdAt },
        enterpriseStatus: { financeType },
        leadMaturity: {
          capitalFulfilled: { loanApplicationDetails },
        },
      },
    } = this.props
    let dateToConsider = moment(
      financeType === '100% self-financed'
        ? createdAt
        : loanApplicationDetails[0]['dateOfDisbursement']
    )

    let dateToSet = e.target.value
    if (moment(dateToSet) > moment()) {
      this.notifyError(
        'Future date selection is not allowed, resetting to today'
      )
      dateToSet = moment().format('YYYY-MM-DD')
      this.setState({
        stages: {
          ...this.state.stages,
          enterpriseSetup: {
            ...this.state.stages.enterpriseSetup,
            createdOn: dateToSet || '',
          },
        },
      })
      return
    }
    if (dateToConsider > moment(dateToSet) && moment(dateToSet).year() > 1950) {
      Swal.fire({
        title: 'Are you sure about the date?',
        html: `Date of enterprise ${this.state.stages.enterpriseSetup.enterpriseState === 'Scale-up'
          ? 'Scale-up'
          : 'Set-up'
          } should be ${financeType === '100% self-financed' ? 'on/after profile creation date' : 'on/after the date of disbursement of loan'} (${moment(dateToConsider).format('DD-MM-YYYY')})`,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Yes, Please change',
        confirmButtonAriaLabel: 'Yes, Please change',
        cancelButtonText: 'No, Cancel',
        cancelButtonAriaLabel: 'No, Cancel',
      }).then(result => {
        if (result.value) {
          fetch(
            process.env.REACT_APP_API_URL +
            '/api/v1/swati-leads/updateEnterpriseSetUpDate/' +
            this.props.leadId,
            {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': JSON.parse(readCookie('access_token')),
              },
              body: JSON.stringify({ date: dateToSet }),
            }
          )
            .then(data => data.json())
            .then(data => {
              if (!data.error) {
                this.setState({
                  interimDate: dateToSet,
                  stages: {
                    ...this.state.stages,
                    enterpriseSetup: {
                      ...this.state.stages.enterpriseSetup,
                      createdOn: dateToSet || '',
                    },
                  },
                })
                this.notifySuccess(data.message)
              } else {
                this.notifyError("Date couldn't be updated!")
              }
            })
        } else {
          this.setState({
            stages: {
              ...this.state.stages,
              enterpriseSetup: {
                ...this.state.stages.enterpriseSetup,
                createdOn: this.state.interimDate || '',
              },
            },
          })
        }
      })
    } else {
      fetch(
        process.env.REACT_APP_API_URL +
        '/api/v1/swati-leads/updateEnterpriseSetUpDate/' +
        this.props.leadId,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'x-auth-token': JSON.parse(readCookie('access_token')),
          },
          body: JSON.stringify({ date: dateToSet }),
        }
      )
        .then(data => data.json())
        .then(data => {
          if (!data.error) {
            this.notifySuccess(data.message)
          } else {
            this.notifyError("Date couldn't be updated!")
          }
        })
    }
  }
  capitalize = word =>
    word
      .split(' ')
      .map(subStr =>
        subStr && subStr[0]
          ? subStr[0].toUpperCase() +
          subStr.slice(1, subStr.length).toLowerCase()
          : ''
      )
      .join(' ')

  enterpriseSetupChange = (type, e) => {
    let value = e,
      stages = this.state.stages
    if (e.hasOwnProperty('target')) value = e.target.value
    if (type === 'entityName') {
      value = this.capitalize(value)
    }
    if (type === 'recognizedSupport') {
      let supportError = value.match(
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{1,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      )
      let stages = this.state.stages
      stages.enterpriseSetup.recognizedSupport = value
      this.setState({
        supportError: supportError ? 'Please enter valid contact info' : null,
        stages,
      })
      if (supportError) {
        return
      }
    }
    if (
      type === 'officeShopFactoryAddressUrlLat' ||
      type === 'officeShopFactoryAddressUrlLong'
    ) {
      if (type === 'officeShopFactoryAddressUrlLat')
        stages['enterpriseSetup']['officeShopFactoryAddressUrl']['latitude'] =
          value
      else if (type === 'officeShopFactoryAddressUrlLong')
        stages['enterpriseSetup']['officeShopFactoryAddressUrl']['longitude'] =
          value
      stages['enterpriseSetup']['officeShopFactoryAddressUrl']['url'] =
        `https://maps.google.com/maps?q=${stages.enterpriseSetup.officeShopFactoryAddressUrl.latitude},${stages.enterpriseSetup.officeShopFactoryAddressUrl.longitude}`
    } else if (type === 'googleBusinessLocationUrl') {
      // var google_maps_url_regex = new RegExp('@(.*),(.*),');

      let loc_err = ''
      if (value.trim() === '') {
        loc_err = 'This field cannot be empty!'
        let stages = this.state.stages
        stages.enterpriseSetup.googleBusinessLocationUrl = value
        this.setState({ locError: loc_err, stages })
        return
      } else if (!value.match(google_maps_url_regex)) {
        loc_err = 'Only expanded Google Map URL is allowed in this field!'
        let stages = this.state.stages
        stages.enterpriseSetup.googleBusinessLocationUrl = value
        this.setState({ locError: loc_err, stages })
        return
      } else if (value.match(google_maps_url_regex)) {
        fetch(
          process.env.REACT_APP_API_URL +
          '/api/v1/swati-leads/googleLocationUrl/' +
          this.props.leadId,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'x-auth-token': JSON.parse(readCookie('access_token')),
            },
            body: JSON.stringify({ url: value }),
          }
        )
          .then(data => data.json())
          .then(data => {
            if (!data.error) {
              this.notifySuccess(data.message)
            } else {
              this.notifyError("URL couldn't be updated!")
            }
          })
      }
      let stages = this.state.stages
      stages.enterpriseSetup.googleBusinessLocationUrl = value
      this.setState({ locError: loc_err, stages })
    } else if (
      type === 'kycPAN' ||
      type === 'kycUdyogAadhar' ||
      type === 'kycAadhar'
    ) {
      if (type === 'kycPAN') stages.enterpriseSetup.kycDocuments.pan = value
      else if (type === 'kycAadhar') {
        stages.enterpriseSetup.kycDocuments.aadhar = value
        let aadhar_regex = /^\d{0,12}$/
        if (aadhar_regex.test(value)) {
          this.setState({ aadharError: false })
        } else {
          this.setState({ aadharError: true })
          this.notifyError('Please enter valid aadhar!')
          return
        }
      } else if (type === 'kycUdyogAadhar')
        stages.enterpriseSetup.kycDocuments.udyogAadhar = value
    } else stages['enterpriseSetup'][type] = value
    if (
      type !== 'entityName' &&
      type !== 'officeShopFactoryAddress' &&
      type !== 'officeShopFactoryAddressUrlLat' &&
      type !== 'officeShopFactoryAddressUrlLong' &&
      type !== 'entrepreneurStory' &&
      type !== 'bankAccountNum' &&
      type !== 'bankIFSC' &&
      type !== 'kycPAN' &&
      type !== 'kycUdyogAadhar' &&
      type !== 'kycAadhar' &&
      type !== 'recognizedSupport'
    ) {
      if (
        ['Started up', 'Scaled up'].includes(
          this.state.stages.enterpriseSetup.enterpriseSetupStatus
        )
      ) {
        if (this.checkIfEnterpriseDataIsValid(stages, type, value)) {
          this.writeData(stages, type, value)
        } else {
          this.overwriteSetupInfo(stages, type, value)
        }
      } else {
        this.writeData(stages, type, value)
      }
    } else {
      this.setState({ stages })
    }
  }

  overwriteSetupInfo = (stages, type, value) => {
    Swal.fire({
      title: 'Are you sure?',
      html: 'Are you sure to continue? This action moves back the candidate to the previous stage as some fields are mandatory.',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Yes, Proceed',
      confirmButtonAriaLabel: 'Yes, Proceed',
      cancelButtonText: 'No, Cancel',
      cancelButtonAriaLabel: 'No, Cancel',
    }).then(result => {
      if (result.value) {
        this.writeData(stages, type, value, true)
      } else {
        this.fetchLeadMaturityData()
        this.notifySuccess('Changes were not saved!')
      }
    })
  }

  checkIfEnterpriseDataIsValid = (stages, type, value) => {
    if (type && value) {
      stages[type] = value
    }
    return (
      stages.enterpriseSetup.entityName &&
      ((stages.enterpriseSetup.creationMonth &&
        stages.enterpriseSetup.creationYear) ||
        stages.enterpriseSetup.createdOn) &&
      ((stages.enterpriseSetup.kycDocuments.pan &&
        stages.enterpriseSetup.kycDocuments.pan.length === 10) ||
        (stages.enterpriseSetup.kycDocuments.aadhar &&
          stages.enterpriseSetup.kycDocuments.aadhar.length === 12 &&
          !this.state.aadharError) ||
        (stages.enterpriseSetup.kycDocuments.udyogAadhar &&
          stages.enterpriseSetup.kycDocuments.udyogAadhar.length === 12)) &&
      stages.enterpriseSetup.enterpriseRegistered &&
      stages.enterpriseSetup.udyogAadharCertificateReceived &&
      stages.enterpriseSetup.gstCertificate &&
      stages.enterpriseSetup.otherLicenses &&
      google_maps_url_regex.test(
        stages.enterpriseSetup.googleBusinessLocationUrl
      ) &&
      stages.enterpriseSetup.certificateOfShopAndEstablishmentAct &&
      stages.enterpriseSetup.digitalPayment &&
      stages.enterpriseSetup.hasInsurance &&
      stages.enterpriseSetup.gemsPortalRegistered &&
      stages.enterpriseSetup.officeShopFactoryAddress &&
      stages.enterpriseSetup.officeShopFactoryAddressUrl &&
      stages.enterpriseSetup.officeShopFactoryAddressUrl.latitude &&
      stages.enterpriseSetup.officeShopFactoryAddressUrl.longitude &&
      stages.enterpriseSetup.supportReceived &&
      stages.enterpriseSetup.entrepreneurStory &&
      stages.enterpriseSetup.otherImageUrls &&
      stages.enterpriseSetup.bankName &&
      stages.enterpriseSetup.bankIFSC &&
      stages.enterpriseSetup.recognizedSupport &&
      this.state.verifyingIFSC !== 'Failed' &&
      stages.enterpriseSetup.otherImageUrls.length &&
      ((stages.enterpriseSetup.enterpriseRegistered === 'Yes' &&
        stages.enterpriseSetup.entityType) ||
        stages.enterpriseSetup.enterpriseRegistered === 'No')
    )
  }
  writeData = (stages, type, value, moveBack) => {
    fetch(
      moveBack
        ? process.env.REACT_APP_API_URL +
        '/api/v1/lead-maturity/' +
        this.props.leadId +
        '/enterpriseSetup?moveBack=true'
        : process.env.REACT_APP_API_URL +
        '/api/v1/lead-maturity/' +
        this.props.leadId +
        '/enterpriseSetup',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': JSON.parse(readCookie('access_token')),
        },
        body: JSON.stringify({ [type]: value }),
      }
    )
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          this.setState({ stages })
          this.fetchLeadMaturityData()
        } else {
          this.notifyError(data.errorMsg)
        }
      })
  }

  checkProfileCompletionErrors = cb => {
    let errorObj = {},
      leadData = this.props.leadData,
      error = false

    // if (this.state.mobileNumberStatus !== 'ok') { errorObj['mobileNumber'] = 'Invalid Mobile Number!'; error = true; }
    if (leadData.basic.altMobileNumber) {
      if (leadData.basic.altMobileNumber.match(altMobileRegex) === null) {
        errorObj['altMobileNumber'] = 'Invalid Alt-Mobile Number!'
        error = true
      }
    }
    if (!leadData.basic.name || !fullNameRegex.test(leadData.basic.name)) {
      errorObj['name'] = 'Invalid Full Name!'
      error = true
    }
    if (!leadData.basic.address.state) {
      errorObj['state'] = 'Invalid State!'
      error = true
    }
    if (!leadData.basic.address.district) {
      errorObj['district'] = 'Invalid District!'
      error = true
    }
    if (!leadData.basic.address.city) {
      errorObj['city'] = 'Invalid City!'
      error = true
    }
    if (!leadData.basic.address.block) {
      errorObj['block'] = 'Invalid Block!'
      error = true
    }
    if (!leadData.basic.address.line1) {
      errorObj['addressLine1'] = 'Invalid Address Line 1!'
      error = true
    }
    // if (!leadData.basic.phase) { errorObj['phase'] = 'Invalid Phase!'; error = true; }
    if (!leadData.enterpriseStatus.phase) {
      errorObj['phase'] = 'Invalid Phase!'
      error = true
    } else if (leadData.enterpriseStatus.phase === 'Scale-up') {
      if (!leadData.enterpriseStatus.creditLinked) {
        errorObj['creditLinked'] = 'Please select a correct value!'
        error = true
      }
    }
    if (!leadData.basic.gender) {
      errorObj['gender'] = 'Invalid Gender!'
      error = true
    }
    // if (!leadData.basic.pincode) { errorObj['pincode'] = 'Invalid Pincode!'; error = true; }
    if (!leadData.basic.generatedThrough) {
      errorObj['generatedThrough'] = 'Invalid Generated Through!'
      error = true
    }
    if (JSON.parse(readCookie('userData')).type !== 'partners') {
      if (!leadData.leadInfo.userType) {
        errorObj['userType'] = 'Invalid User Type!'
        error = true
      }
      if (!leadData.leadInfo.assignTo) {
        errorObj['assignTo'] = 'Invalid Assigned To!'
        error = true
      }
    }

    if (!leadData.enterpriseStatus.hasABusinessIdea) {
      errorObj['hasABusinessIdea'] = 'Invalid Business Idea selected!'
      error = true
    }
    if (!leadData.enterpriseStatus.financeType) {
      errorObj['financeType'] = 'Invalid Finance Status selected!'
      error = true
    } else if (
      ['Bank Loan required', '100% self-financed'].indexOf(
        leadData.enterpriseStatus.financeType
      ) === -1
    ) {
      errorObj['financeType'] = 'Invalid Finance Status selected!'
      error = true
    }
    if (leadData.basic.altMobileNumber === leadData.basic.mobileNumber) {
      errorObj['altMobileNumber'] =
        "Alternate mobile no. can't be same as the primary number!"
      error = true
    } else if (
      leadData.basic.altMobileNumber.length &&
      leadData.basic.altMobileNumber.length !== 10
    ) {
      errorObj['altMobileNumber'] =
        'Alternate mobile number should be a valid 10 digit mobile number!'
      error = true
    }
    if (
      leadData.enterpriseStatus.canSelfFinanceTheCapitalRequiredUpToINR === ''
    ) {
      errorObj['canSelfFinanceTheCapitalRequiredUpToINR'] =
        'Invalid self finance amount!'
      error = true
    } else if (
      parseInt(
        leadData.enterpriseStatus.canSelfFinanceTheCapitalRequiredUpToINR
      ) < 1000
    ) {
      errorObj['canSelfFinanceTheCapitalRequiredUpToINR'] =
        'Minimum Self finance amount is 1000 INR!'
      error = true
    }
    if (
      leadData.enterpriseStatus.financeType === 'Bank Loan required' &&
      !leadData.enterpriseStatus.loanAmountRequired
    ) {
      errorObj['loanAmountRequired'] = 'Invalid loan amount!'
      error = true
    }
    if (leadData.enterpriseStatus.loanAmountRequired) {
      if (parseInt(leadData.enterpriseStatus.loanAmountRequired) < 1000) {
        errorObj['loanAmountRequired'] = 'Minimum loan amount is 1000 INR!'
        error = true
      }
    }
    if (
      leadData.enterpriseStatus.hasABusinessIdea &&
      leadData.enterpriseStatus.hasABusinessIdea !== 'None'
    ) {
      if (!leadData.enterpriseStatus.businessIdeas.length) {
        errorObj['businessIdeas'] = 'Invalid business ideas enlisted!'
        error = true
      } else {
        let businessIdeasError = false
        for (
          let i = 0;
          i < leadData.enterpriseStatus.businessIdeas.length;
          i++
        ) {
          if (
            !leadData.enterpriseStatus.businessIdeas[i].enterpriseIdea ||
            !leadData.enterpriseStatus?.businessIdeas[i].enterpriseCategory ||
            !leadData.enterpriseStatus.businessIdeas[i].ideaDetails ||
            !leadData.enterpriseStatus.businessIdeas[i].easeOfIdeaExecution ||
            !leadData.enterpriseStatus.businessIdeas[i].confidenceOfDemand ||
            !leadData.enterpriseStatus.businessIdeas[i].confidenceOfSupply
          )
            businessIdeasError = true
        }
        if (businessIdeasError) {
          errorObj['businessIdeas'] =
            'Please fill the mandatory fields for the business ideas enlisted!'
          error = true
        }
      }
    }
    if (
      [null, undefined].includes(
        leadData.enterpriseStatus.appliedForEnterpriseLoanBefore
      )
    ) {
      errorObj['appliedForEnterpriseLoanBefore'] =
        'Please select a correct value!'
      error = true
    }
    if (!leadData.leadMaturity.skillTrained.skillTrainedStatus) {
      errorObj['skillTrainedStatus'] = 'Please select a skill training status!'
      error = true
    }
    // else if (["Skill training not required", "Skill training pending", "Skill training ongoing", "Skill training completed and has certificate", "Skill training completed but no certificate"].indexOf(leadData.leadMaturity.skillTrainedStatus) === -1) { errorObj['skillTrainedStatus'] = 'Please select a skill training status!'; error = true; }
    else {
      if (
        [
          'Skill training ongoing',
          'Skill training completed and has certificate',
          'Skill training completed but no certificate',
        ].indexOf(leadData.leadMaturity.skillTrainedStatus) > -1
      ) {
        if (!leadData.leadMaturity.skillTrainingInstituteType) {
          errorObj['skillTrainingInstituteType'] =
            'Invalid skill training institute type!'
          error = true
        }
        if (!leadData.leadMaturity.skillTrainingInstituteName) {
          errorObj['skillTrainingInstituteName'] =
            'Invalid skill training institute name!'
          error = true
        }
        if (!leadData.leadMaturity.skillTrainingInstituteLocation) {
          errorObj['skillTrainingInstituteLocation'] =
            'Invalid skill training institute location!'
          error = true
        }
      }
    }
    if (!leadData.leadMaturity.enterpriseTrained.enterpriseTrainedStatus) {
      errorObj['enterpriseTrainedStatus'] =
        'Please select a EDP training status!'
      error = true
    } else {
      if (
        [
          'EDP ongoing',
          'Completed EDP with certificate',
          'Completed EDP without certificate',
        ].indexOf(leadData.leadMaturity.enterpriseTrainedStatus) > -1
      ) {
        if (!leadData.leadMaturity.enterpriseTrainingInstituteType) {
          errorObj['enterpriseTrainingInstituteType'] =
            'Invalid EDP training institute type!'
          error = true
        }
        if (!leadData.leadMaturity.enterpriseTrainingInstituteName) {
          errorObj['enterpriseTrainingInstituteName'] =
            'Invalid EDP training institute name!'
          error = true
        }
        if (!leadData.leadMaturity.enterpriseTrainingInstituteLocation) {
          errorObj['enterpriseTrainingInstituteLocation'] =
            'Invalid EDP training institute location!'
          error = true
        }
      }
    }
    if (
      leadData.enterpriseStatus.hasABusinessIdea !== 'None' &&
      !leadData.familyAndAsset.familyBackground
    ) {
      errorObj['familyBackground'] = 'Invalid Family Background selected!'
      error = true
    }
    if (
      leadData.enterpriseStatus.hasABusinessIdea !== 'None' &&
      leadData.familyAndAsset.experienceInSector === ''
    ) {
      errorObj['experienceInSector'] = 'Invalid experience in sector value!'
      error = true
    }

    if (!leadData.basic.educationalQualification) {
      errorObj['educationalQualification'] =
        'Invalid educational qualification selected!'
      error = true
    } else if (
      ['Diploma', 'graduate', 'post graduate', 'Doctorate'].indexOf(
        leadData.basic.educationalQualification
      ) > -1
    ) {
      if (!leadData.basic.specializationOfEducation) {
        errorObj['specializationOfEducation'] =
          'Invalid specialization of education selected!'
        error = true
      }
    }
    if (!leadData.basic.category) {
      errorObj['category'] = 'Invalid category selected!'
      error = true
    }
    if (!leadData.basic.pwd) {
      errorObj['pwd'] = 'Invalid selection!'
      error = true
    }
    if (!leadData.basic.employmentStatus) {
      errorObj['employmentStatus'] = 'Invalid employment status selected!'
      error = true
    }
    if (!leadData.basic.currentAnnualIncome) {
      errorObj['currentAnnualIncome'] =
        'Invalid current annual income selected!'
      error = true
    }
    if (
      !leadData.basic.experience &&
      parseInt(leadData.basic.experience) !== 0
    ) {
      errorObj['experience'] = 'Invalid total work experience!'
      error = true
    }
    if (leadData.basic.numberOfFamilyMember === '') {
      errorObj['numberOfFamilyMember'] =
        'Invalid total number of family members!'
      error = true
    }
    if (leadData.basic.numberOfDependents === '') {
      errorObj['numberOfDependents'] = 'Invalid total number of dependents!'
      error = true
    }
    // if (!leadData.basic.basicAndStability) { errorObj['basicAndStability'] = 'Invalid option selected!'; error = true; }
    // else if (["Stable (Ownership of assets (house/land/shop) by individual/family)", "Somewhat stable (No dependents, Other earning members in the family)", "Unstable (Only earning member, with dependents)"].indexOf(leadData.basic.basicAndStability) === -1) { errorObj['basicAndStability'] = 'Invalid option selected!'; error = true; }
    if (
      !leadData.basic.dob ||
      !moment(leadData.basic.dob).isValid() ||
      moment(leadData.basic.dob).year() < 1900
    ) {
      errorObj['dob'] = 'Invalid date of birth selected!'
      error = true
    } else if (moment(leadData.basic.dob).isValid()) {
      if (moment().diff(moment(leadData.basic.dob), 'years') < 14) {
        errorObj['dob'] = 'Invalid date of birth selected!'
        error = true
      }
    }
    if (!leadData.basic.identityType.length) {
      errorObj['identityType'] = 'No options were selected!'
      error = true
    }

    if ([undefined, null].includes(leadData.familyAndAsset.hasLand)) {
      errorObj['hasLand'] = 'Invalid selection!'
      error = true
    }
    // else if (leadData.familyAndAsset.hasLand === 'Yes') {
    //   if (!leadData.familyAndAsset.relationshipWithLandOwner) { errorObj['relationshipWithLandOwner'] = 'Invalid relationship selected!'; error = true; }
    // }
    // if (!leadData.familyAndAsset.collateral) { errorObj['collateral'] = 'Invalid selection!'; error = true; }
    // if (!leadData.familyAndAsset.hasBankAccount) { errorObj['hasBankAccount'] = 'Invalid selection!'; error = true; }
    // else if (leadData.familyAndAsset.hasBankAccount === 'Yes') {
    //   if (!leadData.familyAndAsset.bankAccounts.length) { errorObj['bankAccounts'] = 'Please select atleast one Bank!'; error = true; }
    //   if (!leadData.familyAndAsset.proximityToBank) { errorObj['proximityToBank'] = 'Invalid selection!'; error = true; }
    // }
    // if (!leadData.familyAndAsset.receivedBankLoan) { errorObj['receivedBankLoan'] = 'Invalid selection!'; error = true; }
    // else if (leadData.familyAndAsset.receivedBankLoan !== 'Never taken a loan') {
    //   if (["Never taken a loan", "Loan repaid", "Loan taken and ongoing", "Loan taken and defaulted"].indexOf(leadData.familyAndAsset.receivedBankLoan) === -1) { errorObj['receivedBankLoan'] = 'Invalid selection!'; error = true; }
    //   if (!leadData.familyAndAsset.loanType) { errorObj['loanType'] = 'Invalid type of loan selected!'; error = true; }
    //   if (!leadData.familyAndAsset.receivedLoanProviderType) { errorObj['receivedLoanProviderType'] = 'Invalid type of loan provider selected!'; error = true; }
    //   if (leadData.familyAndAsset.receivedBankLoan === 'Loan taken and ongoing' && !leadData.familyAndAsset.outstandingLoanAmount) { errorObj['outstandingLoanAmount'] = 'Invalid outstanding loan amount!'; error = true; }
    //   else if (leadData.familyAndAsset.receivedBankLoan === 'Loan taken and ongoing' && leadData.familyAndAsset.outstandingLoanAmount) {
    //     if (parseInt(leadData.familyAndAsset.outstandingLoanAmount) < 1000) { errorObj['outstandingLoanAmount'] = 'Minimum outstanding loan amount is 1000 INR!'; error = true; }
    //   }
    // }
    // if (!leadData.familyAndAsset.genuinenessAndHumility) { errorObj['genuinenessAndHumility'] = 'Invalid value selected!'; error = true; }
    // else if (["Very genuine and humble", "Somewhat genuine and humble", "Not genuine and passionate"].indexOf(leadData.familyAndAsset.genuinenessAndHumility) === -1) { errorObj['genuinenessAndHumility'] = 'Invalid value selected!'; error = true; }
    // if (!leadData.familyAndAsset.confidenceAsSwavalambi) { errorObj['confidenceAsSwavalambi'] = 'Invalid value selected!'; error = true; }
    if (!leadData.leadScoreAndSentiment.overallSentiment) {
      errorObj['overallSentiment'] = 'Invalid value selected!'
      error = true
    }
    if (!leadData.leadScoreAndSentiment.tentativeHorizonToCloseThis) {
      errorObj['tentativeHorizonToCloseThis'] = 'Invalid value selected!'
      error = true
    }

    // EXISTING BUSINESS DETAILS SECTION ERROR CHECK
    // businessStartMonth, registrationProof, hasGstRegistration, gstCertMonthYear, gstFilingMeans, filesIT, proofOfSalesAndPurchase, issuesCheques, businessBankAccountType, bankAccountActive, averageMonthlyTxnSize,
    // maintainAccountBooks, businessPremisesOwnership, monthlyRent, premisesArea, salesFigures
    //

    let existingBusinessErrors = {}

    if (
      leadData.enterpriseStatus.phase === 'Scale-up' &&
      leadData.existingBusinessDetails
    ) {
      let {
        businessStartMonth,
        // registrationProof,
        hasGstRegistration,
        gstCertMonthYear,
        gstFilingMeans,
        filesIT,
        proofOfSalesAndPurchase,
        issuesCheques,
        businessBankAccountType,
        bankAccountActive,
        averageMonthlyTxnSize,
        maintainAccountBooks,
        businessPremisesOwnership,
        monthlyRent,
        premisesArea,
        salesFigures,
      } = leadData.existingBusinessDetails
      if (!businessStartMonth) {
        existingBusinessErrors.businessStartMonth =
          'Please fill in month and year of starting business'
        error = true
      } else existingBusinessErrors.businessStartMonth = ''
      // if (!registrationProof) {existingBusinessErrors.registrationProof = "Please select at least one registration proof!"; error = true;} else existingBusinessErrors.registrationProof = "";
      if (!salesFigures) {
        existingBusinessErrors.salesFigures = 'Please mention the revenue'
        error = true
      } else existingBusinessErrors.salesFigures = ''
      if (!hasGstRegistration) {
        existingBusinessErrors.hasGstRegistration =
          'Please fill if the business has GST registration'
        error = true
      } else existingBusinessErrors.hasGstRegistration = ''
      if (hasGstRegistration === 'Yes' && !gstCertMonthYear) {
        existingBusinessErrors.gstCertMonthYear =
          'Please enter the month and year of GST certificate.'
        error = true
      } else existingBusinessErrors.gstCertMonthYear = ''
      if (hasGstRegistration === 'Yes' && !gstFilingMeans) {
        existingBusinessErrors.gstFilingMeans =
          'Please enter the how you file your GST.'
        error = true
      } else existingBusinessErrors.gstFilingMeans = ''
      if (!filesIT) {
        existingBusinessErrors.filesIT = 'Please mention if IT filing is done.'
        error = true
      } else existingBusinessErrors.filesIT = ''
      if (!proofOfSalesAndPurchase) {
        existingBusinessErrors.proofOfSalesAndPurchase =
          'Please mention if there are sales and purchase proofs.'
        error = true
      } else existingBusinessErrors.proofOfSalesAndPurchase = ''
      if (!issuesCheques) {
        existingBusinessErrors.issuesCheques =
          'Please specify if the business issues cheques to its customer.'
        error = true
      } else existingBusinessErrors.issuesCheques = ''
      if (!businessBankAccountType) {
        existingBusinessErrors.businessBankAccountType =
          'Please specify the kind of bank account used with business.'
        error = true
      } else existingBusinessErrors.businessBankAccountType = ''
      if (!bankAccountActive) {
        existingBusinessErrors.bankAccountActive =
          'Please mention if the bank account is active in the last 6 months.'
        error = true
      } else existingBusinessErrors.bankAccountActive = ''
      if (!averageMonthlyTxnSize) {
        existingBusinessErrors.averageMonthlyTxnSize =
          'Please fill the average monthly transaction size!'
        error = true
      } else existingBusinessErrors.averageMonthlyTxnSize = ''
      if (!maintainAccountBooks) {
        existingBusinessErrors.maintainAccountBooks =
          'Please specify if an account book is maintained.'
        error = true
      } else existingBusinessErrors.maintainAccountBooks = ''
      if (!businessPremisesOwnership) {
        existingBusinessErrors.businessPremisesOwnership =
          'Please specify the type of ownership of the business premises.'
        error = true
      } else existingBusinessErrors.businessPremisesOwnership = ''
      if (businessPremisesOwnership === 'Rented' && !monthlyRent) {
        existingBusinessErrors.monthlyRent = 'Please enter monthly rent!'
        error = true
      } else existingBusinessErrors.monthlyRent = ''
      if (!premisesArea) {
        existingBusinessErrors.premisesArea =
          'Please specify the business premises area!'
        error = true
      } else existingBusinessErrors.premisesArea = ''
    }

    if (existingBusinessErrors && Object.keys(existingBusinessErrors).length)
      errorObj.existingBusinessErrors = existingBusinessErrors
    this.setState({
      profileCompletionErrorObj: errorObj,
      profileCompletionError: error,
    })
  }

  enterpriseSetupFileChange = (type, e) => {
    let input = e.target,
      files = e.target.files,
      stages = this.state.stages
    if (files.length > 0 && files.length < 6) {
      if (type !== 'otherImageFiles') files = files[0]
      this.setState({ [type]: files }, () => {
        let formData = new FormData()
        if (type !== 'otherImageFiles') formData.append(type, files)
        else {
          for (let x = 0; x < files.length; x++) {
            formData.append(type, files[x])
          }
        }

        fetch(
          process.env.REACT_APP_API_URL +
          '/api/v1/lead-maturity/' +
          this.props.leadId +
          '/enterpriseSetup',
          {
            method: 'POST',
            headers: {
              'x-auth-token': JSON.parse(readCookie('access_token')),
            },
            body: formData,
          }
        )
          .then(data => data.json())
          .then(data => {
            if (data.status) {
              let key = type.replace('File', 'Url')
              stages['enterpriseSetup'][key] = data.enterpriseSetup[key]
              $(input).val(null)
              this.setState({ stages, [type]: null })
            } else {
              this.notifyError(data.errorMsg)
            }
          })
      })
    } else if (files.length > 5) {
      $(input).val(null)
      this.notifyError('Maximum 5 photos can be uploaded!')
    }
  }

  enterpriseSetupBlurChange = (type, e) => {
    let stages = this.state.stages,
      value = stages.enterpriseSetup[type]
    if (type === 'recognizedSupport') {
      let supportError = value.match(
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{1,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      )
      let stages = this.state.stages
      stages.enterpriseSetup.recognizedSupport = value
      this.setState({
        supportError: supportError ? 'Please enter valid contact info' : null,
        stages,
      })
      if (supportError) {
        return
      }
    }
    if (type === 'bankIFSC') {
      if (!this.state.stages.enterpriseSetup.bankName) {
        this.notifyError('Please select the Bank')
        this.setState({ verifyingIFSC: 'Failed' })
      } else {
        this.setState({ verifyingIFSC: 'Verifying' })
        fetch(
          process.env.REACT_APP_API_URL +
          '/api/v1/bank-branches/verify-ifsc/' +
          value,
          {
            method: 'GET',
            headers: {
              'x-auth-token': JSON.parse(readCookie('access_token')),
            },
          }
        )
          .then(data => data.json())
          .then(data => {
            if (data.status) {
              if (!data.bank) {
                this.notifyError('Please select the Bank with this IFSC')
                this.setState({ verifyingIFSC: 'Failed' })
              } else {
                this.setState({ verifyingIFSC: data.result })
                if (
                  ['Started up', 'Scaled up'].includes(
                    this.state.stages.enterpriseSetup.enterpriseSetupStatus
                  )
                ) {
                  if (this.checkIfEnterpriseDataIsValid(stages, type, value)) {
                    this.writeData(stages, type, value)
                  } else {
                    this.overwriteSetupInfo(stages, type, value)
                  }
                } else {
                  //   fetch(
                  //   process.env.REACT_APP_API_URL +
                  //   "/api/v1/lead-maturity/" +
                  //   this.props.leadId +
                  //   "/enterpriseSetup",
                  //   {
                  //     method: "POST",
                  //     headers: {
                  //       "Content-Type": "application/json",
                  //       "x-auth-token": JSON.parse(readCookie("access_token")),
                  //     },
                  //     body: JSON.stringify({ [type]: value }),
                  //   }
                  // )
                  //   .then((data) => data.json())
                  //   .then((data) => {
                  //     if (data.status) {
                  //       this.setState({ stages });
                  //     } else {
                  //       this.notifyError(data.errorMsg);
                  //     }
                  //   });
                  this.writeData(stages, type, value)
                }
              }
            } else {
              this.notifyError(data.errorMsg)
              this.setState({ verifyingIFSC: data.result })
            }
          })
          .catch(err => {
            this.notifyError('Invalid Bank IFSC')
            this.setState({ verifyingIFSC: 'Failed' })
          })
      }
    } else {
      if (
        type === 'kycPAN' ||
        type === 'kycUdyogAadhar' ||
        (type === 'kycAadhar' && !this.state.aadharError)
      ) {
        type = 'kycDocuments'
        value = stages.enterpriseSetup.kycDocuments
      }
      if (
        ['Started up', 'Scaled up'].includes(
          this.state.stages.enterpriseSetup.enterpriseSetupStatus
        )
      ) {
        if (this.checkIfEnterpriseDataIsValid(stages, type, value)) {
          this.writeData(stages, type, value)
        } else {
          this.overwriteSetupInfo(stages, type, value)
        }
      } else {
        //   fetch(
        //   process.env.REACT_APP_API_URL +
        //   "/api/v1/lead-maturity/" +
        //   this.props.leadId +
        //   "/enterpriseSetup",
        //   {
        //     method: "POST",
        //     headers: {
        //       "Content-Type": "application/json",
        //       "x-auth-token": JSON.parse(readCookie("access_token")),
        //     },
        //     body: JSON.stringify({ [type]: value }),
        //   }
        // )
        //   .then((data) => data.json())
        //   .then((data) => {
        //     if (data.status) {
        //       this.setState({ stages });
        //     } else {
        //       this.notifyError(data.errorMsg);
        //     }
        //   });
        this.writeData(stages, type, value)
      }
      // fetch(
      //   process.env.REACT_APP_API_URL +
      //   "/api/v1/lead-maturity/" +
      //   this.props.leadId +
      //   "/enterpriseSetup",
      //   {
      //     method: "POST",
      //     headers: {
      //       "Content-Type": "application/json",
      //       "x-auth-token": JSON.parse(readCookie("access_token")),
      //     },
      //     body: JSON.stringify({ [type]: value }),
      //   }
      // )
      //   .then((data) => data.json())
      //   .then((data) => {
      //     if (data.status) {
      //       this.setState({ stages });
      //     } else {
      //       this.notifyError(data.errorMsg);
      //     }
      //   });
    }
  }

  showIFSCIcon = () => {
    let verifyingIFSC = this.state.verifyingIFSC
    if (verifyingIFSC === 'Verified') {
      return (
        <Icon style={{ marginBottom: 6 }} type="check" title="IFSC Verified" />
      )
    } else if (verifyingIFSC === 'Verifying') {
      return (
        <Icon
          style={{ marginBottom: 6 }}
          type="loading"
          title="Verifying IFSC"
        />
      )
    } else if (verifyingIFSC === 'Failed') {
      return (
        <Icon style={{ marginBottom: 6 }} type="warning" title="Invalid IFSC" />
      )
    } else return null
  }

  createBusinessPlan = () => {
    this.refreshLeadMaturity = setInterval(() => {
      if (this.state.stages.businessPlanReady.businessPlanId)
        clearInterval(this.refreshLeadMaturity)
      else this.fetchLeadMaturityData(false)
    }, 2000)

    window.open(
      process.env.REACT_APP_BPLAN_FRONTEND_URL +
      '/v2/new-bplan?token=' +
      JSON.parse(readCookie('access_token')) +
      '&lead=' +
      this.props.leadId +
      '&projectId=' +
      this.props.projectId,
      '_blank'
    )
  }

  uploadBusinessPlan = () => {
    this.setState({ uploadingBusinessPlan: true })
  }

  pasteLinkToBusinessPlan = () => {
    this.setState({ pastingLinkToBusinessPlan: true })
  }

  cancelChangeBusinessPlan = () => {
    this.setState({
      uploadingBusinessPlan: false,
      uploadingBusinessPlanFile: null,
      pastingLinkToBusinessPlan: false,
      linkToBusinessPlan: '',
    })
  }

  uploadingBusinessPlanChange = e => {
    this.setState({ uploadingBusinessPlanFile: e.target.files[0] })
  }

  linkToBusinessPlanChange = e => {
    this.setState({ linkToBusinessPlan: e.target.value })
  }

  saveBusinessPlan = () => {
    let stages = this.state.stages,
      formData = new FormData()
    if (
      this.state.uploadingBusinessPlan &&
      this.state.uploadingBusinessPlanFile
    )
      formData.append(
        'uploadingBusinessPlanFile',
        this.state.uploadingBusinessPlanFile
      )
    else if (
      this.state.pastingLinkToBusinessPlan &&
      this.state.linkToBusinessPlan
    )
      formData.append('linkToBusinessPlan', this.state.linkToBusinessPlan)

    fetch(
      process.env.REACT_APP_API_URL +
      '/api/v1/lead-maturity/' +
      this.props.leadId +
      '/businessPlanReady',
      {
        method: 'POST',
        headers: {
          'x-auth-token': JSON.parse(readCookie('access_token')),
        },
        body: formData,
      }
    )
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          stages['businessPlanReady'] = data.businessPlanReady
          stages.businessPlanReady.updatedBy = this.getCurrentUpdatedByObj()
          this.setState({
            stages,
            pastingLinkToBusinessPlan: false,
            uploadingBusinessPlanFile: null,
            uploadingBusinessPlan: false,
            linkToBusinessPlan: '',
            showBusinessPlanEdit: false,
          })
        } else {
          this.notifyError(data.errorMsg)
        }
      })
  }

  markBPlanVerified = () => {
    fetch(
      process.env.REACT_APP_API_URL +
      '/api/v1/swati-leads/' +
      this.props.leadId +
      '/verify-business-plan',
      {
        method: 'GET',
        headers: {
          'x-auth-token': JSON.parse(readCookie('access_token')),
        },
      }
    )
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          this.notifySuccess(data.message)
        } else if (data.errorMessage) this.notifyError(data.errorMessage)
      })
  }

  viewBPlan = bplan => {
    window.open(
      process.env.REACT_APP_BPLAN_FRONTEND_URL +
      '/bplan/' +
      bplan.businessPlanId +
      '?lead=' +
      this.props.leadId +
      '?token=' +
      JSON.parse(readCookie('access_token')),
      '_blank'
    )
  }

  editBPlan = bplan => {
    if (bplan.businessPlanUrl) {
      this.setState({ showBusinessPlanEdit: true })
    } else {
      const BPLAN_VERSION_REVISION_DATE = moment()
        .date(22)
        .month(5)
        .year(2022)
        .hours(20)
        .toDate()
      const bplan_version =
        BPLAN_VERSION_REVISION_DATE >
          moment(this.state.stages.businessPlanReady.createdAt).toDate()
          ? ''
          : '/v2'

      console.log(
        'MY URL:',
        process.env.REACT_APP_BPLAN_FRONTEND_URL +
        bplan_version +
        '/edit-bplan/' +
        bplan.businessPlanId +
        '?token=' +
        JSON.parse(readCookie('access_token')) +
        '&lead=' +
        this.props.leadId,
        '_blank'
      )
      window.open(
        process.env.REACT_APP_BPLAN_FRONTEND_URL +
        bplan_version +
        '/edit-bplan/' +
        bplan.businessPlanId +
        '?token=' +
        JSON.parse(readCookie('access_token')) +
        '&lead=' +
        this.props.leadId,
        '_blank'
      )
    }
  }

  updateBplan = () => {
    Swal.fire({
      title: 'Are you sure?',
      html: 'Updating B-plan is recommended only when there is a change in the business template. This will replace the existing B-plan.',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Yes, Proceed',
      confirmButtonAriaLabel: 'Yes, Proceed',
      cancelButtonText: 'No, Cancel',
      cancelButtonAriaLabel: 'No, Cancel',
    }).then(result => {
      if (result.value) {
        // fetch(
        //   process.env.REACT_APP_API_URL +
        //   "/api/v1/swati-leads/" +
        //   this.props.leadId +
        //   "?discardBplan=true",
        //   {
        //     method: "PATCH",
        //     headers: {
        //       "x-auth-token": JSON.parse(readCookie("access_token")),
        //     },
        //   }
        // )
        //   .then((data) => data.json())
        //   .then((data) => {
        //     if (data.status) {
        this.createBusinessPlan()
        //     this.notifySuccess(
        //       "The Business Plan has been deleted successfully!"
        //     );
        //     window.location.reload();
        //   } else {
        //     this.notifyError("Could not update lead");
        //   }
        // });
      }
    })
  }

  deleteBPlan = () => {
    Swal.fire({
      title: 'Are you sure?',
      html: 'Are you sure you want to delete this B-plan? Doing so will make the candidate move back to the Bplan stage and lock the subsequent stages.',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Yes, Delete',
      confirmButtonAriaLabel: 'Yes, Delete',
      cancelButtonText: 'No, Cancel',
      cancelButtonAriaLabel: 'No, Cancel',
    }).then(result => {
      if (result.value) {
        fetch(
          process.env.REACT_APP_API_URL +
          '/api/v1/swati-leads/' +
          this.props.leadId +
          '?discardBplan=true',
          {
            method: 'PATCH',
            headers: {
              'x-auth-token': JSON.parse(readCookie('access_token')),
            },
          }
        )
          .then(data => data.json())
          .then(data => {
            if (data.status) {
              this.notifySuccess(
                'The Business Plan has been deleted successfully!'
              )
              window.location.reload()
            } else {
              this.notifyError('Could not update lead')
            }
          })
      }
    })
  }

  hideBusinessPlanEdit = () => {
    this.setState({ showBusinessPlanEdit: false })
  }

  searchFilter = (input, option) => {
    input = input.toLowerCase()
    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
  }

  addNewCheckIn = () => {
    let stages = this.state.stages,
      checkIns = stages.enterpriseSustainability.checkIns
    if (checkIns && checkIns.length) {
      let lastIndex = checkIns.length - 1
      // let nextIndex = checkIns[lastIndex].index + 1;
      if (
        checkIns[lastIndex].checkInDate &&
        checkIns[lastIndex].assessedBy &&
        checkIns[lastIndex].modeOfAssessment &&
        checkIns[lastIndex].operational &&
        checkIns[lastIndex].dailyProfit &&
        checkIns[lastIndex].businessHealth &&
        parseInt(checkIns[lastIndex].jobsCreated) &&
        checkIns[lastIndex].scaleupLoanReqd
      ) {
        checkIns.push({
          index: checkIns[lastIndex].index + 1,
          checkInDate: '',
          assessedBy: '',
          modeOfAssessment: '',
          operational: '',
          dailyProfit: '',
          businessHealth: '',
          jobsCreated: 1,
          developments: '',
          scaleupLoanReqd: 'No',
          reqdLoanValue: 0,
          comments: '',
          creditScore: '',
          creditScoreDoc: this.state.creditScoreDoc,
        })
      } else
        this.notifyError(
          'Please fill in the values of the previous assessment!'
        )
    } else {
      checkIns = [
        {
          index: 0,
          checkInDate: '',
          assessedBy: '',
          modeOfAssessment: '',
          operational: '',
          dailyProfit: '',
          businessHealth: '',
          jobsCreated: 1,
          developments: '',
          scaleupLoanReqd: 'No',
          reqdLoanValue: 0,
          comments: '',
          creditScore: '',
          creditScoreDoc: this.state.creditScoreDoc,
        },
      ]
    }
    stages.enterpriseSustainability.checkIns = checkIns
    this.setState({ stages })
  }

  formatDeleteCheckIn = (cell, row, index) => {
    return (
      <button
        className="btn delete-assessment-btn"
        title="Delete Assessment"
        onClick={this.deleteCheckIn.bind(this, index)}
        disabled={!this.props.isEditable}
      >
        <i className="fa fa-trash" />
      </button>
    )
  }

  formatCheckInAssessee = (cell, row, index) => {
    if (!cell) return JSON.parse(readCookie('userData')).fullName
    else {
      if (
        cell.fullName &&
        cell._id &&
        cell.userType &&
        cell.userType.customUrl
      ) {
        return (
          <a
            href={'/user-types/' + cell.userType.customUrl + '/' + cell._id}
            target="_blank"
            rel="noopener noreferrer"
          >
            {cell.fullName}
          </a>
        )
      } else if (cell.fullName) {
        return cell.fullName
      } else return null
    }
  }

  deleteCheckIn = index => {
    let stages = this.state.stages,
      checkIns = stages.enterpriseSustainability.checkIns
    if (checkIns[index]) checkIns.splice(index, 1)
    let formData = new FormData()
    formData.append('checkIns', JSON.stringify(checkIns))

    fetch(
      process.env.REACT_APP_API_URL +
      '/api/v1/lead-maturity/' +
      this.props.leadId +
      '/enterpriseSustainability',
      {
        method: 'POST',
        headers: {
          'x-auth-token': JSON.parse(readCookie('access_token')),
        },
        body: formData,
      }
    )
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          stages.enterpriseSustainability = data.enterpriseSustainability
          stages.enterpriseSustainability.updatedBy =
            this.getCurrentUpdatedByObj()
          this.setState({ stages })
          this.notifySuccess('The Assessment has been deleted successfully!')
        } else {
          this.notifyError(data.errorMsg)
        }
      })
  }

  checkAndUpdateCheckIns = (oldValue, newValue, row, column) => {
    let stages = this.state.stages,
      checkIns = stages.enterpriseSustainability.checkIns,
      lastIndex = checkIns.length - 1
    if (newValue) {
      if (newValue.scaleupLoanReqd === 'No') newValue.reqdLoanValue = 0
      checkIns[newValue.index] = newValue
    }
    if (
      checkIns[lastIndex].checkInDate &&
      checkIns[lastIndex].modeOfAssessment &&
      checkIns[lastIndex].operational &&
      checkIns[lastIndex].dailyProfit &&
      checkIns[lastIndex].businessHealth &&
      parseInt(checkIns[lastIndex].jobsCreated) &&
      checkIns[lastIndex].scaleupLoanReqd
    ) {
      console.log('hjbscjhbdcvjhbd')
      let formData = new FormData()
      formData.append('checkIns', JSON.stringify(checkIns))
      if (this.state.creditScoreDoc) {
        formData.append('creditScoreDoc', this.state.creditScoreDoc)
        formData.append('rowIndex', this.state.currentIndex)
      }
      fetch(
        process.env.REACT_APP_API_URL +
        '/api/v1/lead-maturity/' +
        this.props.leadId +
        '/enterpriseSustainability',
        {
          method: 'POST',
          headers: {
            'x-auth-token': JSON.parse(readCookie('access_token')),
          },
          'Content-Type': 'multipart/form-data',

          body: formData,
        }
      )
        .then(data => data.json())
        .then(data => {
          if (data.status) {
            console.log('DATATA', data)
            stages.enterpriseSustainability = data.enterpriseSustainability
            stages.enterpriseSustainability.updatedBy =
              this.getCurrentUpdatedByObj()
            this.setState({ stages })
            this.notifySuccess('The Assessment has been updated successfully!')
          } else {
            console.log('errrororor')
            this.notifyError(data.errorMsg)
          }
        })
    } else {
      stages.enterpriseSustainability.checkIns = checkIns
      this.setState({ stages })
    }
  }

  viewScheme = viewScheme => {
    this.setState({ viewScheme })
  }

  hideViewScheme = () => {
    this.setState({ viewScheme: null })
  }

  schemeSearchFilter = (input, option) => {
    input = input.toLowerCase()
    if (!Array.isArray(option.props.children)) {
      if (typeof option.props.children === 'string') {
        return (
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        )
      }
    }
  }

  notifySuccess = text => toast.success(text)
  notifyError = text => toast.error(text)

  updateSelfInvestmentAmount = e => {
    let stages = this.state.stages
    stages.capitalFulfilled.selfInvestmentAmount = e.target.value
    this.setState({ stages })
    let editingLoanApplication = this.state.editingLoanApplication
    if (editingLoanApplication) {
      editingLoanApplication.selfInvestmentAmount = e.target.value
      this.setState({ editingLoanApplication })
    }
  }
  updateGrantAmount = e => {
    let stages = this.state.stages
    stages.capitalFulfilled.grantAmount = e.target.value
    this.setState({ stages })
    let editingLoanApplication = this.state.editingLoanApplication
    if (editingLoanApplication) {
      editingLoanApplication.grantAmount = e.target.value
      this.setState({ editingLoanApplication })
    }
  }
  updateLoanAmountRequired = e => {
    let stages = this.state.stages
    stages.capitalFulfilled.loanAmount = e.target.value
    this.setState({ stages })
    let editingLoanApplication = this.state.editingLoanApplication
    if (editingLoanApplication) {
      editingLoanApplication.loanAmount = e.target.value
      this.setState({ editingLoanApplication })
    }
  }

  saveSelfInvestmentAmount = () => {
    let stages = this.state.stages,
      formData = new FormData()
    formData.append(
      'selfInvestmentAmount',
      stages.capitalFulfilled.selfInvestmentAmount
    )
    formData.append('loanAmount', stages.capitalFulfilled.loanAmount)
    fetch(
      process.env.REACT_APP_API_URL +
      '/trainee/add-capital/' +
      this.props.leadId,
      {
        method: 'POST',
        headers: {
          source: 'humblebee_admin',
          Authorization: 'Bearer ' + JSON.parse(readCookie('access_token')),
        },
        body: formData,
      }
    )
      .then(data => data.json())
      .then(data => {
        if (data.status) {
          stages.capitalFulfilled = data.capitalFulfilled
          stages.capitalFulfilled.updatedBy = this.getCurrentUpdatedByObj()
          this.setState({ stages })
          this.notifySuccess('The Capital Stage has been updated successfully!')
        } else {
          this.notifyError(data.errorMsg)
        }
      })
  }

  updateRecordType = e => {
    console.log('e', e)
    this.setState({ recordType: e })
    let editingLoanApplication = this.state.editingLoanApplication
    if (editingLoanApplication) {
      editingLoanApplication.recordType = e
      this.setState({ editingLoanApplication })
    }
  }


  renderStageButtons = () => {
    const stages = [
      { key: "applied", label: "Loan Applied" },
      { key: "sanctioned", label: "Loan Sanctioned" },
      { key: "disbursed", label: "Loan Disbursed" },
      { key: "transferred", label: "Transferred to Buzzworthy" },
      { key: "rejected", label: "Rejected" }
    ];

    return stages.map(s => (
      <div
        key={s.key}
        onClick={() => this.setState({ selectedStage: s.key })}
        style={{
          padding: "12px 15px",
          marginBottom: 12,
          cursor: "pointer",
          borderRadius: 4,
          background:
            this.state.selectedStage === s.key ? "#DF6F4F" : "#F3F3F3",
          color: this.state.selectedStage === s.key ? "#fff" : "#000",
          fontWeight: 600
        }}
      >
        {s.label}
      </div>
    ));
  };



  getStatusLabel = () => {
    const appType = this.state.selectedApplicationType;
    const st = this.state.selectedStage;

    // Get the actual loan status from data (similar to Show Investment FieldView)
    const actualStatus = this.state.latestLoanData?.loanStatus || this.state.latestLoanData?.status;

    // If we have actual loan data status, use it
    if (actualStatus) {
      return `Loan Status: ${actualStatus.charAt(0).toUpperCase() + actualStatus.slice(1)}`;
    }

    // Fall back to stage-based labels
    if (appType === "self") {
      if (st === "preferred") return "Status: Self Investment Preferred";
      if (st === "transferred") return "Status: Self Investment Transferred";
      return "Self Investment";
    }

    // Loan Flow
    if (st === "rejected") return "Loan Status: Rejected";
    if (st === "sanctioned") return "Status: Loan Sanctioned";
    if (st === "disbursed") return "Status: Loan Disbursed";
    if (st === "transferred") return "Status: Transferred";
    return "Status: Loan Applied";
  };




  // Helper method to determine which stages to show based on loan status
  getVisibleStages = () => {
    const currentStatus = this.state.latestLoanData?.loanStatus || this.state.latestLoanData?.status;

    // Define stage progression order
    const stageOrder = ['applied', 'sanctioned', 'disbursed', 'transferred'];

    // If rejected, show only applied and rejected
    if (currentStatus === 'rejected') {
      return ['applied', 'rejected'];
    }

    // Otherwise, show all stages up to and including current status
    const currentIndex = stageOrder.indexOf(currentStatus);
    if (currentIndex === -1) {
      // If status not found, default to showing just 'applied'
      return ['applied'];
    }

    return stageOrder.slice(0, currentIndex + 1);
  };

  // Helper to check if a stage is completed (before current status)
  isStageCompleted = (stage) => {
    const currentStatus = this.state.latestLoanData?.loanStatus || this.state.latestLoanData?.status;
    const stageOrder = ['applied', 'sanctioned', 'disbursed', 'transferred'];

    const stageIndex = stageOrder.indexOf(stage);
    const currentIndex = stageOrder.indexOf(currentStatus);

    // A stage is completed if it comes before the current status
    return stageIndex < currentIndex && stageIndex !== -1 && currentIndex !== -1;
  };

  renderRightPanel = () => {
    const { selectedStage: st, latestLoanData } = this.state;

    console.log("latestLoanData right panels", latestLoanData);

    // Use empty object if data is missing, so we can still render the structure as requested
    const data = latestLoanData || {};
    const status = data?.status
    console.log("status", status);

    if (st === "applied") {
      return (
        <div>
          <div>Date of Application: <b>{data.dateOfApplication ? moment(data.dateOfApplication).format("D MMM, YYYY") : "-"}</b></div>
          <div>
            Mode of Application:&nbsp;
            {/* Logic: If mode is Online or undefined/null (default), check Online. If Offline, check Offline. */}
            <input type="radio" checked={!data.modeOfApplication || data.modeOfApplication === 'online'} readOnly /> Online
            <input type="radio" checked={data.modeOfApplication === 'offline'} style={{ marginLeft: 8 }} readOnly /> Offline
          </div>

          <div style={{ marginTop: 10 }}>Proof of Application:</div>
          <div style={{ display: "flex", gap: 10, marginTop: 4, flexWrap: "wrap" }}>
            {data.proofOfApplication && Array.isArray(data.proofOfApplication) && data.proofOfApplication.length > 0 ? (
              data.proofOfApplication.map((file, index) => (
                <img
                  key={index}
                  src={file}
                  width="80"
                  height="80"
                  style={{ objectFit: "cover", borderRadius: 4, cursor: "pointer" }}
                  onClick={() => window.open(file, "_blank")}
                  alt="Proof"
                />
              ))
            ) : null}
          </div>

          {/* {this.renderEditDelete()} */}
        </div>
      );
    }

    if (st === "sanctioned") {
      return (
        <div>
          <div>Date of Sanction: <b>{data.dateOfSanction ? moment(data.dateOfSanction).format("D MMM, YYYY") : "-"}</b></div>
          <div>Amount Sanctioned: <b>₹ {data.amountSanctioned || 0}</b></div>
          <div>Reason for Pendency: <b>{data.pendencyReason || "Fund Unavailability"}</b></div>

          {/* Render Proof of Sanction using same structure */}
          <div style={{ marginTop: 10 }}>Proof of Sanction:</div>
          <div style={{ display: "flex", gap: 10, marginTop: 4, flexWrap: "wrap" }}>
            {data.sanctionProof && Array.isArray(data.sanctionProof) && data.sanctionProof.length > 0 ? (
              data.sanctionProof.map((file, index) => (
                <img
                  key={index}
                  src={file}
                  width="80"
                  height="80"
                  style={{ objectFit: "cover", borderRadius: 4, cursor: "pointer" }}
                  onClick={() => window.open(file, "_blank")}
                  alt="Sanction Proof"
                />
              ))
            ) : null}
          </div>

          {/* {this.renderEditDelete()} */}
        </div>
      );
    }

    if (st === "disbursed") {
      return (
        <div>
          <div>Date of Disbursement: <b>{data.disbursement?.date ? moment(data.disbursement.date).format("D MMM, YYYY") : "-"}</b></div>
          <div>Amount Disbursed: <b>₹ {data.disbursement?.amount || 0}</b></div>

          <div style={{ marginTop: 10 }}>Proof of Disbursement:</div>
          <div style={{ display: "flex", gap: 10, marginTop: 4, flexWrap: "wrap" }}>
            {data.disbursement?.proofs && Array.isArray(data.disbursement.proofs) && data.disbursement.proofs.length > 0 ? (
              data.disbursement.proofs.map((file, index) => (
                <img
                  key={index}
                  src={file}
                  width="80"
                  height="80"
                  style={{ objectFit: "cover", borderRadius: 4, cursor: "pointer" }}
                  onClick={() => window.open(file, "_blank")}
                  alt="Disbursement Proof"
                />
              ))
            ) : null}
          </div>

          {/* {this.renderEditDelete()} */}
        </div>
      );
    }

    if (st === "transferred") {
      return (
        <div>
          <div>Date of Transfer: <b>{data.transferDetails?.dateOfTransfer ? moment(data.transferDetails.dateOfTransfer).format("D MMM, YYYY") : "-"}</b></div>
          <div>Amount Transferred: <b>₹ {data.transferDetails?.amountTransferred || 0}</b></div>
          <div>Status: <b>{data.loanStatus || "Transferred"}</b></div>
          <div>Loan Disbursed: <b>{data.transferDetails?.loanDisbursed || "Fund Unavailability"}</b></div>

          <div style={{ marginTop: 10 }}>Proof of Transfer:</div>
          <div style={{ display: "flex", gap: 10, marginTop: 4, flexWrap: "wrap" }}>
            {data.transferDetails?.proofs && Array.isArray(data.transferDetails.proofs) && data.transferDetails.proofs.length > 0 ? (
              data.transferDetails.proofs.map((file, index) => (
                <img
                  key={index}
                  src={file}
                  width="80"
                  height="80"
                  style={{ objectFit: "cover", borderRadius: 4, cursor: "pointer" }}
                  onClick={() => window.open(file, "_blank")}
                  alt="Transfer Proof"
                />
              ))
            ) : null}
          </div>
          {/* {this.renderEditDelete()} */}
        </div>
      );
    }

    if (st === "rejected") {
      return (
        <div>
          <div>Date of Rejection: <b>{data.dateOfRejection ? moment(data.dateOfRejection).format("D MMM, YYYY") : "-"}</b></div>
          <div>Reason: <b>{data.rejectionReason || "Inadequate Documents"}</b></div>
          {/* {this.renderEditDelete()} */}
        </div>
      );
    }

    return null;
  };

  renderEditDelete = () => (
    <div style={{ marginTop: 20 }}>
      <Button className="btn brand-color-background">Edit</Button>
      <Button className="btn btn-dark" style={{ marginLeft: 10 }}>Delete</Button>
    </div>
  );


  // renderRightPanel = () => {
  //   switch (this.state.selectedStage) {

  //     case "applied":
  //       return (
  //         <div>
  //           <div>Date of Application: <b>1 Sep, 2025</b></div>
  //           <div>Mode of Application:
  //             <label> <input type="radio" checked /> Online </label>
  //             <label> <input type="radio" /> Offline </label>
  //           </div>

  //           <div>Proof of Application:</div>
  //           <div style={{ display: "flex", gap: 10 }}>
  //             <img src="sample1.jpg" width="80" />
  //             <img src="sample2.jpg" width="80" />
  //             <img src="sample3.jpg" width="80" />
  //           </div>

  //           <br />
  //           <Button className="btn brand-color-background">Edit</Button>
  //           <Button className="btn btn-dark" style={{ marginLeft: 10 }}>Delete</Button>
  //         </div>
  //       );

  //     case "sanctioned":
  //       return (
  //         <div>
  //           <div>Date of Sanction: <b>3 Sep, 2025</b></div>
  //           <div>Reason of Pendency: <b>Fund Unavailability or Constraints</b></div>

  //           <br />
  //           <Button className="btn brand-color-background">Edit</Button>
  //           <Button className="btn btn-dark" style={{ marginLeft: 10 }}>Delete</Button>
  //         </div>
  //       );

  //     case "disbursed":
  //       return (
  //         <div>
  //           <div>Date of Disbursement: <b>10 Sep, 2025</b></div>
  //           <div>Amount Disbursed: <b>₹ 50,000</b></div>

  //           <br />
  //           <Button className="btn brand-color-background">Edit</Button>
  //           <Button className="btn btn-dark" style={{ marginLeft: 10 }}>Delete</Button>
  //         </div>
  //       );

  //     case "transferred":
  //       return (
  //         <div>
  //           <div>Date of Transfer: <b>12 Sep, 2025</b></div>
  //           <div>Status: <b>Moved to Buzzworthy</b></div>

  //           <br />
  //           <Button className="btn brand-color-background">Edit</Button>
  //           <Button className="btn btn-dark" style={{ marginLeft: 10 }}>Delete</Button>
  //         </div>
  //       );

  //     case "rejected":
  //       return (
  //         <div>
  //           <div>Date of Rejection: <b>3 Sep, 2025</b></div>
  //           <div>Reason for Rejection: <b>Inadequate Documents</b></div>

  //           <br />
  //           <Button className="btn brand-color-background">Edit</Button>
  //           <Button className="btn btn-dark" style={{ marginLeft: 10 }}>Delete</Button>
  //         </div>
  //       );

  //     default:
  //       return null;
  //   }
  // };




  render() {
    var years = [startYear.toString()]
    for (
      var i = 1;
      i <= moment().diff(moment(years[0], 'YYYY'), 'years');
      i++
    ) {
      let year = (parseInt(2019) + i).toString()
      years.push(year)
    }
    const // placesAutoCompleteOptions = {
      //   types: ["(regions)", "establishment", "address"],
      // },
      // renderFunc = ({ getInputProps, getSuggestionItemProps, suggestions }) => (
      //   <div className="autocomplete-root">
      //     <input
      //       {...getInputProps({
      //         placeholder: "Start typing and select from dropdown",
      //         className: "form-control",
      //       })}
      //     />
      //     <div className="autocomplete-dropdown-container">
      //       {suggestions.map((suggestion, index) => (
      //         <div {...getSuggestionItemProps(suggestion)} key={index}>
      //           <span>{suggestion.description}</span>
      //         </div>
      //       ))}
      //     </div>
      //   </div>
      // ),
      enterpriseSustainabilityCheckInTableCellEdit = cellEditFactory({
        mode: 'click',
        blurToSave: true,
        afterSaveCell: this.checkAndUpdateCheckIns,
      })



    return (
      <Col md={12} className="">
        {/* <div className="stages-container">
          <div
            className={
              this.state.currentActiveStage === 'capitalFulfilled'
                ? 'stage selected'
                : 'stage'
            }
            disabled={!this.props.isEditable}
            onClick={this.changeCurrentActiveStage.bind(
              this,
              'capitalFulfilled'
            )}
          >
            <span>Capital Stage</span>
          </div>
        </div> */}

        {['sidbi'].includes(JSON.parse(readCookie('userData')).type) &&
          this.state.currentActiveStage !== 'capitalFulfilled' ? null : this.state
            .currentActiveStage &&
            this.state.stages[this.state.currentActiveStage] ? (
          <div className="selected-stage-container">
            {this.state.stages[this.state.currentActiveStage][
              this.state.currentActiveStage + 'Status'
            ] ||
              (this.state.stages[this.state.currentActiveStage].updatedOn &&
                this.state.stages[this.state.currentActiveStage].updatedBy) ? (
              <div className="top-status-updated-container">
                {this.state.stages[this.state.currentActiveStage][
                  this.state.currentActiveStage + 'Status'
                ] ? (
                  this.state.currentActiveStage ===
                    'enterpriseSustainability' ? (
                    <span className="status-container">
                      Still Operational:{' '}
                      <span>
                        {
                          this.state.stages[this.state.currentActiveStage][
                          this.state.currentActiveStage + 'Status'
                          ]
                        }
                      </span>
                    </span>
                  ) : (
                    <span className="status-container">
                      Status:{' '}
                      <span>
                        {
                          this.state.stages[this.state.currentActiveStage][
                          this.state.currentActiveStage + 'Status'
                          ]
                        }
                      </span>
                    </span>
                  )
                ) : null}

                {this.state.stages[this.state.currentActiveStage].updatedOn &&
                  this.state.stages[this.state.currentActiveStage].updatedBy ? (
                  <div className="updated-container">
                    <span className="updated-by">
                      {'Last Updated By: '}
                      {this.state.stages[this.state.currentActiveStage]
                        .updatedBy.fullName ? (
                        JSON.parse(readCookie('userData')).type === 'le' ||
                          JSON.parse(readCookie('userData')).type === 'sidbi' ? (
                          <a
                            href={
                              '/user-types/' +
                              this.state.stages[this.state.currentActiveStage]
                                .updatedBy.userType.customUrl +
                              '/' +
                              this.state.stages[this.state.currentActiveStage]
                                .updatedBy._id
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {
                              this.state.stages[this.state.currentActiveStage]
                                .updatedBy.fullName
                            }
                          </a>
                        ) : (
                          this.state.stages[this.state.currentActiveStage]
                            .updatedBy.fullName
                        )
                      ) : (
                        <a
                          href={
                            JSON.parse(readCookie('userData')).type ===
                              'partners'
                              ? '/settings'
                              : '/org-types/swavalamban-connect-kendra/' +
                              this.state.stages[this.state.currentActiveStage]
                                .updatedBy._id
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {
                            this.state.stages[this.state.currentActiveStage]
                              .updatedBy.ngoName
                          }
                        </a>
                      )}
                    </span>
                    <span className="updated-on">
                      {' on '}
                      {moment(
                        this.state.stages[this.state.currentActiveStage]
                          .updatedOn
                      ).format('DD/MM/YYYY hh:mm A')}
                    </span>
                  </div>
                ) : null}
              </div>
            ) : null}

            {['sidbi'].includes(
              JSON.parse(readCookie('userData')).type
            ) ? null : this.state.currentActiveStage === 'dueDiligence' ? (
              <div className="selected-stage">
                {/*<div className="status-container">
									<label className="control-label">Due Diligence Completed?</label>
									<div className="status-options">
										<span><input type="radio" name="status" onChange={this.onStatusChange.bind(this, 'Pending')} checked={this.state.stages[this.state.currentActiveStage][this.state.currentActiveStage + 'Status'] === 'Pending' ? true : false} />Pending</span>
										<span><input type="radio" name="status" onChange={this.onStatusChange.bind(this, 'Completed')} checked={this.state.stages[this.state.currentActiveStage][this.state.currentActiveStage + 'Status'] === 'Completed' ? true : false} />Completed</span>
										<span><input type="radio" name="status" disabled checked={this.state.stages[this.state.currentActiveStage][this.state.currentActiveStage + 'Status'] === 'Hold' ? true : false} />Hold</span>
										<span><input type="radio" name="status" disabled checked={this.state.stages[this.state.currentActiveStage][this.state.currentActiveStage + 'Status'] === 'Disqualified' ? true : false} />Disqualified</span>
									</div>
								</div>*/}

                {this.props.businessIdea && this.state.stages.dueDiligence ? (
                  JSON.parse(readCookie('userData')).type === 'partners' ? (
                    <div className="due-diligence-locked program-team-only">
                      Can be accessed only by the Program Team.
                    </div>
                  ) : (
                    <Col md={12} className="due-diligence-details-container">
                      {!this.props?.leadData?.leadInfo?.disqualificationObj
                        .disqualified ? (
                        <Row className="justify-content-between">
                          {this.state.stages.dueDiligence.dueDiligenceStatus !==
                            'Hold' &&
                            this.state.stages.dueDiligence.dueDiligenceStatus !==
                            'Not Started' ? (
                            this.state.stages.dueDiligence
                              .dueDiligenceStatus !== 'Completed' ? (
                              <button
                                className="btn move-to-next-stage-btn"
                                onClick={this.onStatusChange.bind(
                                  this,
                                  'Completed'
                                )}
                                disabled={!this.props.isEditable}
                              >
                                MOVE TO BUSINESS PLAN STAGE
                              </button>
                            ) : (
                              <button
                                className="btn move-to-prev-stage-btn"
                                disabled={!this.props.isEditable}
                                onClick={this.onStatusChange.bind(
                                  this,
                                  'Pending',
                                  true
                                )}
                              >
                                MOVE BACK TO DUE DILIGENCE STAGE
                              </button>
                            )
                          ) : null}
                          {!this.props.leadData.leadInfo.onHoldObj
                            .onHoldStage ||
                            (this.props.leadData.leadInfo.onHoldObj.onHoldStage &&
                              this.props.leadData.leadInfo.onHoldObj
                                .onHoldStage === 'dueDiligence') ? (
                            this.state.stages.dueDiligence
                              .dueDiligenceStatus !== 'Hold' ? (
                              <button
                                className="btn btn-success put-on-hold-btn"
                                onClick={this.showHoldPrompt.bind(
                                  this,
                                  'dueDiligence'
                                )}
                                disabled={!this.props.isEditable}
                              >
                                PUT ON HOLD
                              </button>
                            ) : (
                              <button
                                className="btn btn-success put-on-hold-btn un-hold"
                                onClick={this.props.changeOnHoldStatus.bind(
                                  this,
                                  'dueDiligence'
                                )}
                              >
                                UN-HOLD
                              </button>
                            )
                          ) : null}
                          <button
                            className="btn disqualify-btn"
                            onClick={this.showDisqualificationPrompt}
                            disabled={!this.props.isEditable}
                          >
                            DISQUALIFY
                          </button>
                        </Row>
                      ) : (
                        <Row className="justify-content-end">
                          <button
                            className="btn disqualify-btn"
                            onClick={this.props.changeDisqualificationStatus}
                            disabled={!this.props.isEditable}
                          >
                            REQUALIFY
                          </button>
                        </Row>
                      )}

                      {/* { */}
                      {
                        // !(this.state.profileCompletionError && this.props.leadData.leadMaturity.dueDiligence.dueDiligenceStatus !== 'Completed') ?
                      }
                      <Row className="due-diligence-details">
                        <Col md={12} className="due-diligence-detail-item">
                          <label className="control-label">
                            Business Idea:
                          </label>
                          <span className="value">
                            {this.props.businessIdea}
                          </span>
                        </Col>
                        <Col md={4} className="due-diligence-detail-item">
                          <label className="control-label">
                            Self-investment:
                          </label>
                          <span className="value">
                            {'INR ' +
                              this.props.selfInvestment.toLocaleString()}
                          </span>
                        </Col>
                        <Col md={4} className="due-diligence-detail-item">
                          <label className="control-label">Loan sought:</label>
                          <span className="value">
                            {'INR ' +
                              this.props.loanAmountRequired.toLocaleString()}
                          </span>
                        </Col>
                        <Col md={4} className="due-diligence-detail-item">
                          <label className="control-label">
                            Total Investment:
                          </label>
                          <span className="value">
                            {'INR ' +
                              this.props.totalInvestment.toLocaleString()}
                          </span>
                        </Col>
                      </Row>
                      {/* : null} */}

                      {!this.state.refreshingDueDiligenceForm &&
                        !this.props.leadData?.leadInfo?.disqualificationObj
                          .disqualified &&
                        this.state.stages.dueDiligence.dueDiligenceStatus !==
                        'Hold' ? (
                        this.state.profileCompletionError &&
                          this.props.leadData.leadMaturity.dueDiligence
                            .dueDiligenceStatus !== 'Completed' ? (
                          <Row className="due-diligence-locked flex-column">
                            <span>
                              Please fill all the mandatory fields in the lead
                              profile first{' '}
                              <button
                                className="btn edit-lead-btn"
                                onClick={() =>
                                (window.location.pathname =
                                  '/edit-lead/' + this.props.leadId)
                                }
                                disabled={!this.props.isEditable}
                              >
                                EDIT PROFILE NOW
                              </button>
                            </span>
                          </Row>
                        ) : (
                          <DueDiligenceForm
                            isEditable={this.props.isEditable}
                            businessIdea={this.props.businessIdea}
                            dueDiligenceChange={this.dueDiligenceChange}
                            showHoldPrompt={this.showHoldPrompt}
                            showDisqualificationPrompt={
                              this.showDisqualificationPrompt
                            }
                            saveToProfile={this.saveToProfile}
                            addGuarantor={this.addGuarantor}
                            dueDiligence={this.state.stages.dueDiligence}
                            leadData={this.props.leadData}
                            stages={this.state.stages}
                            allBanks={this.state.allBanks}
                            bankAccounts={
                              this.props.leadData.familyAndAsset.bankAccounts
                            }
                            willingToGiveCollateral={
                              this.props.leadData.familyAndAsset.collateral
                            }
                            experienceInSector={
                              !isNaN(
                                this.props.leadData.familyAndAsset
                                  .experienceInSector
                              )
                                ? parseInt(
                                  this.props.leadData.familyAndAsset
                                    .experienceInSector
                                )
                                : 0
                            }
                            employmentStatus={
                              this.props.leadData.basic.employmentStatus
                            }
                            employer={this.props.leadData.basic.employer}
                            receivedBankLoan={
                              this.props.leadData.familyAndAsset
                                .receivedBankLoan
                            }
                            skillTrainedStatus={
                              this.state.stages.skillTrained.skillTrainedStatus
                            }
                          />
                        )
                      ) : this.props.leadData?.leadInfo?.disqualificationObj
                        .disqualified ? (
                        <div className="due-diligence-locked">
                          To update the details, kindly <span>REQUALIFY</span>{' '}
                          the candidate.
                        </div>
                      ) : this.state.stages.dueDiligence.dueDiligenceStatus ===
                        'Hold' ? (
                        <div className="due-diligence-locked">
                          To update the details, kindly <span>UN-HOLD</span> the
                          candidate.
                        </div>
                      ) : null}

                      {!this.props.leadData?.leadInfo?.disqualificationObj
                        .disqualified &&
                        this.state.stages.dueDiligence.dueDiligenceStatus !==
                        'Hold' ? (
                        <Row className="justify-content-between">
                          {this.state.stages.dueDiligence.dueDiligenceStatus !==
                            'Hold' &&
                            this.state.stages.dueDiligence.dueDiligenceStatus !==
                            'Not Started' ? (
                            this.state.stages.dueDiligence
                              .dueDiligenceStatus !== 'Completed' ? (
                              <button
                                className="btn move-to-next-stage-btn"
                                onClick={this.onStatusChange.bind(
                                  this,
                                  'Completed'
                                )}
                                disabled={!this.props.isEditable}
                              >
                                MOVE TO BUSINESS PLAN STAGE
                              </button>
                            ) : (
                              <button
                                className="btn move-to-prev-stage-btn"
                                onClick={this.onStatusChange.bind(
                                  this,
                                  'Pending',
                                  true
                                )}
                                disabled={!this.props.isEditable}
                              >
                                MOVE BACK TO DUE DILIGENCE STAGE
                              </button>
                            )
                          ) : null}
                          {!this.props.leadData.leadInfo.onHoldObj
                            .onHoldStage ||
                            (this.props.leadData.leadInfo.onHoldObj.onHoldStage &&
                              this.props.leadData.leadInfo.onHoldObj
                                .onHoldStage === 'dueDiligence') ? (
                            this.state.stages.dueDiligence
                              .dueDiligenceStatus !== 'Hold' ? (
                              <button
                                className="btn btn-success put-on-hold-btn"
                                onClick={this.showHoldPrompt.bind(
                                  this,
                                  'dueDiligence'
                                )}
                                disabled={!this.props.isEditable}
                              >
                                PUT ON HOLD
                              </button>
                            ) : (
                              <button
                                className="btn btn-success put-on-hold-btn un-hold"
                                onClick={this.props.changeOnHoldStatus.bind(
                                  this,
                                  'dueDiligence'
                                )}
                                disabled={!this.props.isEditable}
                              >
                                UN-HOLD
                              </button>
                            )
                          ) : null}
                          <button
                            className="btn disqualify-btn"
                            onClick={this.showDisqualificationPrompt}
                            disabled={!this.props.isEditable}
                          >
                            DISQUALIFY
                          </button>
                        </Row>
                      ) : null}
                    </Col>
                  )
                ) : (
                  <h4 className="due-diligence-locked flex-column">
                    The candidate has NO business idea selected.
                    <div className="mb15">
                      This section will unlock after business idea is entered.
                    </div>
                    <Row className="justify-content-center">
                      {!this.props.leadData?.leadInfo?.disqualificationObj
                        .disqualified ? (
                        <button
                          className="btn disqualify-btn"
                          onClick={this.showDisqualificationPrompt}
                          disabled={!this.props.isEditable}
                        >
                          DISQUALIFY
                        </button>
                      ) : (
                        <button
                          className="btn disqualify-btn"
                          onClick={this.props.changeDisqualificationStatus}
                          disabled={!this.props.isEditable}
                        >
                          REQUALIFY
                        </button>
                      )}
                    </Row>
                  </h4>
                )}
              </div>
            ) : null}

            {['sidbi'].includes(
              JSON.parse(readCookie('userData')).type
            ) ? null : this.state.currentActiveStage === 'skillTrained' &&
              this.state.loaded &&
              false ? (
              <div className="selected-stage">
                <div className="status-container">
                  <label className="control-label">Skill Trained?</label>
                  <div className="status-options">
                    <span>
                      <input
                        type="radio"
                        name="status"
                        onChange={this.onStatusChange.bind(
                          this,
                          'Skill training not required (General business idea)'
                        )}
                        disabled={!this.props.isEditable}
                        checked={
                          this.state.stages.skillTrained.skillTrainedStatus ===
                            'Skill training not required (General business idea)' ||
                            this.state.stages.skillTrained.skillTrainedStatus ===
                            'Not required'
                            ? true
                            : false
                        }
                      />
                      Skill training not required (General business idea)
                    </span>
                    <span>
                      <input
                        type="radio"
                        name="status"
                        onChange={this.onStatusChange.bind(
                          this,
                          'Skill training pending'
                        )}
                        disabled={!this.props.isEditable}
                        checked={
                          this.state.stages.skillTrained.skillTrainedStatus ===
                            'Skill training pending'
                            ? true
                            : false
                        }
                      />
                      Skill training pending
                    </span>
                    <span>
                      <input
                        type="radio"
                        name="status"
                        onChange={this.onStatusChange.bind(
                          this,
                          'Skill training ongoing'
                        )}
                        disabled={!this.props.isEditable}
                        checked={
                          this.state.stages.skillTrained.skillTrainedStatus ===
                            'Skill training ongoing'
                            ? true
                            : false
                        }
                      />
                      Skill training ongoing
                    </span>
                    <span>
                      <input
                        type="radio"
                        name="status"
                        onChange={this.onStatusChange.bind(
                          this,
                          'Skill training completed and has certificate'
                        )}
                        disabled={!this.props.isEditable}
                        checked={
                          this.state.stages.skillTrained.skillTrainedStatus ===
                            'Skill training completed and has certificate'
                            ? true
                            : false
                        }
                      />
                      Skill training completed and has certificate
                    </span>
                    <span>
                      <input
                        type="radio"
                        name="status"
                        onChange={this.onStatusChange.bind(
                          this,
                          'Skill training completed but no certificate'
                        )}
                        disabled={!this.props.isEditable}
                        checked={
                          this.state.stages.skillTrained.skillTrainedStatus ===
                            'Skill training completed but no certificate'
                            ? true
                            : false
                        }
                      />
                      Skill training completed but no certificate
                    </span>
                  </div>
                </div>

                {this.state.stages.skillTrained.skillTrainedStatus ? (
                  <Row className="skill-trained-questions">
                    {[
                      'Skill training ongoing',
                      'Skill training completed and has certificate',
                      'Skill training completed but no certificate',
                    ].indexOf(
                      this.state.stages.skillTrained.skillTrainedStatus
                    ) > -1 ? (
                      <Col md={12} className="skill-trained-question">
                        <label className="control-label is-imp">
                          Skill Training Institute Type
                        </label>
                        <Select
                          size="large"
                          style={{ width: '100%' }}
                          value={this.state.stages.skillTrained.instituteType}
                          disabled={!this.props.isEditable}
                          onChange={this.skillAndEDPTrainingChange.bind(
                            this,
                            'skillTrained',
                            'instituteType'
                          )}
                        >
                          <Option value="">
                            Select Training Institute Type
                          </Option>
                          <Option value="RSETI">RSETI</Option>
                          <Option value="RUDSETI">RUDSETI</Option>
                          <Option value="PMKK (NSDC)">PMKK (NSDC)</Option>
                          <Option value="JSS (NSDC)">JSS (NSDC)</Option>
                          <Option value="Others">Others</Option>
                        </Select>
                      </Col>
                    ) : null}

                    {[
                      'Skill training ongoing',
                      'Skill training completed and has certificate',
                      'Skill training completed but no certificate',
                    ].indexOf(
                      this.state.stages.skillTrained.skillTrainedStatus
                    ) > -1 ? (
                      <Col md={12} className="skill-trained-question">
                        <label className="control-label is-imp">
                          Skill Training Institute Name
                        </label>
                        <input
                          type="text"
                          placeholder="Training Institute Name"
                          value={this.state.stages.skillTrained.instituteName}
                          className={'form-control'}
                          onChange={this.skillAndEDPTrainingChange.bind(
                            this,
                            'skillTrained',
                            'instituteName'
                          )}
                          disabled={!this.props.isEditable}
                        />
                      </Col>
                    ) : null}

                    {[
                      'Skill training ongoing',
                      'Skill training completed and has certificate',
                      'Skill training completed but no certificate',
                    ].indexOf(
                      this.state.stages.skillTrained.skillTrainedStatus
                    ) > -1 ? (
                      <Col md={12} className="skill-trained-question">
                        <label className="control-label is-imp">
                          Skill Training Institute Location
                        </label>
                        <input
                          type="text"
                          placeholder="Training Institute Location"
                          value={
                            this.state.stages.skillTrained.instituteLocation
                          }
                          className={'form-control'}
                          onChange={this.skillAndEDPTrainingChange.bind(
                            this,
                            'skillTrained',
                            'instituteLocation'
                          )}
                          disabled={!this.props.isEditable}
                        />
                        {/*<PlacesAutocomplete onChange={this.skillAndEDPTrainingChange.bind(this, 'skillTrained', 'instituteLocation')} value={this.state.stages.skillTrained.instituteLocation.label} options={placesAutoCompleteOptions}>
													{renderFunc}
												</PlacesAutocomplete>*/}
                      </Col>
                    ) : null}
                  </Row>
                ) : null}
              </div>
            ) : null}

            {['sidbi'].includes(
              JSON.parse(readCookie('userData')).type
            ) ? null : this.state.currentActiveStage === 'enterpriseTrained' &&
              this.state.loaded &&
              false ? (
              <div className="selected-stage">
                <div className="status-container">
                  <label className="control-label">Enterprise Trained?</label>
                  <div className="status-options">
                    <span>
                      <input
                        type="radio"
                        name="status"
                        onChange={this.onStatusChange.bind(
                          this,
                          'EDP not required'
                        )}
                        disabled={!this.props.isEditable}
                        checked={
                          this.state.stages.enterpriseTrained
                            .enterpriseTrainedStatus === 'EDP not required'
                            ? true
                            : false
                        }
                      />
                      EDP not required
                    </span>
                    <span>
                      <input
                        type="radio"
                        name="status"
                        onChange={this.onStatusChange.bind(this, 'EDP pending')}
                        disabled={!this.props.isEditable}
                        checked={
                          this.state.stages.enterpriseTrained
                            .enterpriseTrainedStatus === 'EDP pending'
                            ? true
                            : false
                        }
                      />
                      EDP pending
                    </span>
                    <span>
                      <input
                        type="radio"
                        name="status"
                        onChange={this.onStatusChange.bind(this, 'EDP ongoing')}
                        disabled={!this.props.isEditable}
                        checked={
                          this.state.stages.enterpriseTrained
                            .enterpriseTrainedStatus === 'EDP ongoing'
                            ? true
                            : false
                        }
                      />
                      EDP ongoing
                    </span>
                    <span>
                      <input
                        type="radio"
                        name="status"
                        onChange={this.onStatusChange.bind(
                          this,
                          'Completed EDP with certificate'
                        )}
                        disabled={!this.props.isEditable}
                        checked={
                          this.state.stages.enterpriseTrained
                            .enterpriseTrainedStatus ===
                            'Completed EDP with certificate'
                            ? true
                            : false
                        }
                      />
                      Completed EDP with certificate
                    </span>
                    <span>
                      <input
                        type="radio"
                        name="status"
                        onChange={this.onStatusChange.bind(
                          this,
                          'Completed EDP without certificate'
                        )}
                        disabled={!this.props.isEditable}
                        checked={
                          this.state.stages.enterpriseTrained
                            .enterpriseTrainedStatus ===
                            'Completed EDP without certificate'
                            ? true
                            : false
                        }
                      />
                      Completed EDP without certificate
                    </span>
                  </div>
                </div>

                {this.state.stages.enterpriseTrained.enterpriseTrainedStatus ? (
                  <Row className="enterprise-trained-questions">
                    {[
                      'EDP ongoing',
                      'Completed EDP with certificate',
                      'Completed EDP without certificate',
                    ].indexOf(
                      this.state.stages.enterpriseTrained
                        .enterpriseTrainedStatus
                    ) > -1 ? (
                      <Col md={12} className="enterprise-trained-question">
                        <label className="control-label is-imp">
                          EDP Institute Type
                        </label>
                        <Select
                          size="large"
                          style={{ width: '100%' }}
                          value={
                            this.state.stages.enterpriseTrained.instituteType
                          }
                          onChange={this.skillAndEDPTrainingChange.bind(
                            this,
                            'enterpriseTrained',
                            'instituteType'
                          )}
                          disabled={!this.props.isEditable}
                        >
                          <Option value="">
                            Select Training Institute Type
                          </Option>
                          <Option value="RSETI">RSETI</Option>
                          <Option value="RUDSETI">RUDSETI</Option>
                          <Option value="PMKK (NSDC)">PMKK (NSDC)</Option>
                          <Option value="JSS (NSDC)">JSS (NSDC)</Option>
                          <Option value="Others">Others</Option>
                        </Select>
                      </Col>
                    ) : null}

                    {[
                      'EDP ongoing',
                      'Completed EDP with certificate',
                      'Completed EDP without certificate',
                    ].indexOf(
                      this.state.stages.enterpriseTrained
                        .enterpriseTrainedStatus
                    ) > -1 ? (
                      <Col md={12} className="enterprise-trained-question">
                        <label className="control-label is-imp">
                          EDP Institute Name
                        </label>
                        <input
                          type="text"
                          placeholder="Training Institute Name"
                          value={
                            this.state.stages.enterpriseTrained.instituteName
                          }
                          className={'form-control'}
                          onChange={this.skillAndEDPTrainingChange.bind(
                            this,
                            'enterpriseTrained',
                            'instituteName'
                          )}
                          disabled={!this.props.isEditable}
                        />
                      </Col>
                    ) : null}

                    {[
                      'EDP ongoing',
                      'Completed EDP with certificate',
                      'Completed EDP without certificate',
                    ].indexOf(
                      this.state.stages.enterpriseTrained
                        .enterpriseTrainedStatus
                    ) > -1 ? (
                      <Col md={12} className="enterprise-trained-question">
                        <label className="control-label is-imp">
                          EDP Institute Location
                        </label>
                        <input
                          type="text"
                          placeholder="Training Institute Location"
                          value={
                            this.state.stages.enterpriseTrained
                              .instituteLocation
                          }
                          className={'form-control'}
                          onChange={this.skillAndEDPTrainingChange.bind(
                            this,
                            'enterpriseTrained',
                            'instituteLocation'
                          )}
                          disabled={!this.props.isEditable}
                        />
                        {/*<PlacesAutocomplete onChange={this.skillAndEDPTrainingChange.bind(this, 'enterpriseTrained', 'instituteLocation')} value={this.state.stages.enterpriseTrained.instituteLocation.label} options={placesAutoCompleteOptions}>
													{renderFunc}
												</PlacesAutocomplete>*/}
                      </Col>
                    ) : null}
                  </Row>
                ) : null}
              </div>
            ) : null}

            {['sidbi'].includes(
              JSON.parse(readCookie('userData')).type
            ) ? null : this.state.currentActiveStage === 'businessPlanReady' ? (
              <div className="selected-stage">
                {JSON.parse(readCookie('userData')).type ===
                  'partners' ? null : !this.props.leadData.leadInfo
                    .disqualificationObj.disqualified ? (
                  <Row className="justify-content-between mb10">
                    {this.state.stages.businessPlanReady
                      .businessPlanReadyStatus !== 'Hold' &&
                      this.state.stages.businessPlanReady
                        .businessPlanReadyStatus !== 'Not Started' ? (
                      this.state.stages.businessPlanReady
                        .businessPlanReadyStatus !== 'Completed' ? (
                        <button
                          style={
                            window.screen.width < 500 ? { margin: 10 } : null
                          }
                          className="btn move-to-next-stage-btn"
                          onClick={this.onStatusChange.bind(this, 'Completed')}
                        >
                          MOVE TO LOAN APPLICATION STAGE
                        </button>
                      ) : (
                        <button
                          style={
                            window.screen.width < 500 ? { margin: 10 } : null
                          }
                          className="btn move-to-prev-stage-btn"
                          onClick={this.onStatusChange.bind(
                            this,
                            'Pending',
                            true
                          )}
                          disabled={!this.props.isEditable}
                        >
                          MOVE BACK TO BUSINESS PLAN STAGE
                        </button>
                      )
                    ) : null}
                    {!this.props.leadData.leadInfo.onHoldObj.onHoldStage ||
                      (this.props.leadData.leadInfo.onHoldObj.onHoldStage &&
                        this.props.leadData.leadInfo.onHoldObj.onHoldStage ===
                        'businessPlanReady') ? (
                      this.state.stages.businessPlanReady
                        .businessPlanReadyStatus !== 'Hold' ? (
                        <button
                          className="btn btn-success put-on-hold-btn"
                          onClick={this.showHoldPrompt.bind(
                            this,
                            'businessPlanReady'
                          )}
                          disabled={!this.props.isEditable}
                        >
                          PUT ON HOLD
                        </button>
                      ) : (
                        <button
                          className="btn btn-success put-on-hold-btn un-hold"
                          onClick={this.props.changeOnHoldStatus.bind(
                            this,
                            'businessPlanReady'
                          )}
                          disabled={!this.props.isEditable}
                        >
                          UN-HOLD
                        </button>
                      )
                    ) : null}
                    <button
                      className="btn disqualify-btn"
                      onClick={this.showDisqualificationPrompt}
                      disabled={!this.props.isEditable}
                    >
                      DISQUALIFY
                    </button>
                  </Row>
                ) : (
                  <Row className="justify-content-end">
                    <button
                      className="btn disqualify-btn"
                      onClick={this.props.changeDisqualificationStatus}
                      disabled={!this.props.isEditable}
                    >
                      REQUALIFY
                    </button>
                  </Row>
                )}

                <Row className="business-plan-container">
                  <label className="control-label">Business Plan:</label>
                  {this.state.stages.businessPlanReady
                    .businessPlanVerification ? (
                    <div className="verified-container">
                      <span className="verified-by">
                        {'Verified By '}
                        {this.state.stages.businessPlanReady
                          .businessPlanVerification.verifiedBy &&
                          this.state.stages.businessPlanReady
                            .businessPlanVerification.verifiedBy.fullName ? (
                          <a
                            href={
                              '/user-types/' +
                              this.state.stages.businessPlanReady
                                .businessPlanVerification.verifiedBy.userType
                                .customUrl +
                              '/' +
                              this.state.stages.businessPlanReady
                                .businessPlanVerification.verifiedBy._id
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {
                              this.state.stages.businessPlanReady
                                .businessPlanVerification.verifiedBy.fullName
                            }
                          </a>
                        ) : null}
                      </span>
                      <span className="verified-on">
                        {' on '}
                        {moment(
                          this.state.stages.businessPlanReady
                            .businessPlanVerification.verifiedAt
                        ).format('DD/MM/YYYY hh:mm A')}
                      </span>
                    </div>
                  ) : null}
                  {JSON.parse(readCookie('userData')).type === 'le' &&
                    JSON.parse(readCookie('userData')).userType.name ===
                    'Project Management Unit' ? (
                    <button
                      className="btn mark-verified-btn"
                      onClick={this.markBPlanVerified}
                      disabled={!this.props.isEditable}
                    >
                      Mark Verified
                    </button>
                  ) : null}
                  {(this.state.stages.businessPlanReady.businessPlanId ||
                    this.state.stages.businessPlanReady.businessPlanUrl) &&
                    !this.state.showBusinessPlanEdit ? (
                    <div className="business-plan">
                      {this.state.stages.businessPlanReady.businessPlanId ? (
                        <button
                          style={
                            window.screen.width < 500 ? { marginTop: 50 } : null
                          }
                          className="btn view-button"
                          onClick={this.viewBPlan.bind(
                            this,
                            this.state.stages.businessPlanReady
                          )}
                          disabled={!this.props.isEditable}
                        >
                          View
                        </button>
                      ) : null}
                      {JSON.parse(readCookie('userData')).type ===
                        'partners' ? null : (
                        <>
                          {' '}
                          <button
                            style={
                              window.screen.width < 500
                                ? { marginTop: 50 }
                                : null
                            }
                            className="btn edit-button"
                            onClick={this.editBPlan.bind(
                              this,
                              this.state.stages.businessPlanReady
                              // "Completed EDP with certificate"
                            )}
                            disabled={!this.props.isEditable}
                          >
                            <i className="fa fa-pencil"></i>
                            Edit
                          </button>
                          {JSON.parse(readCookie('userData')).userType.name ===
                            'Project Management Unit' ? (
                            <button
                              style={
                                window.screen.width < 500
                                  ? { marginTop: 50 }
                                  : null
                              }
                              className="btn delete-button"
                              onClick={this.deleteBPlan}
                              disabled={!this.props.isEditable}
                            >
                              <i className="fa fa-times"></i>
                              Delete
                            </button>
                          ) : (
                            <button
                              style={
                                window.screen.width < 500
                                  ? { marginTop: 50 }
                                  : null
                              }
                              className="btn delete-button"
                              onClick={this.updateBplan}
                              disabled={!this.props.isEditable}
                            >
                              {/* <i className="fa fa-times"></i> */}
                              Update Template
                            </button>
                          )}
                        </>
                      )}
                      {this.state.stages.businessPlanReady.businessPlanUrl ? (
                        <div
                          style={
                            window.screen.width < 500
                              ? { width: 250, overflow: 'scroll', maxLines: 2 }
                              : null
                          }
                        >
                          <a
                            className="heading-container"
                            href={
                              this.state.stages.businessPlanReady
                                .businessPlanUrl
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {
                              this.state.stages.businessPlanReady
                                .businessPlanUrl
                            }
                          </a>
                        </div>
                      ) : (
                        <div className="heading-container">
                          {this.state.stages.businessPlanReady.businessPlanName}
                        </div>
                      )}
                      <div className="timing d-flex align-items-center">
                        {this.state.stages.businessPlanReady.createdAt ? (
                          <span
                            style={
                              window.screen.width < 500
                                ? { marginTop: 55 }
                                : null
                            }
                          >
                            <b>Created At:</b>
                            {moment(
                              this.state.stages.businessPlanReady.createdAt
                            ).format('LLL')}
                          </span>
                        ) : null}
                        {this.state.stages.businessPlanReady.updatedOn ? (
                          <span
                            style={
                              window.screen.width < 500
                                ? { marginTop: 55 }
                                : null
                            }
                          >
                            <b>Last Updated:</b>
                            <TimeAgo
                              date={
                                this.state.stages.businessPlanReady.updatedOn
                              }
                            />
                          </span>
                        ) : null}
                      </div>
                    </div>
                  ) : (
                    <Col md={12} className="create-business-plan-container">
                      {this.state.uploadingBusinessPlan ||
                        this.state.pastingLinkToBusinessPlan ? (
                        this.state.uploadingBusinessPlan ? (
                          <div className="uploading-business-plan-input">
                            <label className="control-label">
                              Select Business Plan File
                            </label>
                            <div className="d-flex">
                              <input
                                className="form-control"
                                type="file"
                                onChange={this.uploadingBusinessPlanChange}
                                accept=".jpg,.png,.jpeg,.pdf"
                                disabled={!this.props.isEditable}
                              />
                              <button
                                className="btn save-business-plan-btn"
                                onClick={this.saveBusinessPlan}
                                disabled={!this.props.isEditable}
                              >
                                <i className="fas fa-check"></i>
                                Submit
                              </button>
                            </div>
                            <button
                              className="btn btn-danger cancel-btn"
                              onClick={this.cancelChangeBusinessPlan}
                              disabled={!this.props.isEditable}
                            >
                              Cancel
                            </button>
                          </div>
                        ) : (
                          <div className="link-for-business-plan-input">
                            <label className="control-label">
                              Enter Business Plan File URL
                            </label>
                            <div className="d-flex">
                              <input
                                className="form-control"
                                type="text"
                                onChange={this.linkToBusinessPlanChange}
                                value={this.state.linkToBusinessPlan}
                                placeholder="Paste the link to the Business Plan File"
                                disabled={!this.props.isEditable}
                              />
                              <button
                                className="btn save-business-plan-btn"
                                onClick={this.saveBusinessPlan}
                                disabled={!this.props.isEditable}
                              >
                                <i className="fas fa-check"></i>
                                Submit
                              </button>
                            </div>
                            <button
                              className="btn btn-danger cancel-btn"
                              onClick={this.cancelChangeBusinessPlan}
                              disabled={!this.props.isEditable}
                            >
                              Cancel
                            </button>
                          </div>
                        )
                      ) : JSON.parse(readCookie('userData')).type ===
                        'partners' ? (
                        <span className="justify-content-center">
                          The Business Plan is yet to be created
                        </span>
                      ) : (
                        <div
                          style={
                            window.screen.width < 500
                              ? { display: 'flex', flexDirection: 'column' }
                              : null
                          }
                          className="buttons"
                        >
                          <button
                            className="btn create-business-plan-btn"
                            onClick={this.createBusinessPlan}
                            disabled={!this.props.isEditable}
                          >
                            <i className="fa fa-plus"></i>
                            Create Business Plan (RECOMMENDED)
                          </button>
                          <div>OR</div>
                          <button
                            className="btn btn-danger upload-business-plan-btn"
                            onClick={this.uploadBusinessPlan}
                            disabled={!this.props.isEditable}
                          >
                            <i className="fas fa-upload"></i>
                            Upload B-Plan
                          </button>
                          {/* <div>OR</div>
                          <button
                            className="btn btn-danger paste-business-plan-link-btn"
                            onClick={this.pasteLinkToBusinessPlan}
                          >
                            <i className="fas fa-paste"></i>
                            Paste B-Plan link
                          </button> */}
                          {this.state.showBusinessPlanEdit ? (
                            <div className="mt20">
                              <button
                                className="btn cancel-business-plan-edit-btn"
                                onClick={this.hideBusinessPlanEdit}
                                disabled={!this.props.isEditable}
                              >
                                Cancel Edit
                              </button>
                            </div>
                          ) : null}
                        </div>
                      )}
                    </Col>
                  )}
                </Row>
                {this.state.stages.businessPlanReady.quotationsObj ? (
                  <Row className="quotations-container">
                    <div className="status-container">
                      <label className="control-label">Quotations:</label>
                      <div className="status-options">
                        <span
                          style={
                            window.screen.width < 500 ? { width: '100%' } : null
                          }
                          className={
                            this.state.stages.businessPlanReady.quotationsObj
                              .quotationStatus === 'Pending'
                              ? 'selected'
                              : null
                          }
                        >
                          <input
                            style={
                              window.screen.width < 500
                                ? { marginLeft: 0, width: '10%' }
                                : null
                            }
                            type="radio"
                            name="status"
                            checked={
                              this.state.stages.businessPlanReady.quotationsObj
                                .quotationStatus === 'Pending'
                                ? true
                                : false
                            }
                            onChange={this.changeQuotationsStatus.bind(
                              this,
                              'Pending'
                            )}
                            disabled={!this.props.isEditable}
                          />
                          Pending
                        </span>
                        <span
                          style={
                            window.screen.width < 500 ? { width: '100%' } : null
                          }
                          className={
                            this.state.stages.businessPlanReady.quotationsObj
                              .quotationStatus === 'Received'
                              ? 'selected'
                              : null
                          }
                          title={
                            !this.state.stages.businessPlanReady.quotationsObj
                              .quotations.length
                              ? "Add quotations to mark it 'Received'"
                              : null
                          }
                        >
                          <input
                            style={
                              window.screen.width < 500
                                ? { marginLeft: 0, width: '10%' }
                                : null
                            }
                            type="radio"
                            name="status"
                            disabled={
                              !this.props.isEditable ||
                              !this.state.stages.businessPlanReady.quotationsObj
                                .quotations.length
                            }
                            checked={
                              this.state.stages.businessPlanReady.quotationsObj
                                .quotationStatus === 'Received'
                                ? true
                                : false
                            }
                            onChange={this.changeQuotationsStatus.bind(
                              this,
                              'Received'
                            )}
                          />
                          Received
                        </span>
                        <span
                          style={
                            window.screen.width < 500 ? { width: '100%' } : null
                          }
                          className={
                            this.state.stages.businessPlanReady.quotationsObj
                              .quotationStatus === 'Not required'
                              ? 'selected'
                              : null
                          }
                        >
                          <input
                            style={
                              window.screen.width < 500
                                ? { marginLeft: 0, width: '10%' }
                                : null
                            }
                            type="radio"
                            name="status"
                            checked={
                              this.state.stages.businessPlanReady.quotationsObj
                                .quotationStatus === 'Not required'
                                ? true
                                : false
                            }
                            onChange={this.changeQuotationsStatus.bind(
                              this,
                              'Not required'
                            )}
                            disabled={!this.props.isEditable}
                          />
                          Not required
                        </span>
                      </div>
                    </div>
                    {this.state.stages.businessPlanReady.quotationsObj
                      .quotationStatus !== 'Not required' ? (
                      <div className="quotations-table-container">
                        <label className="control-label">
                          Upload Quotations and other documents (rent
                          aggrement/training certificate/licenses/any other
                          document that supports the loan application)
                        </label>
                        <ToolkitProvider
                          keyField="slNo"
                          data={this.props.capitalInfo}
                          columns={this.state.quotationsColumns}
                        >
                          {props => (
                            <div>
                              <BootstrapTable
                                id="quotations-table"
                                {...props.baseProps}
                                ref={table => {
                                  this.quotationsTable = table
                                }}
                              />
                            </div>
                          )}
                        </ToolkitProvider>
                        <Col md={12} className="text-center">
                          <Button
                            className="btn mt10 brand-color-background add-quotation-btn"
                            onClick={this.addNewQuotation}
                            disabled={!this.props.isEditable}
                          >
                            <i className="fa fa-plus"></i>Add New Quotation
                          </Button>
                        </Col>
                      </div>
                    ) : null}
                  </Row>
                ) : null}

                {this.state.editingQuotation ? (
                  <Modal
                    className="edit-loan-application-modal"
                    size="lg"
                    show={this.state.editingQuotation ? true : false}
                    onHide={() => { }}
                  >
                    <Modal.Header>
                      <Modal.Title className="modal-header-custom">
                        Quotation
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="mb20">
                      <Row>
                        <Col md={6}>
                          <label className="control-label is-imp">
                            Quotation / Documentation of
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            style={{ width: '100%' }}
                            placeholder="Quotation / Documentation of"
                            value={this.state.editingQuotation.quotationOf}
                            onChange={this.updateEditingQuotation.bind(
                              this,
                              'quotationOf'
                            )}
                            disabled={!this.props.isEditable}
                          />
                        </Col>
                        <Col md={6}>
                          <label className="control-label is-imp">
                            Select File Type
                          </label>
                          <Select
                            size="large"
                            showSearch
                            style={{ width: '100%' }}
                            value={this.state.editingQuotation.fileType}
                            onChange={this.updateEditingQuotation.bind(
                              this,
                              'fileType'
                            )}
                            disabled={!this.props.isEditable}
                          >
                            <Option value="" disabled>
                              Select File Type
                            </Option>
                            <Option value="Quotation">Quotation</Option>
                            <Option value="Other document">
                              Other document
                            </Option>
                          </Select>
                        </Col>
                        <Col md={12}>
                          <label className="control-label is-imp">
                            File(s)
                          </label>
                          <div className="files-container">
                            <div className="files">
                              {this.state.editingQuotation.files.map(
                                (file, index) => {
                                  return (
                                    <div className="file-container" key={index}>
                                      <a
                                        download
                                        href={file}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                      >
                                        {'File ' + (index + 1)}
                                      </a>
                                      <i
                                        className="fa fa-times"
                                        title="Delete File"
                                        onClick={this.deleteFileFromQuotation.bind(
                                          this,
                                          index
                                        )}
                                        disabled={!this.props.isEditable}
                                      ></i>
                                    </div>
                                  )
                                }
                              )}
                            </div>
                            <div className="mt5">
                              {this.state.showQuotationUploadFiles ? (
                                <div className="upload-loan-files-container">
                                  <input
                                    type="file"
                                    className="form-control"
                                    multiple
                                    accept=".pdf, image/*"
                                    onChange={this.updateFilesQuotation}
                                    disabled={!this.props.isEditable}
                                  />
                                  <Button
                                    className="btn ml10 brand-color-background"
                                    onClick={this.quotationUploadFiles}
                                    disabled={
                                      !this.props.isEditable ||
                                      this.state.newFilesQuotation === null ||
                                      this.state.uploadingQuotationFiles
                                    }
                                  >
                                    {this.state.uploadingQuotationFiles ? (
                                      <span className="d-flex align-items-center">
                                        Uploading
                                        <i className="fa fa-spin fa-spinner ml5"></i>
                                      </span>
                                    ) : (
                                      'Upload'
                                    )}
                                  </Button>
                                  <Button
                                    className="btn btn-danger brand-color-background ml5"
                                    onClick={this.hideQuotationUploadFiles}
                                    disabled={
                                      !this.props.isEditable ||
                                      this.state.uploadingQuotationFiles
                                    }
                                  >
                                    Cancel
                                  </Button>
                                </div>
                              ) : (
                                <Button
                                  className="btn btn-danger brand-color-background"
                                  onClick={this.showQuotationUploadFiles}
                                  disabled={!this.props.isEditable}
                                >
                                  Upload Files
                                </Button>
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Modal.Body>
                    <Modal.Footer className="footer-center">
                      <Button
                        className="btn brand-color-background"
                        onClick={this.saveEditingQuotation}
                        disabled={
                          !this.props.isEditable ||
                          this.state.uploadingQuotationFiles
                        }
                      >
                        Save
                      </Button>
                      <Button
                        className="btn btn-danger brand-color-background"
                        onClick={this.hideEditingQuotation}
                        disabled={
                          !this.props.isEditable ||
                          this.state.uploadingQuotationFiles
                        }
                      >
                        Cancel
                      </Button>
                    </Modal.Footer>
                  </Modal>
                ) : null}
              </div>
            ) : null}

            {this.state.currentActiveStage === 'capitalFulfilled' ? (
              <div className="selected-stage" style={{ padding: "20px" }}>

                {/* Only show loan UI when loan data exists AND has essential fields, otherwise show "No Investment" */}
                {this.state.latestLoanData && (this.state.latestLoanData.loanId || this.state.latestLoanData._id || this.state.latestLoanData.dateOfApplication) ? (
                  <>
                    {/* Status Badge */}
                    {(this.getMatchedFinancialProduct() || this.state.latestLoanData) && (
                      <div
                        style={{
                          background: this.badgeColor ? this.badgeColor() : "#28a745",
                          padding: "6px 14px",
                          borderRadius: "20px",
                          fontWeight: 600,
                          width: "fit-content",
                          marginBottom: "25px",
                          color: "#fff"
                        }}
                      >
                        {this.getStatusLabel ? this.getStatusLabel() : (this.state.latestLoanData?.status || "Status")}
                      </div>
                    )}

                    {/* Type of Application Toggle */}
                    <div style={{ fontWeight: 600, marginBottom: 6 }}>Type of Application</div>
                    <div style={{ display: "flex", gap: 40, marginBottom: 25 }}>
                      <label style={{ cursor: "pointer" }}>
                        <input
                          type="radio"
                          checked={this.state.selectedApplicationType === "loan"}
                          onChange={() => this.setState({ selectedApplicationType: "loan" })}
                          style={{ marginRight: 8 }}
                        />
                        Loan
                      </label>

                      <label style={{ cursor: "pointer" }}>
                        <input
                          type="radio"
                          checked={this.state.selectedApplicationType === "self"}
                          onChange={() => this.setState({ selectedApplicationType: "self" })}
                          style={{ marginRight: 8 }}
                        />
                        Self Investment
                      </label>
                    </div>

                    {/* Loan Scheme Info */}
                    {this.renderFinancialProductInfo && this.renderFinancialProductInfo()}

                    {/* Main Two-Column Layout */}
                    <div style={{ display: "flex", marginTop: 10 }}>
                      {/* LEFT SIDEBAR STAGES */}
                      <div style={{ width: "200px", marginRight: "30px" }}>

                        {this.state.selectedApplicationType === "loan" ? (
                          <>
                            {this.getVisibleStages().map(stage => {
                              const isCompleted = this.isStageCompleted(stage);
                              const isSelected = this.state.selectedStage === stage;

                              return (
                                <div
                                  key={stage}
                                  onClick={() => this.setState({ selectedStage: stage })}
                                  style={{
                                    padding: "12px 15px",
                                    marginBottom: "10px",
                                    cursor: "pointer",
                                    background: isSelected ? "#DF6F4F" : (isCompleted ? "#6B7280" : "#F3F3F3"),
                                    color: isSelected || isCompleted ? "#fff" : "#000",
                                    borderRadius: "4px",
                                    fontWeight: 600
                                  }}
                                >
                                  {stage === 'applied' && "Loan Applied"}
                                  {stage === 'sanctioned' && "Loan Sanctioned"}
                                  {stage === 'disbursed' && "Loan Disbursed"}
                                  {stage === 'transferred' && "Transferred"}
                                  {stage === 'rejected' && "Loan Rejected"}
                                </div>
                              );
                            })}
                          </>
                        ) : (
                          <>
                            {/* SELF Investment */}
                            <div
                              onClick={() => this.setState({ selectedStage: "preferred" })}
                              style={{
                                padding: "12px 15px",
                                marginBottom: "10px",
                                cursor: "pointer",
                                background: this.state.selectedStage === "preferred" ? "#DF6F4F" : "#F3F3F3",
                                color: this.state.selectedStage === "preferred" ? "#fff" : "#000",
                                borderRadius: 4,
                                fontWeight: 600
                              }}
                            >
                              Self Investment Preferred
                            </div>

                            <div
                              onClick={() => this.setState({ selectedStage: "self_transferred" })}
                              style={{
                                padding: "12px 15px",
                                cursor: "pointer",
                                background: this.state.selectedStage === "self_transferred" ? "#DF6F4F" : "#F3F3F3",
                                color: this.state.selectedStage === "self_transferred" ? "#fff" : "#000",
                                borderRadius: 4,
                                fontWeight: 600
                              }}
                            >
                              Self Investment Transferred
                            </div>
                          </>
                        )}
                      </div>

                      {/* Right Dynamic Panel */}
                      <div style={{ flex: 1 }}>
                        {this.renderRightPanel()}
                      </div>
                    </div>
                  </>
                ) : (
                  // Show "No Investment" UI when no loan data exists
                  this.renderNoInvestmentUI()
                )}

                {/* Modals */}
                {this.state.showNewInvestmentModal ? (<Modal
                  show={this.state.showNewInvestmentModal}
                  onHide={() => this.setState({ showNewInvestmentModal: false })}
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title>New Record</Modal.Title>
                  </Modal.Header>

                  <Modal.Body>
                    <div style={{ fontWeight: 600, marginBottom: 10 }}>
                      Select Type of Investment:
                    </div>

                    <div style={{ display: "flex", gap: 20 }}>
                      <label>
                        <input
                          type="radio"
                          name="recordType"
                          value="loan"
                          onChange={() => this.setState({ newRecordType: "loan" })}
                        />
                        &nbsp;Loan
                      </label>

                      <label>
                        <input
                          type="radio"
                          name="recordType"
                          value="self"
                          onChange={() => this.setState({ newRecordType: "self" })}
                        />
                        &nbsp;Self Investment
                      </label>
                    </div>
                  </Modal.Body>

                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => this.setState({ showNewInvestmentModal: false })}
                    >
                      Cancel
                    </Button>

                    <Button
                      variant="primary"
                      onClick={() => {
                        this.setState({ showNewInvestmentModal: false });
                        // Logic for next step would go here
                      }}
                      disabled={!this.state.newRecordType}
                    >
                      Next
                    </Button>
                  </Modal.Footer>
                </Modal>
                ) : null}

                {this.state.editingLoanApplication ? (
                  <Modal
                    className="edit-loan-application-modal"
                    size="lg"
                    show={this.state.editingLoanApplication ? true : false}
                    onHide={() => { }}
                    dialogClassName="capital-modal-width"
                  >
                    <Modal.Header>
                      <Modal.Title className="modal-header-custom">
                        {this.state.editingLoanApplication.slNo
                          ? 'Loan Record Edit'
                          : 'New Record'}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="mb20">
                      <AddCapitalModal
                        leadId={this.props.leadId}
                        closeModal={e => this.setState({
                          editingLoanApplication: false
                        })}
                      />
                    </Modal.Body>
                  </Modal>
                ) : null}

              </div>
            ) : null}

            {['sidbi'].includes(
              JSON.parse(readCookie('userData')).type
            ) ? null : this.state.currentActiveStage === 'enterpriseSetup' &&
              this.state.loaded ? (
              <div className="selected-stage">
                {/*<div className="status-container">
									<label className="control-label">Enterprise Setup/Scale-up?</label>
									<div className="status-options">
										<span><input type="radio" name="status" onChange={this.onStatusChange.bind(this, 'Yes')} checked={this.state.stages[this.state.currentActiveStage][this.state.currentActiveStage + 'Status'] === 'Yes' ? true : false} />Yes</span>
										<span><input type="radio" name="status" onChange={this.onStatusChange.bind(this, 'No')} checked={this.state.stages[this.state.currentActiveStage][this.state.currentActiveStage + 'Status'] === 'No' ? true : false} />No</span>
									</div>
								</div>*/}

                {this.state.stages.enterpriseSetup.entityName &&
                  ((this.state.stages.enterpriseSetup.creationMonth &&
                    this.state.stages.enterpriseSetup.creationYear) ||
                    this.state.stages.enterpriseSetup.createdOn) &&
                  ((this.state.stages.enterpriseSetup.kycDocuments.pan &&
                    this.state.stages.enterpriseSetup.kycDocuments.pan.length ===
                    10) ||
                    (this.state.stages.enterpriseSetup.kycDocuments.aadhar &&
                      this.state.stages.enterpriseSetup.kycDocuments.aadhar
                        .length === 12 &&
                      !this.state.aadharError) ||
                    (this.state.stages.enterpriseSetup.kycDocuments.udyogAadhar &&
                      (this.state.stages.enterpriseSetup.kycDocuments.udyogAadhar
                        .length === 12 ||
                        this.state.stages.enterpriseSetup.kycDocuments.udyogAadhar
                          .length === 19))) &&
                  this.state.stages.enterpriseSetup.enterpriseRegistered &&
                  google_maps_url_regex.test(
                    this.state.stages.enterpriseSetup.googleBusinessLocationUrl
                  ) &&
                  this.state.stages.enterpriseSetup
                    .udyogAadharCertificateReceived &&
                  this.state.stages.enterpriseSetup.gstCertificate &&
                  this.state.stages.enterpriseSetup.otherLicenses &&
                  this.state.stages.enterpriseSetup
                    .certificateOfShopAndEstablishmentAct &&
                  this.state.stages.enterpriseSetup.digitalPayment &&
                  this.state.stages.enterpriseSetup.hasInsurance &&
                  this.state.stages.enterpriseSetup.gemsPortalRegistered &&
                  this.state.stages.enterpriseSetup.officeShopFactoryAddress &&
                  this.state.stages.enterpriseSetup.officeShopFactoryAddressUrl &&
                  this.state.stages.enterpriseSetup.officeShopFactoryAddressUrl
                    .latitude &&
                  this.state.stages.enterpriseSetup.officeShopFactoryAddressUrl
                    .longitude &&
                  this.state.stages.enterpriseSetup.supportReceived &&
                  this.state.stages.enterpriseSetup.entrepreneurStory &&
                  this.state.stages.enterpriseSetup.otherImageUrls &&
                  this.state.stages.enterpriseSetup.bankName &&
                  this.state.stages.enterpriseSetup.bankIFSC &&
                  this.state.stages.enterpriseSetup.recognizedSupport &&
                  this.state.verifyingIFSC !== 'Failed' &&
                  this.state.stages.enterpriseSetup.otherImageUrls.length &&
                  ((this.state.stages.enterpriseSetup.enterpriseRegistered ===
                    'Yes' &&
                    this.state.stages.enterpriseSetup.entityType) ||
                    this.state.stages.enterpriseSetup.enterpriseRegistered ===
                    'No') ? (
                  this.state.stages.enterpriseSetup.enterpriseSetupStatus !==
                    'Started up' &&
                    this.state.stages.enterpriseSetup.enterpriseSetupStatus !==
                    'Scaled up' ? (
                    this.state.stages.enterpriseSetup.enterpriseState ===
                      'Start-up' ? (
                      <button
                        className="btn move-to-next-stage-btn"
                        disabled={!this.props.isEditable}
                        onClick={this.onStatusChange.bind(this, 'Started up')}
                      >
                        MARK AS ENTERPRISE STARTED UP
                      </button>
                    ) : (
                      <button
                        disabled={!this.props.isEditable}
                        className="btn move-to-next-stage-btn"
                        onClick={this.onStatusChange.bind(this, 'Scaled up')}
                      >
                        MARK AS ENTERPRISE SCALED UP
                      </button>
                    )
                  ) : (
                    <button
                      disabled={!this.props.isEditable}
                      className="btn move-to-prev-stage-btn"
                      onClick={this.onStatusChange.bind(
                        this,
                        'Not Started',
                        true
                      )}
                    >
                      MOVE BACK TO ENTERPRISE SETUP/SCALE-UP STAGE
                    </button>
                  )
                ) : null}

                <Row className="enterprise-setup-questions">
                  <Col md={6} className="enterprise-setup-question">
                    <label className="control-label is-imp">
                      Enterprise State?
                    </label>
                    <div className="options">
                      <span>
                        <input
                          type="radio"
                          name="enterpriseState"
                          disabled
                          checked={
                            this.state.stages.enterpriseSetup
                              .enterpriseState === 'Start-up'
                              ? true
                              : false
                          }
                        />
                        Start-up
                      </span>
                      <span>
                        <input
                          type="radio"
                          name="enterpriseState"
                          disabled
                          checked={
                            this.state.stages.enterpriseSetup
                              .enterpriseState === 'Scale-up'
                              ? true
                              : false
                          }
                        />
                        Scale-up
                      </span>
                    </div>
                  </Col>

                  <Col md={6} className="enterprise-setup-question">
                    <label className="control-label is-imp">
                      Enterprise Registered?
                    </label>
                    <div className="options">
                      <span>
                        <input
                          type="radio"
                          name="enterpriseRegistered"
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'enterpriseRegistered',
                            'Yes'
                          )}
                          disabled={!this.props.isEditable}
                          checked={
                            this.state.stages.enterpriseSetup
                              .enterpriseRegistered === 'Yes'
                              ? true
                              : false
                          }
                        />
                        Yes
                      </span>
                      <span>
                        <input
                          type="radio"
                          name="enterpriseRegistered"
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'enterpriseRegistered',
                            'No'
                          )}
                          disabled={!this.props.isEditable}
                          checked={
                            this.state.stages.enterpriseSetup
                              .enterpriseRegistered === 'No'
                              ? true
                              : false
                          }
                        />
                        No
                      </span>
                    </div>
                  </Col>

                  {this.state.stages.enterpriseSetup.enterpriseRegistered ===
                    'Yes' ? (
                    <Col md={6} className="enterprise-setup-question">
                      <label className="control-label is-imp">
                        Entity type
                      </label>
                      <Select
                        size="large"
                        style={{ width: '100%' }}
                        value={this.state.stages.enterpriseSetup.entityType}
                        onChange={this.enterpriseSetupChange.bind(
                          this,
                          'entityType'
                        )}
                        disabled={!this.props.isEditable}
                      >
                        <Option value="" disabled>
                          Select Entity Type
                        </Option>
                        <Option value="Proprietorship">Proprietorship</Option>
                        <Option value="Private Limited">Private Limited</Option>
                        <Option value="Partnership">Partnership</Option>
                        <Option value="Others">Others</Option>
                      </Select>
                    </Col>
                  ) : null}

                  <Col md={12} className="enterprise-setup-question">
                    <label className="control-label is-imp">
                      Name of the Enterprise
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      onChange={this.enterpriseSetupChange.bind(
                        this,
                        'entityName'
                      )}
                      value={this.state.stages.enterpriseSetup.entityName}
                      onBlur={this.enterpriseSetupBlurChange.bind(
                        this,
                        'entityName'
                      )}
                      disabled={!this.props.isEditable}
                    />
                  </Col>

                  <Col md={12} className="enterprise-setup-question">
                    <label className="control-label is-imp">
                      Enterprise{' '}
                      {this.state.stages.enterpriseSetup.enterpriseState ===
                        'Scale-up'
                        ? 'Scaled up'
                        : 'Started up'}{' '}
                      {(this.state.stages.enterpriseSetup.createdOn !==
                        undefined &&
                        this.state.stages.enterpriseSetup.createdOn !== null &&
                        this.state.stages.enterpriseSetup.createdOn !== '') ||
                        this.state.stages.enterpriseSetup.creationYear ===
                        undefined ||
                        this.state.stages.enterpriseSetup.creationMonth ===
                        undefined ||
                        this.state.stages.enterpriseSetup.creationMonth ===
                        null ||
                        this.state.stages.enterpriseSetup.creationMonth === '' ||
                        this.state.stages.enterpriseSetup.creationYear === null ||
                        this.state.stages.enterpriseSetup.creationYear === ''
                        ? 'on'
                        : 'in'}
                    </label>
                    {(this.state.stages.enterpriseSetup.createdOn !==
                      undefined &&
                      this.state.stages.enterpriseSetup.createdOn !== null &&
                      this.state.stages.enterpriseSetup.createdOn !== '') ||
                      this.state.stages.enterpriseSetup.creationYear ===
                      undefined ||
                      this.state.stages.enterpriseSetup.creationMonth ===
                      undefined ||
                      this.state.stages.enterpriseSetup.creationMonth === null ||
                      this.state.stages.enterpriseSetup.creationMonth === '' ||
                      this.state.stages.enterpriseSetup.creationYear === null ||
                      this.state.stages.enterpriseSetup.creationYear === '' ? (
                      <input
                        type="date"
                        className="form-control"
                        id="enterprisesetup-date"
                        // onBlur={(e) => props.onUpdate(e.target.value)}
                        max={
                          this.state.projectDetails.toDate &&
                            moment(this.state.projectDetails.toDate).format(
                              'YYYY-MM-DD'
                            ) < moment().format('YYYY-MM-DD')
                            ? moment(this.state.projectDetails.toDate).format(
                              'YYYY-MM-DD'
                            )
                            : moment().format('YYYY-MM-DD')
                        }
                        defaultValue={
                          this.state.stages.enterpriseSetup.createdOn
                        }
                        value={this.state.stages.enterpriseSetup.createdOn}
                        onChange={this.changeDate.bind(this)}
                        // onBlur={this.enter}
                        onBlur={this.updateDate.bind(this)}
                        disabled={!this.props.isEditable}
                      />
                    ) : (
                      <div className="options">
                        <Select
                          disabled={true}
                          size="large"
                          style={{ width: '30%' }}
                          value={
                            this.state.stages.enterpriseSetup.creationMonth
                          }
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'creationMonth'
                          )}
                        >
                          <Option value="" disabled>
                            Select Creation Month
                          </Option>
                          {months.map((month, index) => {
                            return (
                              <Option key={index} value={month}>
                                {month}
                              </Option>
                            )
                          })}
                        </Select>
                        <Select
                          size="large"
                          disabled={true}
                          style={{ width: '30%' }}
                          value={this.state.stages.enterpriseSetup.creationYear}
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'creationYear'
                          )}
                        >
                          <Option value="" disabled>
                            Select Creation Year
                          </Option>
                          {years.map((year, index) => {
                            return (
                              <Option key={index} value={year}>
                                {year}
                              </Option>
                            )
                          })}
                        </Select>

                        <Button
                          disabled={!this.props.isEditable}
                          onClick={this.editDate}
                        >
                          Edit
                        </Button>
                      </div>
                    )}
                  </Col>

                  <Col md={12} className="enterprise-setup-question">
                    <label className="control-label is-imp">
                      Udyog Aadhar Certificate Received?
                    </label>
                    <div className="options">
                      <span>
                        <input
                          type="radio"
                          name="udyogAadharCertificateReceived"
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'udyogAadharCertificateReceived',
                            'Yes'
                          )}
                          checked={
                            this.state.stages.enterpriseSetup
                              .udyogAadharCertificateReceived === 'Yes'
                              ? true
                              : false
                          }
                          disabled={!this.props.isEditable}
                        />
                        Yes
                      </span>
                      <span>
                        <input
                          type="radio"
                          name="udyogAadharCertificateReceived"
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'udyogAadharCertificateReceived',
                            'No'
                          )}
                          checked={
                            this.state.stages.enterpriseSetup
                              .udyogAadharCertificateReceived === 'No'
                              ? true
                              : false
                          }
                          disabled={!this.props.isEditable}
                        />
                        No
                      </span>
                      {this.state.stages.enterpriseSetup
                        .udyogAadharCertificateReceived === 'Yes' ? (
                        <input
                          className="form-control"
                          type="file"
                          onChange={this.enterpriseSetupFileChange.bind(
                            this,
                            'udyogAadharCertificateFile'
                          )}
                          accept=".jpg,.png,.jpeg,.gif,.pdf"
                          disabled={!this.props.isEditable}
                        />
                      ) : null}
                      {this.state.stages.enterpriseSetup
                        .udyogAadharCertificateUrl ? (
                        <>
                          <a
                            className="image-url"
                            href={
                              this.state.stages.enterpriseSetup
                                .udyogAadharCertificateUrl
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Certificate
                          </a>
                          <i
                            className="fa fa-trash"
                            disabled={!this.props.isEditable}
                            title="Delete File"
                            onClick={this.removeSupportingDocument.bind(
                              this,
                              'udyogAadharCertificateUrl'
                            )}
                          ></i>
                        </>
                      ) : null}
                    </div>
                  </Col>

                  <Col md={12} className="enterprise-setup-question">
                    <label className="control-label is-imp">
                      GST Certificate Received?
                    </label>
                    <div className="options">
                      <span>
                        <input
                          type="radio"
                          name="gstCertificate"
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'gstCertificate',
                            'Yes'
                          )}
                          checked={
                            this.state.stages.enterpriseSetup.gstCertificate ===
                              'Yes'
                              ? true
                              : false
                          }
                          disabled={!this.props.isEditable}
                        />
                        Yes
                      </span>
                      <span>
                        <input
                          type="radio"
                          name="gstCertificate"
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'gstCertificate',
                            'No'
                          )}
                          checked={
                            this.state.stages.enterpriseSetup.gstCertificate ===
                              'No'
                              ? true
                              : false
                          }
                          disabled={!this.props.isEditable}
                        />
                        No
                      </span>
                      <span>
                        <input
                          type="radio"
                          name="gstCertificate"
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'gstCertificate',
                            'N/A'
                          )}
                          checked={
                            this.state.stages.enterpriseSetup.gstCertificate ===
                              'N/A'
                              ? true
                              : false
                          }
                          disabled={!this.props.isEditable}
                        />
                        N/A
                      </span>
                      {this.state.stages.enterpriseSetup.gstCertificate ===
                        'Yes' ? (
                        <input
                          className="form-control"
                          type="file"
                          onChange={this.enterpriseSetupFileChange.bind(
                            this,
                            'gstCertificateFile'
                          )}
                          accept=".jpg,.png,.jpeg,.gif,.pdf"
                          disabled={!this.props.isEditable}
                        />
                      ) : null}
                      {this.state.stages.enterpriseSetup.gstCertificateUrl ? (
                        <>
                          <a
                            className="image-url"
                            href={
                              this.state.stages.enterpriseSetup
                                .gstCertificateUrl
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Certificate
                          </a>
                          <i
                            className="fa fa-trash"
                            disabled={!this.props.isEditable}
                            title="Delete File"
                            onClick={this.removeSupportingDocument.bind(
                              this,
                              'gstCertificateUrl'
                            )}
                          ></i>
                        </>
                      ) : null}
                    </div>
                  </Col>

                  <Col md={12} className="enterprise-setup-question">
                    <label className="control-label is-imp">
                      Any other relevant licenses received?
                    </label>
                    <div className="options">
                      <span>
                        <input
                          type="radio"
                          name="otherLicenses"
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'otherLicenses',
                            'Yes'
                          )}
                          checked={
                            this.state.stages.enterpriseSetup.otherLicenses ===
                              'Yes'
                              ? true
                              : false
                          }
                          disabled={!this.props.isEditable}
                        />
                        Yes
                      </span>
                      <span>
                        <input
                          type="radio"
                          name="otherLicenses"
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'otherLicenses',
                            'No'
                          )}
                          checked={
                            this.state.stages.enterpriseSetup.otherLicenses ===
                              'No'
                              ? true
                              : false
                          }
                          disabled={!this.props.isEditable}
                        />
                        No
                      </span>
                      <span>
                        <input
                          type="radio"
                          name="otherLicenses"
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'otherLicenses',
                            'N/A'
                          )}
                          checked={
                            this.state.stages.enterpriseSetup.otherLicenses ===
                              'N/A'
                              ? true
                              : false
                          }
                          disabled={!this.props.isEditable}
                        />
                        N/A
                      </span>
                      {this.state.stages.enterpriseSetup.otherLicenses ===
                        'Yes' ? (
                        <input
                          className="form-control"
                          type="file"
                          onChange={this.enterpriseSetupFileChange.bind(
                            this,
                            'otherLicensesFile'
                          )}
                          accept=".jpg,.png,.jpeg,.gif,.pdf"
                          disabled={!this.props.isEditable}
                        />
                      ) : null}
                      {this.state.stages.enterpriseSetup.otherLicensesUrl ? (
                        <>
                          <a
                            className="image-url"
                            href={
                              this.state.stages.enterpriseSetup.otherLicensesUrl
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Certificate
                          </a>
                          <i
                            className="fa fa-trash"
                            disabled={!this.props.isEditable}
                            title="Delete File"
                            onClick={this.removeSupportingDocument.bind(
                              this,
                              'otherLicensesUrl'
                            )}
                          ></i>
                        </>
                      ) : null}
                    </div>
                  </Col>

                  <Col md={12} className="enterprise-setup-question">
                    <label className="control-label is-imp">
                      Certificate of shop and establishment act received?
                    </label>
                    <div className="options">
                      <span>
                        <input
                          type="radio"
                          name="certificateOfShopAndEstablishmentAct"
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'certificateOfShopAndEstablishmentAct',
                            'Yes'
                          )}
                          checked={
                            this.state.stages.enterpriseSetup
                              .certificateOfShopAndEstablishmentAct === 'Yes'
                              ? true
                              : false
                          }
                          disabled={!this.props.isEditable}
                        />
                        Yes
                      </span>
                      <span>
                        <input
                          type="radio"
                          name="certificateOfShopAndEstablishmentAct"
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'certificateOfShopAndEstablishmentAct',
                            'No'
                          )}
                          checked={
                            this.state.stages.enterpriseSetup
                              .certificateOfShopAndEstablishmentAct === 'No'
                              ? true
                              : false
                          }
                          disabled={!this.props.isEditable}
                        />
                        No
                      </span>
                      <span>
                        <input
                          type="radio"
                          name="certificateOfShopAndEstablishmentAct"
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'certificateOfShopAndEstablishmentAct',
                            'N/A'
                          )}
                          checked={
                            this.state.stages.enterpriseSetup
                              .certificateOfShopAndEstablishmentAct === 'N/A'
                              ? true
                              : false
                          }
                          disabled={!this.props.isEditable}
                        />
                        N/A
                      </span>
                      {this.state.stages.enterpriseSetup
                        .certificateOfShopAndEstablishmentAct === 'Yes' ? (
                        <input
                          className="form-control"
                          type="file"
                          onChange={this.enterpriseSetupFileChange.bind(
                            this,
                            'certificateOfShopAndEstablishmentActFile'
                          )}
                          accept=".jpg,.png,.jpeg,.gif,.pdf"
                          disabled={!this.props.isEditable}
                        />
                      ) : null}
                      {this.state.stages.enterpriseSetup
                        .certificateOfShopAndEstablishmentActUrl ? (
                        <>
                          <a
                            className="image-url"
                            href={
                              this.state.stages.enterpriseSetup
                                .certificateOfShopAndEstablishmentActUrl
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Certificate
                          </a>
                          <i
                            className="fa fa-trash"
                            disabled={!this.props.isEditable}
                            title="Delete File"
                            onClick={this.removeSupportingDocument.bind(
                              this,
                              'certificateOfShopAndEstablishmentActUrl'
                            )}
                          ></i>
                        </>
                      ) : null}
                    </div>
                  </Col>

                  <Col md={12} className="enterprise-setup-question">
                    <label className="control-label is-imp">
                      Digital Payment (BHIM/UPI)
                    </label>
                    <div className="options">
                      <span>
                        <input
                          type="radio"
                          name="digitalPayment"
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'digitalPayment',
                            'Yes'
                          )}
                          checked={
                            this.state.stages.enterpriseSetup.digitalPayment ===
                              'Yes'
                              ? true
                              : false
                          }
                          disabled={!this.props.isEditable}
                        />
                        Yes
                      </span>
                      <span>
                        <input
                          type="radio"
                          name="digitalPayment"
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'digitalPayment',
                            'No'
                          )}
                          checked={
                            this.state.stages.enterpriseSetup.digitalPayment ===
                              'No'
                              ? true
                              : false
                          }
                          disabled={!this.props.isEditable}
                        />
                        No
                      </span>
                    </div>
                  </Col>

                  <Col md={12} className="enterprise-setup-question">
                    <label className="control-label is-imp">
                      Insurance of enterprise/promoted
                    </label>
                    <div className="options">
                      <span>
                        <input
                          type="radio"
                          name="hasInsurance"
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'hasInsurance',
                            'Yes'
                          )}
                          checked={
                            this.state.stages.enterpriseSetup.hasInsurance ===
                              'Yes'
                              ? true
                              : false
                          }
                          disabled={!this.props.isEditable}
                        />
                        Yes
                      </span>
                      <span>
                        <input
                          type="radio"
                          name="hasInsurance"
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'hasInsurance',
                            'No'
                          )}
                          checked={
                            this.state.stages.enterpriseSetup.hasInsurance ===
                              'No'
                              ? true
                              : false
                          }
                          disabled={!this.props.isEditable}
                        />
                        No
                      </span>
                    </div>
                  </Col>

                  <Col md={12} className="enterprise-setup-question">
                    <label className="control-label is-imp">
                      Registration on GEMS portal
                    </label>
                    <div className="options">
                      <span>
                        <input
                          type="radio"
                          name="gemsPortalRegistered"
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'gemsPortalRegistered',
                            'Yes'
                          )}
                          checked={
                            this.state.stages.enterpriseSetup
                              .gemsPortalRegistered === 'Yes'
                              ? true
                              : false
                          }
                          disabled={!this.props.isEditable}
                        />
                        Yes
                      </span>
                      <span>
                        <input
                          type="radio"
                          name="gemsPortalRegistered"
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'gemsPortalRegistered',
                            'No'
                          )}
                          checked={
                            this.state.stages.enterpriseSetup
                              .gemsPortalRegistered === 'No'
                              ? true
                              : false
                          }
                          disabled={!this.props.isEditable}
                        />
                        No
                      </span>
                    </div>
                  </Col>

                  <Col md={12} className="enterprise-setup-question">
                    <label className="control-label is-imp">
                      Complete Address of the shop/mill/factory
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      onChange={this.enterpriseSetupChange.bind(
                        this,
                        'officeShopFactoryAddress'
                      )}
                      value={
                        this.state.stages.enterpriseSetup
                          .officeShopFactoryAddress
                      }
                      placeholder="Enter Complete Address"
                      onBlur={this.enterpriseSetupBlurChange.bind(
                        this,
                        'officeShopFactoryAddress'
                      )}
                      disabled={!this.props.isEditable}
                    />
                    <div className="options">
                      <input
                        className="form-control mt5"
                        type="text"
                        onChange={this.enterpriseSetupChange.bind(
                          this,
                          'officeShopFactoryAddressUrlLat'
                        )}
                        value={
                          this.state.stages.enterpriseSetup
                            .officeShopFactoryAddressUrl.latitude
                        }
                        placeholder="Latitude"
                        onBlur={this.enterpriseSetupBlurChange.bind(
                          this,
                          'officeShopFactoryAddressUrl'
                        )}
                        disabled={!this.props.isEditable}
                      />
                      <input
                        className="form-control mt5"
                        type="text"
                        onChange={this.enterpriseSetupChange.bind(
                          this,
                          'officeShopFactoryAddressUrlLong'
                        )}
                        value={
                          this.state.stages.enterpriseSetup
                            .officeShopFactoryAddressUrl.longitude
                        }
                        placeholder="Longitude"
                        onBlur={this.enterpriseSetupBlurChange.bind(
                          this,
                          'officeShopFactoryAddressUrl'
                        )}
                        disabled={!this.props.isEditable}
                      />
                      {this.state.stages.enterpriseSetup
                        .officeShopFactoryAddressUrl.latitude &&
                        this.state.stages.enterpriseSetup
                          .officeShopFactoryAddressUrl.longitude &&
                        this.state.stages.enterpriseSetup
                          .officeShopFactoryAddressUrl.url ? (
                        <a
                          className="google-map-url"
                          href={
                            this.state.stages.enterpriseSetup
                              .officeShopFactoryAddressUrl.url
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Google Map Url
                        </a>
                      ) : null}
                    </div>
                  </Col>

                  <Col md={12} className="enterprise-setup-question">
                    <label className="control-label is-imp">
                      Bank Account Details
                    </label>
                    <Row className="align-items-center">
                      <Col md={4}>
                        <Select
                          showSearch
                          style={{ width: '100%' }}
                          value={this.state.stages.enterpriseSetup.bankName}
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'bankName'
                          )}
                          disabled={!this.props.isEditable}
                          filterOption={(input, option) =>
                            this.searchFilter(input, option)
                          }
                        >
                          <Option value="" disabled>
                            Select Bank
                          </Option>
                          {this.state.allBanks.map((bank, bankIndex) => {
                            return (
                              <Option key={bankIndex} value={bank}>
                                {bank}
                              </Option>
                            )
                          })}
                        </Select>
                      </Col>
                      <Col md={4}>
                        <input
                          className="form-control"
                          type="text"
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'bankAccountNum'
                          )}
                          disabled={!this.props.isEditable}
                          onBlur={this.enterpriseSetupBlurChange.bind(
                            this,
                            'bankAccountNum'
                          )}
                          value={
                            this.state.stages.enterpriseSetup.bankAccountNum
                          }
                          placeholder="Bank Account Number"
                        />
                      </Col>
                      <Col md={4}>
                        <Input
                          placeholder="Bank IFSC"
                          value={this.state.stages.enterpriseSetup.bankIFSC}
                          onChange={this.enterpriseSetupChange.bind(
                            this,
                            'bankIFSC'
                          )}
                          disabled={!this.props.isEditable}
                          addonAfter={this.showIFSCIcon()}
                          onBlur={this.enterpriseSetupBlurChange.bind(
                            this,
                            'bankIFSC'
                          )}
                        />
                      </Col>
                    </Row>
                  </Col>

                  <Col md={12} className="enterprise-setup-question">
                    <label className="control-label is-imp">
                      KYC Document (Atleast One)
                    </label>
                    <div className="d-flex align-items-center">
                      <input
                        type="checkbox"
                        id="pan-number-checkbox"
                        checked={
                          this.state.stages.enterpriseSetup.kycDocuments.pan
                        }
                      />
                      <label
                        style={{ margin: 5, minWidth: 100 }}
                        htmlFor="pan-number-checkbox"
                      >
                        PAN
                      </label>
                      <input
                        style={{ width: 200 }}
                        className="form-control"
                        type="text"
                        onChange={this.enterpriseSetupChange.bind(
                          this,
                          'kycPAN'
                        )}
                        disabled={!this.props.isEditable}
                        onBlur={this.enterpriseSetupBlurChange.bind(
                          this,
                          'kycPAN'
                        )}
                        value={
                          this.state.stages.enterpriseSetup.kycDocuments.pan
                        }
                        placeholder="PAN"
                      />
                    </div>
                    <div className="d-flex align-items-center mt5">
                      <input
                        type="checkbox"
                        id="udyog-aadhar-number-checkbox"
                        checked={
                          this.state.stages.enterpriseSetup.kycDocuments
                            .udyogAadhar
                        }
                      />
                      <label
                        style={{ margin: 5, minWidth: 100 }}
                        htmlFor="udyog-aadhar-number-checkbox"
                      >
                        Udyog Aadhar
                      </label>
                      <input
                        style={{ width: 200 }}
                        className="form-control"
                        type="text"
                        onChange={this.enterpriseSetupChange.bind(
                          this,
                          'kycUdyogAadhar'
                        )}
                        disabled={!this.props.isEditable}
                        onBlur={this.enterpriseSetupBlurChange.bind(
                          this,
                          'kycUdyogAadhar'
                        )}
                        value={
                          this.state.stages.enterpriseSetup.kycDocuments
                            .udyogAadhar
                        }
                        placeholder="Udyog Aadhar"
                      />
                    </div>
                    {this.state.stages.enterpriseSetup.kycDocuments &&
                      this.state.stages.enterpriseSetup.kycDocuments
                        .udyogAadhar &&
                      this.state.stages.enterpriseSetup.kycDocuments.udyogAadhar
                        .length &&
                      this.state.stages.enterpriseSetup.kycDocuments.udyogAadhar
                        .length !== 12 &&
                      this.state.stages.enterpriseSetup.kycDocuments.udyogAadhar
                        .length !== 19 ? (
                      <Col md={12}>
                        <span style={{ color: 'red', fontWeight: '800' }}>
                          Udyam Registration should have a 19-digit format.
                        </span>
                      </Col>
                    ) : null}
                    <div className="d-flex align-items-center mt5">
                      <input
                        type="checkbox"
                        id="aadhar-number-checkbox"
                        checked={
                          this.state.stages.enterpriseSetup.kycDocuments.aadhar
                            .length === 12 && !this.state.aadharError
                        }
                      />
                      <label
                        style={{ margin: 5, minWidth: 100 }}
                        htmlFor="aadhar-number-checkbox"
                      >
                        Aadhar Number
                      </label>
                      <input
                        style={{ width: 200 }}
                        className="form-control"
                        type="text"
                        onChange={this.enterpriseSetupChange.bind(
                          this,
                          'kycAadhar'
                        )}
                        disabled={!this.props.isEditable}
                        onBlur={this.enterpriseSetupBlurChange.bind(
                          this,
                          'kycAadhar'
                        )}
                        value={
                          this.state.stages.enterpriseSetup.kycDocuments.aadhar
                        }
                        placeholder="Aadhar Number"
                      />
                    </div>{' '}
                    {this.state.aadharError ? (
                      <span style={{ color: 'red' }}>
                        Aadhar field should be a 12-digit number
                      </span>
                    ) : null}
                  </Col>

                  <Col md={12} className="enterprise-setup-question">
                    <label className="control-label is-imp">
                      Support received from Mission Swavalamban
                    </label>
                    <Select
                      size="large"
                      mode="multiple"
                      showSearch
                      style={{ width: '100%' }}
                      value={this.state.stages.enterpriseSetup.supportReceived}
                      onChange={this.enterpriseSetupChange.bind(
                        this,
                        'supportReceived'
                      )}
                      disabled={!this.props.isEditable}
                      filterOption={(input, option) =>
                        this.searchFilter(input, option)
                      }
                    >
                      <Option value="Counselling and Guidance">
                        Counselling and Guidance
                      </Option>
                      <Option value="Securing necessary licenses">
                        Securing necessary licenses
                      </Option>
                      <Option value="Location Selection">
                        Location Selection
                      </Option>
                      <Option value="Skill/Enterprise Training Connect">
                        Skill/Enterprise Training Connect
                      </Option>
                      <Option value="Business Proposal Support">
                        Business Proposal Support
                      </Option>
                      <Option value="Shop Banner and other design support">
                        Shop Banner and other design support
                      </Option>
                      <Option value="Machinery/Material Procurement">
                        Machinery/Material Procurement
                      </Option>
                      <Option value="Credit Linkage">Credit Linkage</Option>
                      <Option value="Business Ideation">
                        Business Ideation
                      </Option>
                      <Option value="Business Connect/Market Linkage">
                        Business Connect/Market Linkage
                      </Option>
                      <Option value="Business Plan Preparation">
                        Business Plan Preparation
                      </Option>
                      <Option value="Entrepreneurship/Financial Training or Training Connect">
                        Entrepreneurship/Financial Training or Training Connect
                      </Option>
                      <Option value="Incentive/Subsidy-related support">
                        Incentive/Subsidy-related support
                      </Option>
                      <Option value="Digital Enablement (Location tagging, Product Listing, etc.)">
                        Digital Enablement (Location tagging, Product Listing,
                        etc.)
                      </Option>
                      <Option value="Other Connections and Networking support">
                        Other Connections and Networking support
                      </Option>
                    </Select>
                  </Col>

                  <Col md={12} className="enterprise-setup-question">
                    <label className="control-label is-imp">
                      Photos of entrepreneur/store front/banner etc.
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      multiple
                      onChange={this.enterpriseSetupFileChange.bind(
                        this,
                        'otherImageFiles'
                      )}
                      disabled={!this.props.isEditable}
                      accept=".jpg,.png,.jpeg,.gif"
                    />
                    {this.state.stages.enterpriseSetup.otherImageUrls ? (
                      <span>
                        {this.state.stages.enterpriseSetup.otherImageUrls.map(
                          (url, urlIndex) => {
                            return (
                              <div className="file-container" key={urlIndex}>
                                <a
                                  download
                                  className="image-url"
                                  key={urlIndex}
                                  href={url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {urlIndex
                                    ? ', Photo' + (urlIndex + 1)
                                    : 'Photo'}
                                </a>
                                <i
                                  className="fa fa-times"
                                  disabled={!this.props.isEditable}
                                  title="Delete File"
                                  onClick={this.deleteFileFromEnterpriseSetup.bind(
                                    this,
                                    urlIndex
                                  )}
                                ></i>
                              </div>
                            )
                          }
                        )}
                      </span>
                    ) : null}
                  </Col>
                  <Col md={12}>
                    <label className="control-label is-imp">
                      Google My Business URL
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      onChange={this.enterpriseSetupChange.bind(
                        this,
                        'googleBusinessLocationUrl'
                      )}
                      disabled={!this.props.isEditable}
                      value={
                        this.state.stages.enterpriseSetup
                          .googleBusinessLocationUrl
                      }
                      placeholder="Enter Google My Business URL (in expanded Google Map URL form)"
                    />
                  </Col>
                  <Col md={12}>
                    <span style={{ color: 'red', fontWeight: '800' }}>
                      {this.state.locError}
                    </span>
                  </Col>

                  <Col md={12}>
                    <label className="control-label is-imp">
                      Candidate recognizes support of the following
                      individual(s)
                    </label>
                    <small style={{ color: 'var(--themeColor)' }}>
                      <span>
                        <b style={{ fontSize: '12px' }}>
                          Use Format- Person 1 name, Organization 1 Name/Person
                          2 Name, Organization 2 Name
                        </b>
                      </span>
                    </small>
                    <input
                      className="form-control"
                      type="text"
                      onBlur={this.enterpriseSetupBlurChange.bind(
                        this,
                        'recognizedSupport'
                      )}
                      onChange={this.enterpriseSetupChange.bind(
                        this,
                        'recognizedSupport'
                      )}
                      disabled={!this.props.isEditable}
                      value={
                        this.state.stages.enterpriseSetup.recognizedSupport
                      }
                      placeholder="Use Format- Person 1 name, Organization 1 Name/Person 2 Name, Organization 2 Name"
                    />
                  </Col>
                  <Col md={12}>
                    <span style={{ color: 'red', fontWeight: '800' }}>
                      {this.state.supportError}
                    </span>
                  </Col>
                  <Col md={12} className="enterprise-setup-question">
                    <Row>
                      {' '}
                      <Col md={6}>
                        <label
                          className="control-label is-imp"
                          style={{ marginLeft: '-15px' }}
                        >
                          Describe the story of the Entrepreneur
                        </label>
                      </Col>
                      <Col md={6}>
                        <div style={{ marginTop: '15px' }}>
                          {' '}
                          {this.state.stages.enterpriseSetup.entrepreneurStory.trim() !==
                            '' &&
                            (this.state.stages.enterpriseSetup
                              ?.entrepreneurStoryVerification?.status ===
                              undefined ||
                              this.state.stages.enterpriseSetup
                                ?.entrepreneurStoryVerification?.status ===
                              'Unverified') &&
                            JSON.parse(readCookie('userData')).userType.name ===
                            'Project Management Unit' ? (
                            <button
                              /*style={{margin:"10px auto"}}*/ onClick={this.verifyStory.bind(
                              this
                            )}
                              disabled={!this.props.isEditable}
                              className="btn btn-sm btn-success"
                            >
                              Verify Story
                            </button>
                          ) : null}
                          {this.state.stages.enterpriseSetup
                            ?.entrepreneurStoryVerification?.status ===
                            'Verified' ? (
                            <span style={{ fontSize: '11px' }}>
                              Verified By{' '}
                              <span
                                style={{
                                  fontSize: '11px',
                                  color: 'var(--themeColor)',
                                  fontWeight: 'bold',
                                }}
                              >
                                {
                                  this.state.stages.enterpriseSetup
                                    ?.entrepreneurStoryVerification?.verifiedBy
                                    ?.fullName
                                }
                              </span>{' '}
                              on{' '}
                              <span
                                style={{
                                  fontSize: '11px',
                                  color: 'var(--themeColor)',
                                  fontWeight: 'bold',
                                }}
                              >
                                {moment(
                                  this.state.stages.enterpriseSetup
                                    ?.entrepreneurStoryVerification?.verifiedAt
                                ).format('DD/MM/YYYY hh:mm A')}
                              </span>
                            </span>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <small style={{ color: 'var(--themeColor)' }}>
                      <span>
                        <b style={{ fontSize: '12px' }}>
                          An ideal story should have the following components:
                        </b>
                      </span>
                      <br />
                      1. Introduction to the candidate (Name, ​Age, City,
                      Educational and Economic Background)
                      <br />
                      2. How and when did he decide to start-up and what was his
                      business idea?
                      <br />
                      3. What were his challenges and struggles and how did our
                      Mission resolve those? (Enlist all the various ways in
                      which the candidate was helped)
                      <br />
                      4. The area and the market where the business operated.{' '}
                      <br />
                      5. Self+Loan Investment with which the business started
                      and how was it invested
                      <br />
                      6. Current (and future) earning and growth plans
                      <br />
                      7. Any visible change in social status, confidence,
                      family's/neighbour's/others' behaviors towards him/her
                      <br />
                    </small>
                    <textarea
                      className="form-control"
                      onChange={this.enterpriseSetupChange.bind(
                        this,
                        'entrepreneurStory'
                      )}
                      disabled={!this.props.isEditable}
                      value={
                        this.state.stages.enterpriseSetup.entrepreneurStory
                      }
                      onBlur={this.enterpriseSetupBlurChange.bind(
                        this,
                        'entrepreneurStory'
                      )}
                    />
                  </Col>
                </Row>
              </div>
            ) : null}

            {['sidbi'].includes(
              JSON.parse(readCookie('userData')).type
            ) ? null : this.state.currentActiveStage ===
              'enterpriseSustainability' ? (
              <div className="selected-stage">
                {JSON.parse(readCookie('userData')).type ===
                  'partners' ? null : (
                  <div className="d-flex align-items-end justify-content-between">
                    <label className="control-label is-imp m0">
                      Add a new check-in
                    </label>
                    <button
                      className="btn add-checkin-btn"
                      onClick={this.addNewCheckIn}
                      disabled={!this.props.isEditable}
                    >
                      Add New Assessment
                    </button>
                  </div>
                )}
                <Row className="enterprise-sustainability-container mt10">
                  {this.state.stages.enterpriseSustainability.checkIns ? (
                    <ToolkitProvider
                      keyField="index"
                      data={this.state.stages.enterpriseSustainability.checkIns}
                      columns={
                        this.state.enterpriseSustainabilityCheckInColumns
                      }
                    >
                      {props => (
                        <div>
                          <BootstrapTable
                            id="enterprise-sustainability-checkin-table"
                            {...props.baseProps}
                            cellEdit={
                              enterpriseSustainabilityCheckInTableCellEdit
                            }
                            ref={table => {
                              this.enterpriseSustainabilityCheckInTable = table
                            }}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  ) : null}
                </Row>
              </div>
            ) : null}
          </div>
        ) : null}

        {this.state.viewScheme ? (
          <ViewSchemeModal
            viewScheme={this.state.viewScheme}
            hideViewScheme={this.hideViewScheme}
          />
        ) : null}
        {/* <LoanSchedule /> */}
      </Col>


    )
  }
}
